/* eslint-disable */
import { registerUser, loginUser, createOrder as apiCreateOrder, getSellerOrders, getBuyerOrders, getOrderById, createPaymentOrder, verifyPayment, confirmDelivery, raiseDispute, dispatchOrder, sendOTP, verifyOTP, sendRegisterOTP, verifyRegisterOTP, clearToken, getIntegrationKey, generateIntegrationKey } from './api';
import { useState, useEffect } from "react";
import LOGO_SRC from "./escarapay-logo.jpg";

// ── Inject Google Fonts once into <head> (avoids flash on re-render) ──
(function injectFonts() {
  if (document.getElementById("escara-gfonts")) return;
  const pc1 = document.createElement("link");
  pc1.rel = "preconnect";
  pc1.href = "https://fonts.googleapis.com";
  document.head.appendChild(pc1);
  const pc2 = document.createElement("link");
  pc2.rel = "preconnect";
  pc2.href = "https://fonts.gstatic.com";
  pc2.crossOrigin = "anonymous";
  document.head.appendChild(pc2);
  const link = document.createElement("link");
  link.id = "escara-gfonts";
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;600;700;800&display=swap";
  document.head.appendChild(link);
})();

const BACKEND_URL = "https://escarapay-backend.onrender.com";

// ── SEO Meta Tags updater ──
const updateMeta = ({ title, description, url, image }) => {
  document.title = title || "EscaraPay | India's Trusted Payment Protection Platform";
  const setMeta = (name, content, prop=false) => {
    let el = prop
      ? document.querySelector(`meta[property="${name}"]`)
      : document.querySelector(`meta[name="${name}"]`);
    if (!el) { el = document.createElement("meta"); prop ? el.setAttribute("property", name) : el.setAttribute("name", name); document.head.appendChild(el); }
    el.setAttribute("content", content);
  };
  if (description) {
    setMeta("description", description);
    setMeta("og:description", description, true);
    setMeta("twitter:description", description);
  }
  if (title) { setMeta("og:title", title, true); setMeta("twitter:title", title); }
  if (url) {
    setMeta("og:url", url, true);
    // ── Dynamic Canonical — fixes GSC "Alternate page with proper canonical tag" ──
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }
  if (image) { setMeta("og:image", image, true); setMeta("twitter:image", image); }
  setMeta("og:type", "website", true);
  setMeta("twitter:card", "summary_large_image");
};

// ── Blog system — fetched from public/blogs/ ──
// To add new blog: create public/blogs/your-slug.json + update public/blogs/registry.json
// No App.js changes needed!
const BLOG_CACHE = {}; // runtime cache

const fetchRegistry = async () => {
  if (BLOG_CACHE._registry) return BLOG_CACHE._registry;
  try {
    const r = await fetch("/blogs/registry.json");
    const data = await r.json();
    BLOG_CACHE._registry = data;
    return data;
  } catch { return []; }
};

const fetchBlogPost = async (slug) => {
  if (BLOG_CACHE[slug]) return BLOG_CACHE[slug];
  try {
    const r = await fetch(`/blogs/${slug}.json`);
    if (!r.ok) return null;
    const data = await r.json();
    BLOG_CACHE[slug] = data;
    return data;
  } catch { return null; }
};

// Language translations

const T = {
  en: {
    tagline: "India's Trusted Payment Protection Platform",
    hero1: "WhatsApp Deal Ka",
    hero2: "Safest Way",
    heroDesc: "Seller's RTO loss eliminated. Buyer's fraud fear eliminated. Minimum ₹200 token for 100% protection.",
    sellerBtn: "Seller — Start Free",
    buyerBtn: "Buyer — Safe Order",
    howWorks: "How Does It Work?",
    sellerView: "Seller View",
    buyerView: "Buyer View",
    myOrders: "My Orders",
    payViaLink: "Pay via Link",
    createDeal: "Create Deal",
    help: "Help",
    dashboard: "Dashboard",
    allOrders: "All Orders",
    analytics: "Analytics",
    payments: "Payments",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    register: "Register",
    newOrder: "+ New Order Link",
    noOrders: "No orders yet!",
    loading: "Loading...",
  },
  hi: {
    tagline: "भारत का भरोसेमंद पेमेंट प्रोटेक्शन प्लेटफॉर्म",
    hero1: "व्हाट्सऐप डील का",
    hero2: "सबसे सुरक्षित तरीका",
    heroDesc: "सेलर का RTO नुकसान खत्म। बायर का फ्रॉड का डर खत्म। न्यूनतम ₹200 टोकन से 100% सुरक्षा।",
    sellerBtn: "सेलर — फ्री शुरू करें",
    buyerBtn: "बायर — सेफ ऑर्डर",
    howWorks: "यह कैसे काम करता है?",
    sellerView: "सेलर व्यू",
    buyerView: "बायर व्यू",
    myOrders: "मेरे ऑर्डर",
    payViaLink: "लिंक से पेमेंट",
    createDeal: "डील बनाएं",
    help: "मदद",
    dashboard: "डैशबोर्ड",
    allOrders: "सभी ऑर्डर",
    analytics: "एनालिटिक्स",
    payments: "पेमेंट",
    settings: "सेटिंग",
    logout: "लॉगआउट",
    login: "लॉगिन",
    register: "रजिस्टर",
    newOrder: "+ नया ऑर्डर लिंक",
    noOrders: "अभी कोई ऑर्डर नहीं!",
    loading: "लोड हो रहा है...",
  },
  hl: {
    tagline: "India Ka Trusted Payment Protection Platform",
    hero1: "WhatsApp Deal Ka",
    hero2: "Sabse Safe Tarika",
    heroDesc: "Seller ka RTO loss khatam. Buyer ka fraud ka darr khatam. Minimum ₹200 token se dono ko 100% protection.",
    sellerBtn: "Seller — Start Free",
    buyerBtn: "Buyer — Safe Order Do",
    howWorks: "Kaise Kaam Karta Hai?",
    sellerView: "Seller View",
    buyerView: "Buyer View",
    myOrders: "Mere Orders",
    payViaLink: "Pay via Link",
    createDeal: "Create Deal",
    help: "Help",
    dashboard: "Dashboard",
    allOrders: "Saare Orders",
    analytics: "Analytics",
    payments: "Payments",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    register: "Register",
    newOrder: "+ Naya Order Link",
    noOrders: "No orders yet!",
    loading: "Load ho raha hai...",
  },
};

function getStyle(dark) {
  return `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  :root {
    --bg:      ${dark ? "#0B0E14" : "#F8FAFC"};
    --surface: ${dark ? "#131620" : "#FFFFFF"};
    --sf2:     ${dark ? "#1C212D" : "#EBF4FA"};
    --border:  ${dark ? "rgba(255,255,255,0.08)" : "rgba(36,161,226,0.15)"};
    --gold:    #24A1E2;
    --gold2:   ${dark ? "#4BB3E9" : "#1A84C4"};
    --green:   ${dark ? "#10B981" : "#059669"};
    --red:     ${dark ? "#EF4444" : "#DC2626"};
    --blue:    ${dark ? "#38BDF8" : "#0284C7"};
    --text:    ${dark ? "#F1F5F9" : "#1D1C59"};
    --muted:   ${dark ? "#94A3B8" : "#64748B"};
    --accent:  ${dark ? "#8B5CF6" : "#4A1C81"};
  }
  body{background:var(--bg);color:var(--text);font-family:'Inter',sans-serif;font-size:15px;line-height:1.6;}
  .syne{font-family:'Outfit',sans-serif;}
  ::-webkit-scrollbar{width:4px;}
  ::-webkit-scrollbar-track{background:var(--bg);}
  ::-webkit-scrollbar-thumb{background:var(--gold);border-radius:2px;}

  /* ── Keyframes ── */
  @keyframes fadeUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
  @keyframes fadeIn{from{opacity:0}to{opacity:1}}
  @keyframes slideLeft{from{opacity:0;transform:translateX(-20px)}to{opacity:1;transform:translateX(0)}}
  @keyframes slideRight{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:translateX(0)}}
  @keyframes shimmer{0%{background-position:-300% center}100%{background-position:300% center}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
  @keyframes pulseCyan{0%,100%{box-shadow:0 0 0 0 rgba(36,161,226,.45)}50%{box-shadow:0 0 0 16px rgba(36,161,226,0)}}
  @keyframes glowCyan{0%,100%{box-shadow:0 4px 20px rgba(36,161,226,.25)}50%{box-shadow:0 8px 40px rgba(36,161,226,.5)}}
  @keyframes breathe{0%,100%{transform:scale(1)}50%{transform:scale(1.03)}}
  @keyframes borderGlow{0%,100%{border-color:rgba(36,161,226,.2)}50%{border-color:rgba(36,161,226,.6)}}
  @keyframes dotPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(.85)}}
  @keyframes typewriter{from{width:0}to{width:100%}}
  @keyframes blinkCursor{0%,100%{border-color:var(--gold)}50%{border-color:transparent}}
  @keyframes gradientShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
  @keyframes slideUpFade{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
  @keyframes scaleIn{from{opacity:0;transform:scale(.92)}to{opacity:1;transform:scale(1)}}
  @keyframes glowPulse{0%,100%{opacity:.6;transform:scale(1)}50%{opacity:1;transform:scale(1.15)}}
  @keyframes chipFadeIn{from{opacity:0;transform:translateY(10px) scale(.95)}to{opacity:1;transform:translateY(0) scale(1)}}

  /* ── Utility animation classes ── */
  .fu {animation:fadeUp .6s cubic-bezier(.22,.68,0,1.2) forwards}
  .fu2{animation:fadeUp .6s .14s cubic-bezier(.22,.68,0,1.2) both}
  .fu3{animation:fadeUp .6s .28s cubic-bezier(.22,.68,0,1.2) both}
  .fu4{animation:fadeUp .6s .42s cubic-bezier(.22,.68,0,1.2) both}
  .float{animation:float 3.5s ease-in-out infinite}
  .breathe{animation:breathe 4s ease-in-out infinite}

  /* ── Buttons ── */
  .btn-gold{
    background:linear-gradient(135deg,var(--gold),var(--gold2));
    color:#fff;border:none;padding:11px 26px;border-radius:10px;
    font-family:'Outfit',sans-serif;font-weight:700;font-size:14px;
    cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);white-space:nowrap;
    letter-spacing:.3px;position:relative;overflow:hidden;
  }
  .btn-gold::after{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.15),transparent);opacity:0;transition:opacity .2s;}
  .btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(36,161,226,.4);}
  .btn-gold:hover::after{opacity:1;}
  .btn-gold:active{transform:translateY(0);box-shadow:0 4px 12px rgba(36,161,226,.3);}
  .btn-gold.pulse{animation:pulseCyan 2.2s infinite;}

  .btn-green{background:linear-gradient(135deg,#10B981,#059669);color:#fff;border:none;padding:11px 26px;border-radius:10px;font-family:'Outfit',sans-serif;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;white-space:nowrap;}
  .btn-green:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(16,185,129,.35);}
  .btn-red{background:linear-gradient(135deg,#EF4444,#DC2626);color:#fff;border:none;padding:11px 26px;border-radius:10px;font-family:'Outfit',sans-serif;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;white-space:nowrap;}
  .btn-red:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(239,68,68,.3);}
  .btn-outline{
    background:transparent;color:var(--gold);border:1.5px solid var(--gold);
    padding:10px 26px;border-radius:10px;font-family:'Outfit',sans-serif;
    font-weight:600;font-size:14px;cursor:pointer;transition:all .25s;white-space:nowrap;
  }
  .btn-outline:hover{background:rgba(36,161,226,.1);transform:translateY(-2px);box-shadow:0 6px 20px rgba(36,161,226,.2);}
  .btn-ghost{
    background:var(--sf2);color:var(--text);border:1px solid var(--border);
    padding:9px 18px;border-radius:8px;font-family:'Inter',sans-serif;
    font-weight:500;font-size:13px;cursor:pointer;transition:all .2s;white-space:nowrap;
  }
  .btn-ghost:hover{border-color:var(--gold);color:var(--gold);background:rgba(36,161,226,.06);}
  .btn-whatsapp{background:linear-gradient(135deg,#25D366,#128C7E);color:#fff;border:none;padding:11px 20px;border-radius:10px;font-family:'Outfit',sans-serif;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;display:flex;align-items:center;gap:7px;white-space:nowrap;}
  .btn-whatsapp:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(37,211,102,.35);}

  /* ── Cards ── */
  .card{
    background:var(--surface);border:1px solid var(--border);
    border-radius:16px;padding:22px;
    transition:border-color .3s,box-shadow .3s,transform .25s;
  }
  .card:hover{border-color:rgba(36,161,226,.35);box-shadow:0 8px 32px rgba(36,161,226,.08);}

  /* ── Inputs ── */
  .input{width:100%;background:var(--sf2);border:1.5px solid var(--border);color:var(--text);padding:11px 14px;border-radius:10px;font-family:'Inter',sans-serif;font-size:14px;outline:none;transition:all .2s;}
  .input:focus{border-color:var(--gold);box-shadow:0 0 0 3px rgba(36,161,226,.12);}
  .input::placeholder{color:var(--muted);}
  .select{width:100%;background:var(--sf2);border:1.5px solid var(--border);color:var(--text);padding:11px 14px;border-radius:10px;font-family:'Inter',sans-serif;font-size:14px;outline:none;cursor:pointer;transition:border-color .2s;}
  .select:focus{border-color:var(--gold);}
  .label{display:block;font-size:12px;color:var(--muted);margin-bottom:5px;font-weight:500;letter-spacing:.3px;}

  /* ── Badges ── */
  .badge{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:600;font-family:'Inter',sans-serif;}
  .bg{background:rgba(16,185,129,.15);color:var(--green);}
  .bo{background:rgba(36,161,226,.15);color:var(--gold);}
  .br{background:rgba(239,68,68,.15);color:var(--red);}
  .bb{background:rgba(56,189,248,.15);color:var(--blue);}
  .bm{background:var(--sf2);color:var(--muted);}
  .bpur{background:rgba(139,92,246,.15);color:#A78BFA;}
  .borange{background:rgba(251,146,60,.15);color:#FB923C;}

  /* ── Chips ── */
  .chip{display:inline-flex;align-items:center;gap:5px;padding:5px 12px;border-radius:20px;font-size:12px;font-weight:600;cursor:pointer;border:1px solid var(--border);background:var(--sf2);color:var(--muted);transition:all .2s;font-family:'Inter',sans-serif;}
  .chip:hover{border-color:var(--gold);color:var(--gold);}
  .chip.active{background:rgba(36,161,226,.12);border-color:var(--gold);color:var(--gold);}

  /* ── Nav ── */
  .nav{
    position:sticky;top:0;z-index:100;
    background:${dark ? "rgba(11,14,20,.92)" : "rgba(248,250,252,.94)"};
    backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);
    border-bottom:1px solid var(--border);
    padding:0 20px;height:64px;
    display:flex;align-items:center;justify-content:space-between;gap:8px;
  }
  .logo-img{height:30px;width:auto;object-fit:contain;flex-shrink:0;}
  .logo-wrap{display:flex;align-items:center;gap:7px;cursor:pointer;flex-shrink:0;}
  .logo-name{
    font-family:'Outfit',sans-serif;font-size:17px;font-weight:800;
    background:linear-gradient(135deg,var(--gold),var(--gold2));
    -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
    letter-spacing:-.3px;
  }
  .toggle-btn{display:flex;align-items:center;gap:6px;padding:6px 11px;border-radius:20px;border:1px solid var(--border);background:var(--sf2);cursor:pointer;font-size:12px;color:var(--muted);transition:all .2s;flex-shrink:0;font-family:'Inter',sans-serif;font-weight:500;}
  .toggle-btn:hover{border-color:var(--gold);color:var(--gold);background:rgba(36,161,226,.06);}

  /* ── Sidebar & Dashboard ── */
  .sidebar{width:220px;background:var(--surface);border-right:1px solid var(--border);padding:18px 10px;position:fixed;top:64px;left:0;bottom:0;overflow-y:auto;display:flex;flex-direction:column;}
  .si{display:flex;align-items:center;gap:9px;padding:9px 12px;border-radius:9px;cursor:pointer;font-size:14px;font-weight:500;color:var(--muted);transition:all .2s;margin-bottom:2px;font-family:'Inter',sans-serif;}
  .si:hover{background:var(--sf2);color:var(--text);}
  .si.active{background:rgba(36,161,226,.1);color:var(--gold);font-weight:600;}
  .main{margin-left:220px;padding:24px;min-height:calc(100vh - 64px);}
  .step{display:flex;align-items:flex-start;gap:12px;padding:14px;border-radius:12px;border:1px solid var(--border);background:var(--surface);}
  .step-num{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'Outfit',sans-serif;font-weight:700;font-size:13px;flex-shrink:0;}

  /* ── Grids ── */
  .g2{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
  .g3{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;}
  .g4{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;}

  /* ── Table ── */
  .tbl{width:100%;border-collapse:collapse;}
  .tbl th{text-align:left;padding:11px 13px;font-size:11px;color:var(--muted);font-weight:600;text-transform:uppercase;letter-spacing:.6px;border-bottom:1px solid var(--border);white-space:nowrap;font-family:'Inter',sans-serif;}
  .tbl td{padding:12px 13px;font-size:13px;border-bottom:1px solid var(--border);font-family:'Inter',sans-serif;}
  .tbl tr:hover td{background:var(--sf2);}
  .tbl tr:last-child td{border-bottom:none;}

  /* ── Overlays & Modals ── */
  .overlay{position:fixed;inset:0;background:rgba(0,0,0,.72);backdrop-filter:blur(6px);z-index:9999;display:flex;align-items:flex-start;justify-content:center;padding:14px;padding-top:max(14px,env(safe-area-inset-top));}
  .modal{background:var(--surface);border:1px solid var(--border);border-radius:20px;padding:20px;width:100%;max-width:470px;animation:fadeUp .3s cubic-bezier(.22,.68,0,1.2);max-height:calc(100vh - 28px);overflow-y:auto;position:relative;z-index:10000;box-shadow:0 24px 60px rgba(0,0,0,.25);margin-top:0;}

  /* ── Timeline ── */
  .tl{display:flex;gap:12px;padding-bottom:20px;position:relative;}
  .tl:not(:last-child)::before{content:'';position:absolute;left:14px;top:30px;bottom:0;width:2px;background:var(--border);}
  .tl-dot{width:30px;height:30px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;}

  /* ── Shimmer text ── */
  .shimmer{
    background:linear-gradient(90deg,#29B6F6,#1565C0,#3730A3,#00B4FF,#1565C0,#29B6F6);
    background-size:300% auto;
    -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
    animation:shimmer 4s linear infinite;
  }

  /* ── Misc ── */
  .hero-glow{position:absolute;width:400px;height:400px;border-radius:50%;filter:blur(90px);pointer-events:none;}
  .avatar{width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,var(--gold),var(--accent));display:flex;align-items:center;justify-content:center;font-family:'Outfit',sans-serif;font-weight:700;font-size:13px;color:white;flex-shrink:0;}
  .ficon{width:44px;height:44px;border-radius:11px;display:flex;align-items:center;justify-content:center;font-size:20px;margin-bottom:12px;}
  .stat-card{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:18px 20px;}
  .pbar{height:5px;background:var(--sf2);border-radius:3px;overflow:hidden;}
  .pfill{height:100%;border-radius:3px;background:linear-gradient(90deg,var(--gold),var(--gold2));transition:width .6s cubic-bezier(.4,0,.2,1);}
  .tracking-box{background:rgba(36,161,226,.08);border:1px solid rgba(36,161,226,.25);border-radius:10px;padding:12px;display:flex;align-items:center;gap:10px;}
  .hold-box{background:rgba(139,92,246,.08);border:1px solid rgba(139,92,246,.25);border-radius:10px;padding:12px;}
  .copy-toast{position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:var(--green);color:#fff;padding:10px 22px;border-radius:10px;font-size:13px;font-weight:600;z-index:999;animation:fadeUp .3s ease;font-family:'Inter',sans-serif;}
  .mobile-nav{display:none;position:fixed;bottom:0;left:0;right:0;background:${dark?"rgba(19,22,32,.97)":"rgba(255,255,255,.97)"};backdrop-filter:blur(24px);border-top:1px solid var(--border);z-index:100;padding:8px 0 max(8px,env(safe-area-inset-bottom));}
  .mni{display:flex;flex-direction:column;align-items:center;gap:3px;padding:6px 16px;cursor:pointer;border-radius:10px;transition:all .2s;color:var(--muted);font-size:10px;font-weight:500;min-width:60px;font-family:'Inter',sans-serif;}
  .mni.active{color:var(--gold);}
  .mni span:first-child{font-size:20px;}

  /* ── Responsive ── */
  @media(max-width:1024px){.g4{grid-template-columns:1fr 1fr;}}
  @media(max-width:800px){.g3{grid-template-columns:1fr 1fr;}}
  @media(max-width:640px){
    .sidebar{display:none;}
    .mobile-nav{display:flex;justify-content:space-around;align-items:center;}
    .main{margin-left:0 !important;padding:14px;padding-bottom:90px;width:100%;max-width:100vw;overflow-x:hidden;}
    .g2,.g3,.g4{grid-template-columns:1fr;}
    .nav{padding:0 10px;height:56px;}
    .hide-m{display:none !important;}
    body{overflow-x:hidden;}
    .card{padding:14px;}
    .tbl{font-size:11px;}
    .tbl th,.tbl td{padding:8px 6px;}
    .copy-toast{bottom:90px;}
    .btn-gold,.btn-outline,.btn-ghost{font-size:12px !important;padding:7px 8px !important;}
    .logo-name{font-size:14px;}
  }
  @media(max-width:380px){
    .nav{padding:0 6px;}
    .toggle-btn{padding:5px 7px;font-size:11px;}
  }
  .hide-d{display:none;}
  @media(max-width:640px){.hide-d{display:flex !important;}}
  *{box-sizing:border-box;}
  html,body{max-width:100vw;overflow-x:hidden;}
  `;
}

const MIN_TOKEN = 200;
const calcToken = (amount, pct) => Math.max(MIN_TOKEN, Math.round(Number(amount)*Number(pct)/100));
const BASE_URL = process.env.REACT_APP_FRONTEND_URL || "https://escarapay.in";

const STATUS_META = {
  pending:                { label:"Awaiting Token",       cls:"bm",     icon:"⏳" },
  pending_seller_confirm: { label:"Awaiting Seller Confirm",  cls:"borange", icon:"🤝" },
  token_paid:             { label:"Token Paid",           cls:"bo",     icon:"🔐" },
  dispatched:             { label:"Dispatched",           cls:"bb",     icon:"📦" },
  delivered:              { label:"Delivered",            cls:"bg",     icon:"✅" },
  cancelled_buyer:        { label:"Cancelled (Buyer)",    cls:"br",     icon:"❌" },
  cancelled_seller:       { label:"Cancelled (Seller)",   cls:"br",     icon:"❌" },
  refunded:               { label:"Refunded",             cls:"bb",     icon:"↩️" },
  disputed:               { label:"Disputed",             cls:"bpur",   icon:"⚠️" },
};

const getDaysLeft = (d) => {
  if (!d) return 7;
  return Math.max(0, 7 - Math.floor((new Date()-new Date(d))/(1000*60*60*24)));
};

const getTrackingUrl = (tn) => {
  if (!tn) return null;
  const t = tn.toUpperCase();
  if (t.startsWith("DTDC")) return `https://www.dtdc.in/tracking.asp?strCnno=${tn}`;
  if (t.startsWith("BLUE")||t.startsWith("BD")) return `https://www.bluedart.com/tracking?trackid=${tn}`;
  if (t.startsWith("ECOM")) return `https://ecomexpress.in/tracking/?awb_field=${tn}`;
  if (t.startsWith("DEL")) return `https://www.delhivery.com/track/package/${tn}`;
  return `https://www.google.com/search?q=track+courier+${tn}`;
};

// ✅ SECURITY: Prevent javascript:// and data: XSS in href attributes
const safeUrl = (url) => {
  if (!url) return null;
  try {
    const u = new URL(url);
    return (u.protocol === "https:" || u.protocol === "http:") ? url : null;
  } catch { return null; }
};

function Toast({ msg, onDone }) {
  useEffect(()=>{ const t=setTimeout(onDone,2500); return ()=>clearTimeout(t); },[onDone]);
  return <div className="copy-toast">✅ {msg}</div>;
}

/* ── Token Receipt Download ── */
function downloadReceipt(order, role) {
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-IN", { day:"2-digit", month:"long", year:"numeric", timeZone:"Asia/Kolkata" });
  const timeStr = now.toLocaleTimeString("en-IN", { hour:"2-digit", minute:"2-digit", hour12:true, timeZone:"Asia/Kolkata" });
  const receiptNum = "RCP-" + order.id + "-" + Date.now().toString().slice(-4);
  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>EscaraPay Token Receipt — ${order.id}</title>
<style>
  *{margin:0;padding:0;box-sizing:border-box;}
  body{font-family:'Segoe UI',Arial,sans-serif;background:#f0f4f8;display:flex;justify-content:center;padding:30px 10px;}
  .receipt{background:#fff;border-radius:18px;max-width:480px;width:100%;box-shadow:0 4px 24px rgba(0,0,0,.10);overflow:hidden;}
  .header{background:linear-gradient(135deg,#0ea5e9,#1a84c4);padding:28px 28px 20px;color:#fff;text-align:center;}
  .logo{font-size:26px;font-weight:900;letter-spacing:-1px;margin-bottom:4px;}
  .tagline{font-size:11px;opacity:.85;letter-spacing:.5px;}
  .badge{display:inline-block;background:rgba(255,255,255,.25);border:1px solid rgba(255,255,255,.4);padding:4px 14px;border-radius:20px;font-size:11px;font-weight:700;margin-top:10px;letter-spacing:.5px;}
  .body{padding:24px 28px;}
  .title{font-size:15px;font-weight:700;color:#1e293b;margin-bottom:6px;}
  .subtitle{font-size:12px;color:#64748b;margin-bottom:20px;}
  .row{display:flex;justify-content:space-between;align-items:center;padding:9px 0;border-bottom:1px solid #f1f5f9;font-size:13px;}
  .row:last-child{border-bottom:none;}
  .row .lbl{color:#64748b;}
  .row .val{font-weight:600;color:#1e293b;text-align:right;}
  .row .val.big{font-size:16px;font-weight:800;color:#0ea5e9;}
  .row .val.green{color:#059669;}
  .divider{border:none;border-top:2px dashed #e2e8f0;margin:14px 0;}
  .section-title{font-size:11px;font-weight:700;color:#94a3b8;letter-spacing:.8px;text-transform:uppercase;margin-bottom:10px;}
  .status-chip{display:inline-flex;align-items:center;gap:6px;background:#dcfce7;color:#166534;padding:5px 14px;border-radius:20px;font-size:12px;font-weight:700;margin:12px 0;}
  .footer{background:#f8fafc;padding:16px 28px;text-align:center;border-top:1px solid #f1f5f9;}
  .footer-text{font-size:11px;color:#94a3b8;line-height:1.8;}
  .watermark{color:#0ea5e9;font-weight:700;font-size:11px;}
  @media print{body{background:#fff;padding:0;}  .receipt{box-shadow:none;border-radius:0;max-width:100%;} .no-print{display:none;}}
</style>
</head>
<body>
<div class="receipt">
  <div class="header">
    <div class="logo">EscaraPay</div>
    <div class="tagline">India's Trusted Payment Protection Platform</div>
    <div class="badge">🔐 TOKEN PAYMENT RECEIPT</div>
  </div>
  <div class="body">
    <div class="title">Payment Confirmation</div>
    <div class="subtitle">Receipt No: ${receiptNum}</div>
    <div class="status-chip">✅ Token Secured Successfully</div>
    <hr class="divider"/>
    <div class="section-title">Order Details</div>
    <div class="row"><span class="lbl">Order ID</span><span class="val">${order.id}</span></div>
    <div class="row"><span class="lbl">Product</span><span class="val">${order.product_name}</span></div>
    <div class="row"><span class="lbl">Seller</span><span class="val">${order.seller_name || order.seller_name_manual || "—"}</span></div>
    <div class="row"><span class="lbl">Buyer</span><span class="val">${order.buyer_name || "—"}</span></div>
    <div class="row"><span class="lbl">Order Value</span><span class="val">₹${Number(order.order_amount).toFixed(2)}</span></div>
    <hr class="divider"/>
    <div class="section-title">Payment Breakdown</div>
    <div class="row"><span class="lbl">Token Amount (${order.token_pct || 10}%)</span><span class="val">₹${Number(order.token_amount).toFixed(2)}</span></div>
    <div class="row"><span class="lbl">Gateway Fee (2%)</span><span class="val">₹${Number(order.gateway_fee).toFixed(2)}</span></div>
    <div class="row"><span class="lbl">Total Paid by Buyer</span><span class="val big">₹${Number(order.buyer_pays).toFixed(2)}</span></div>
    ${role !== "buyer" ? `<hr class="divider"/>
    <div class="section-title">Payout Info (Seller)</div>
    <div class="row"><span class="lbl">Platform Commission (5%)</span><span class="val">₹${Number(order.escara_commission).toFixed(2)}</span></div>
    <div class="row"><span class="lbl">Seller Receives (on delivery)</span><span class="val green">₹${Number(order.seller_receives).toFixed(2)}</span></div>` : ""}
    <hr class="divider"/>
    <div class="section-title">Transaction Info</div>
    <div class="row"><span class="lbl">Payment Gateway</span><span class="val">Cashfree (RBI Authorized)</span></div>
    <div class="row"><span class="lbl">Date</span><span class="val">${dateStr}</span></div>
    <div class="row"><span class="lbl">Time (IST)</span><span class="val">${timeStr}</span></div>
    <div class="row"><span class="lbl">Status</span><span class="val green">Token Paid ✅</span></div>
  </div>
  <div class="footer">
    <div class="footer-text">
      <span class="watermark">EscaraPay (India)</span><br/>
      MSME: UDYAM-UP-23-0036110 | support@escarapay.in<br/>
      Funds are securely held until delivery is confirmed.<br/>
      Track your order at: escarapay.in/track/${order.id}
    </div>
  </div>
</div>
<script>window.onload=()=>{setTimeout(()=>window.print(),400);}</script>
</body>
</html>`;
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    const a = document.createElement("a");
    a.href = url; a.download = `EscaraPay-Receipt-${order.id}.html`; a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function Logo({ onClick }) {
  return (
    <div className="logo-wrap" onClick={onClick}>
      <img src={LOGO_SRC} alt="EscaraPay" className="logo-img" onError={e=>{ e.target.style.display="none"; e.target.nextSibling.style.display="flex"; }} />
      <div style={{display:"none",width:32,height:32,borderRadius:8,background:"linear-gradient(135deg,#0ea5e9,#38bdf8)",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:900,color:"#fff",fontFamily:"'Outfit',sans-serif"}}>E₹</div>
      <span className="logo-name">EscaraPay</span>
    </div>
  );
}

function ThemeToggle({ dark, onToggle }) {
  return <div className="toggle-btn" onClick={onToggle}><span>{dark?"🌙":"☀️"}</span><span className="hide-m">{dark?"Dark":"Light"}</span></div>;
}

function LangToggle({ lang, onToggle }) {
  const labels = { en:"EN", hi:"हि", hl:"HI" };
  const next = { en:"hi", hi:"hl", hl:"en" };
  return (
    <div className="toggle-btn" onClick={()=>onToggle(next[lang])} style={{minWidth:40,justifyContent:"center",fontWeight:700,fontSize:13}}>
      {labels[lang]}
    </div>
  );
}

function Bdg({ status }) {
  const s = STATUS_META[status] || STATUS_META.pending;
  return <span className={`badge ${s.cls}`}>{s.icon} {s.label}</span>;
}

/* ══════════ DIRECT PAYMENT PAGE ══════════ */
function PayPage({ orderId, dark, onToggle, onGoHome }) {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [payStep, setPayStep] = useState(0);
  const [payError, setPayError] = useState("");
  const [buyerName, setBuyerName] = useState("");
  const [buyerPhone, setBuyerPhone] = useState("");

  useEffect(()=>{
    getOrderById(orderId).then(r=>{
      setLoading(false);
      if (r.success) setOrder(r.data.order);
      else setError("Order not found. Please check the link.");
    });
  },[orderId]);

  const loadCashfree = () => new Promise((resolve, reject) => {
    if (document.getElementById("cashfree-script")) { resolve(); return; }
    const s = document.createElement("script");
    s.id = "cashfree-script";
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.onload = resolve; s.onerror = reject;
    document.body.appendChild(s);
  });

  const handlePay = async () => {
    setPayError(""); setPayStep(1);
    try {
      await loadCashfree();
    } catch(e) { setPayError("Payment gateway failed to load. Please try again."); setPayStep(0); return; }
    const result = await createPaymentOrder(order.id);
    if (!result.success) { setPayError(result.error); setPayStep(0); return; }
    const { paymentSessionId } = result.data;
    setPayStep(0);
    const cashfree = window.Cashfree({ mode: "production" });
    cashfree.checkout({ paymentSessionId, redirectTarget: "_modal" }).then(async (res) => {
      if (res.error) { setPayError(res.error.message || "Payment failed"); return; }
      if (res.paymentDetails?.paymentStatus === "FAILED") { setPayError("Payment failed. Please try again."); return; }
      setPayStep(2);
      const verify = await verifyPayment(null, null, null, order.id);
      if (verify.success) { setPayStep(3); setOrder(prev=>({...prev,status:"token_paid"})); }
      else { setPayError("Verify failed: "+verify.error); setPayStep(0); }
    }).catch(e => { setPayError("Payment cancelled or failed."); setPayStep(0); });
  };

  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav">
        <Logo onClick={onGoHome} />
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <ThemeToggle dark={dark} onToggle={onToggle} />
          <button className="btn-ghost" style={{fontSize:12}} onClick={onGoHome}>← Home</button>
        </div>
      </nav>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"calc(100vh - 62px)",padding:20}}>
        <div style={{width:"100%",maxWidth:460}}>
          {loading && <div className="card" style={{textAlign:"center",padding:50}}><div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div style={{color:"var(--muted)"}}>Loading order...</div></div>}
          {error && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:40,marginBottom:12}}>❌</div><div className="syne" style={{fontWeight:800,fontSize:18,marginBottom:8}}>No Order Found</div><div style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>{error}</div><button className="btn-ghost" onClick={onGoHome}>← Home</button></div>}
          {payStep===3 && <div className="card fu" style={{textAlign:"center",padding:40}}><div style={{fontSize:60,marginBottom:16}}>🎉</div><div className="syne" style={{fontWeight:800,fontSize:24,color:"var(--green)",marginBottom:8}}>Token Secured!</div><div style={{color:"var(--muted)",fontSize:14,marginBottom:16}}>₹{order?.token_amount} secured in the protection vault</div><div style={{background:"rgba(14,165,233,.1)",border:"1px solid rgba(14,165,233,.2)",borderRadius:12,padding:14,marginBottom:20}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:4}}>Save your Order ID:</div><div style={{fontFamily:"monospace",fontWeight:700,color:"var(--gold)",fontSize:16}}>{order?.id}</div></div><div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}><button className="btn-gold" style={{fontSize:13,padding:"10px 20px"}} onClick={()=>downloadReceipt(order,"buyer")}>📄 Download Receipt</button><button className="btn-ghost" onClick={onGoHome}>← Go to Home</button></div></div>}
          {payStep===2 && <div className="card" style={{textAlign:"center",padding:50}}><div style={{width:44,height:44,border:"3px solid var(--green)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div className="syne" style={{fontWeight:700,fontSize:16}}>Payment Verify ho rahi hai...</div></div>}
          {payStep===1 && <div className="card" style={{textAlign:"center",padding:50}}><div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div className="syne" style={{fontWeight:700,fontSize:16}}>Payment Gateway Load ho raha hai...</div></div>}
          {order && !loading && payStep===0 && (
            order.status !== "pending" ? (
              <div className="fu">
                {/* Status header */}
                <div style={{textAlign:"center",marginBottom:20}}>
                  <div style={{fontSize:52,marginBottom:8}}>
                    {order.status==="token_paid"?"🔐":order.status==="dispatched"?"📦":order.status==="delivered"?"✅":"📋"}
                  </div>
                  <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:8}}>
                    {order.status==="token_paid"?"Token Payment Secured":order.status==="dispatched"?"Order Dispatched":order.status==="delivered"?"Order Delivered":"Order Processed"}
                  </div>
                  <Bdg status={order.status} />
                </div>

                {/* Order details card */}
                <div className="card" style={{marginBottom:14,background:"rgba(14,165,233,.05)",borderColor:"rgba(14,165,233,.25)"}}>
                  <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Order ID</div>
                  <div style={{fontFamily:"monospace",fontWeight:700,color:"var(--gold)",fontSize:14,marginBottom:12}}>{order.id}</div>

                  <div className="g2" style={{marginBottom:12}}>
                    <div style={{background:"var(--sf2)",borderRadius:10,padding:12}}>
                      <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Product</div>
                      <div style={{fontWeight:700,fontSize:14}}>{order.product_name}</div>
                    </div>
                    <div style={{background:"var(--sf2)",borderRadius:10,padding:12}}>
                      <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Seller</div>
                      <div style={{fontWeight:700,fontSize:14}}>{order.seller_name||"—"}</div>
                    </div>
                  </div>

                  {order.buyer_name && (
                    <div style={{background:"var(--sf2)",borderRadius:10,padding:12,marginBottom:12}}>
                      <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Buyer</div>
                      <div style={{fontWeight:700,fontSize:14}}>{order.buyer_name}</div>
                    </div>
                  )}

                  {/* Payment breakdown */}
                  <div style={{background:"var(--sf2)",borderRadius:10,padding:12,fontSize:13}}>
                    <div style={{fontWeight:600,marginBottom:8,color:"var(--muted)"}}>💰 Payment Breakdown</div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                      <span style={{color:"var(--muted)"}}>Order Value</span>
                      <span style={{fontWeight:600}}>₹{order.order_amount}</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                      <span style={{color:"var(--muted)"}}>Token ({order.token_pct||10}% protected)</span>
                      <span style={{fontWeight:600}}>₹{order.token_amount}</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                      <span style={{color:"var(--muted)"}}>Gateway Fee (2%)</span>
                      <span style={{color:"var(--muted)"}}>₹{order.gateway_fee}</span>
                    </div>
                    <div style={{height:1,background:"var(--border)",margin:"8px 0"}}/>
                    <div style={{display:"flex",justifyContent:"space-between",fontWeight:700}}>
                      <span>Total Paid</span>
                      <span style={{color:"var(--gold)",fontSize:15}}>₹{order.buyer_pays||order.token_amount}</span>
                    </div>
                  </div>

                  {/* Tracking if dispatched */}
                  {order.tracking_number && (
                    <div style={{marginTop:12,background:"rgba(59,130,246,.08)",border:"1px solid rgba(59,130,246,.2)",borderRadius:8,padding:"10px 12px",fontSize:12}}>
                      <span style={{color:"var(--blue)",fontWeight:600}}>📦 Tracking: </span>
                      <span style={{fontFamily:"monospace",fontWeight:700}}>{order.tracking_number}</span>
                    </div>
                  )}
                </div>

                {/* Status info */}
                <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.2)",borderRadius:10,padding:12,marginBottom:16,fontSize:12}}>
                  {order.status==="token_paid" && <><div style={{fontWeight:700,color:"var(--green)",marginBottom:4}}>🔐 Your token is secured</div><div style={{color:"var(--muted)"}}>Funds are held safely until you confirm delivery. Track your order at escarapay.in/track/{order.id}</div></>}
                  {order.status==="dispatched" && <><div style={{fontWeight:700,color:"var(--blue)",marginBottom:4}}>📦 Order is on its way</div><div style={{color:"var(--muted)"}}>Seller has dispatched your order. Confirm delivery once received.</div></>}
                  {order.status==="delivered" && <><div style={{fontWeight:700,color:"var(--green)",marginBottom:4}}>✅ Order completed</div><div style={{color:"var(--muted)"}}>Delivery has been confirmed. Thank you for using EscaraPay!</div></>}
                </div>

                {/* Action buttons */}
                <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  <button className="btn-gold" style={{flex:1,padding:"11px",fontSize:13}}
                    onClick={()=>downloadReceipt(order,"buyer")}>
                    📄 Download Receipt
                  </button>
                  <button className="btn-ghost" style={{flex:1,padding:"11px"}} onClick={onGoHome}>← Home</button>
                </div>
                <div style={{textAlign:"center",marginTop:10,fontSize:11,color:"var(--muted)"}}>
                  Receipt includes order details, payment breakdown, and date/time.
                </div>
              </div>
            ) : (
              <div className="fu">
                {/* ── Layer 3: Seller Branding — Trust Building ── */}
                {order.seller_name && (
                  <div style={{textAlign:"center",marginBottom:16,background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.2)",borderRadius:14,padding:16}}>
                    <div style={{fontSize:11,color:"var(--muted)",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Order From</div>
                    <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:4}}>{order.seller_name}</div>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,fontSize:12,color:"var(--muted)"}}>
                      <span>🛡️</span><span>COD payment secured by <strong style={{color:"var(--blue)"}}>EscaraPay</strong></span>
                    </div>
                    {order.platform_order_id && (
                      <div style={{marginTop:6,fontSize:11,color:"var(--muted)"}}>Store Order: <code style={{background:"var(--sf2)",padding:"1px 6px",borderRadius:4}}>{order.platform_order_id}</code></div>
                    )}
                  </div>
                )}
                <div style={{textAlign:"center",marginBottom:20}}>
                  <img src={LOGO_SRC} alt="EscaraPay" style={{height:44,objectFit:"contain",marginBottom:12}} onError={e=>e.target.style.display="none"} />
                  <div style={{fontSize:12,color:"var(--muted)",marginBottom:4}}>🛡️ Secured by EscaraPay</div>
                  <h2 className="syne" style={{fontWeight:800,fontSize:22}}>Secure Token Payment</h2>
                </div>
                <div className="card" style={{marginBottom:14,background:"rgba(14,165,233,.05)",borderColor:"rgba(14,165,233,.25)"}}>
                  <div style={{marginBottom:14}}>
                    <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Order: <span style={{fontFamily:"monospace",color:"var(--gold)"}}>{order.id}</span></div>
                    <div className="syne" style={{fontWeight:800,fontSize:22}}>{order.product_name}</div>
                    <div style={{fontSize:13,color:"var(--muted)",marginTop:4}}>Seller: <strong style={{color:"var(--text)"}}>{order.seller_name||"—"}</strong></div>
                  </div>
                  <div className="g2" style={{marginBottom:14}}>
                    <div style={{background:"var(--sf2)",borderRadius:10,padding:12,textAlign:"center"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Order Value</div><div className="syne" style={{fontWeight:800,fontSize:22}}>₹{order.order_amount}</div></div>
                    <div style={{background:"rgba(14,165,233,.15)",border:"1px solid rgba(14,165,233,.3)",borderRadius:10,padding:12,textAlign:"center"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>You Pay</div><div className="syne" style={{fontWeight:800,fontSize:22,color:"var(--gold)"}}>₹{order.buyer_pays||order.token_amount}</div></div>
                  </div>
                  <div style={{background:"var(--sf2)",borderRadius:10,padding:12,fontSize:12,marginBottom:14}}>
                    <div style={{fontWeight:600,marginBottom:8,color:"var(--muted)"}}>💰 Breakdown</div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><span style={{color:"var(--muted)"}}>Token (Protected)</span><span>₹{order.token_amount}</span></div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><span style={{color:"var(--muted)"}}>Gateway Fee (2%)</span><span style={{color:"var(--muted)"}}>₹{order.gateway_fee}</span></div>
                    <div style={{height:1,background:"var(--border)",margin:"6px 0"}}></div>
                    <div style={{display:"flex",justifyContent:"space-between",fontWeight:700}}><span>Total</span><span style={{color:"var(--gold)"}}>₹{order.buyer_pays||order.token_amount}</span></div>
                  </div>
                  <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.2)",borderRadius:10,padding:12,marginBottom:14}}>
                    <div style={{fontSize:12,fontWeight:700,color:"var(--green)",marginBottom:6}}>🛡️ EscaraPay Guarantee</div>
                    {["Token is held securely until delivery is confirmed","Item not received? Full token refund guaranteed","Raise a dispute within 7 days of delivery","Our team responds within 24 hours"].map(tx=>(
                      <div key={tx} style={{display:"flex",gap:7,fontSize:12,color:"var(--muted)",marginBottom:4}}><span style={{color:"var(--green)"}}>✓</span><span>{tx}</span></div>
                    ))}
                  </div>
                  <div style={{marginBottom:14}}>
                    <label className="label">Your Name (optional)</label>
                    <input className="input" placeholder="Rahul Sharma" value={buyerName} onChange={e=>setBuyerName(e.target.value)} style={{marginBottom:10}} />
                    <label className="label">WhatsApp Number (optional)</label>
                    <input className="input" placeholder="9876543210" value={buyerPhone} onChange={e=>setBuyerPhone(e.target.value)} />
                  </div>
                </div>
                {payError && <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,padding:12,marginBottom:12,fontSize:13,color:"var(--red)"}}>❌ {payError}</div>}
                <button className="btn-gold pulse" style={{width:"100%",padding:"16px",fontSize:16,borderRadius:12,marginBottom:12}} onClick={handlePay}>
                  💳 Pay ₹{order.buyer_pays||order.token_amount} Token
                </button>
                <div style={{textAlign:"center",fontSize:12,color:"var(--muted)"}}>🔒 Secured by Cashfree • UPI, Cards, NetBanking</div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

/* ══════════ ORDER MODAL ══════════ */
function OrderModal({ order, isSeller, sellerId, onClose, onDispatch, onConfirmDelivery, onDispute }) {
  const [tracking, setTracking] = useState(order.tracking_number||"");
  const [disputeReason, setDisputeReason] = useState("");
  const [showDisputeForm, setShowDisputeForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [copied, setCopied] = useState(false);
  const paymentLink = `${BASE_URL}/pay/${order.id}`;
  const daysLeft = getDaysLeft(order.dispatched_at||order.updated_at);
  const trackingUrl = getTrackingUrl(order.tracking_number);
  const copyLink = () => { navigator.clipboard?.writeText(paymentLink); setCopied(true); setTimeout(()=>setCopied(false),2000); };

  const steps = [
    {label:"Order Created", done:true, icon:"📋"},
    {label:"Token Paid by Buyer", done:order.status!=="pending"&&order.status!=="pending_seller_confirm", icon:"💳"},
    {label:"Dispatched by Seller", done:["dispatched","delivered","disputed"].includes(order.status), icon:"🚚"},
    {label:"Delivered", done:order.status==="delivered", icon:"✅"},
  ];

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
          <div>
            <div style={{fontFamily:"monospace",color:"var(--gold)",fontSize:12,marginBottom:3}}>{order.id}</div>
            <h3 className="syne" style={{fontWeight:800,fontSize:18}}>{order.product_name}</h3>
            <div style={{fontSize:12,color:"var(--muted)",marginTop:3}}>{isSeller?"Buyer":"Seller"}: <strong style={{color:"var(--text)"}}>{order.buyer_name||order.seller_name||"—"}</strong></div>
          </div>
          <Bdg status={order.status} />
        </div>
        <div className="g2" style={{marginBottom:16}}>
          <div style={{background:"var(--sf2)",borderRadius:10,padding:12}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Order Amount</div><div className="syne" style={{fontWeight:800,fontSize:20}}>₹{order.order_amount}</div></div>
          <div style={{background:"rgba(14,165,233,.1)",borderRadius:10,padding:12,border:"1px solid rgba(14,165,233,.2)"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Token (Protected)</div><div className="syne" style={{fontWeight:800,fontSize:20,color:"var(--gold)"}}>₹{order.token_amount}</div></div>
        </div>
        {isSeller && (
          <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:10,padding:12,marginBottom:14}}>
            <div style={{fontSize:11,color:"var(--muted)",marginBottom:6,fontWeight:600}}>🔗 Payment Link</div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <code style={{fontSize:11,color:"var(--gold)",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",background:"var(--sf2)",padding:"6px 10px",borderRadius:6}}>{paymentLink}</code>
              <button className="btn-ghost" style={{padding:"6px 12px",fontSize:12,flexShrink:0,color:copied?"var(--green)":"var(--text)",borderColor:copied?"var(--green)":"var(--border)"}} onClick={copyLink}>{copied?"✅ Copied!":"📋 Copy"}</button>
            </div>
          </div>
        )}
        {steps.map((s,i)=>(
          <div key={i} className="tl">
            <div className="tl-dot" style={{background:s.done?"rgba(5,150,105,.2)":"var(--sf2)",color:s.done?"var(--green)":"var(--muted)"}}>{s.done?"✓":s.icon}</div>
            <div style={{paddingTop:6,fontSize:13,fontWeight:s.done?600:400,color:s.done?"var(--text)":"var(--muted)"}}>{s.label}</div>
          </div>
        ))}
        {order.tracking_number && (
          <div className="tracking-box" style={{marginBottom:12}}>
            <div style={{flex:1}}><div style={{fontSize:11,color:"var(--blue)",fontWeight:600,marginBottom:2}}>📦 Tracking</div><div style={{fontFamily:"monospace",fontWeight:700}}>{order.tracking_number}</div></div>
            {trackingUrl && <a href={trackingUrl} target="_blank" rel="noreferrer" style={{background:"var(--blue)",color:"#fff",padding:"6px 12px",borderRadius:8,fontSize:12,fontWeight:600,textDecoration:"none"}}>Track →</a>}
          </div>
        )}
        {order.status==="dispatched" && <div className="hold-box" style={{marginBottom:12}}><div style={{fontSize:12,color:"#a78bfa",fontWeight:700}}>⏰ Token Hold: {daysLeft>0?`${daysLeft} more day${daysLeft===1?"":"s"}`:"Ready to release!"}</div></div>}
        {order.status==="dispatched" && order.confirm_token && (
          <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.25)",borderRadius:10,padding:12,marginBottom:12}}>
            <div style={{fontSize:12,fontWeight:700,color:"var(--green)",marginBottom:6}}>🔗 Buyer Confirmation Link</div>
            <div style={{fontSize:11,color:"var(--muted)",marginBottom:8}}>Share with buyer — one tap to confirm, no login needed:</div>
            <div style={{display:"flex",gap:6,marginBottom:8}}>
              <code style={{fontSize:10,color:"var(--gold)",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",background:"var(--sf2)",padding:"6px 8px",borderRadius:6}}>
                {`escarapay.in/confirm/${order.confirm_token.slice(0,16)}...`}
              </code>
              <button className="btn-ghost" style={{padding:"5px 10px",fontSize:11,flexShrink:0}}
                onClick={()=>navigator.clipboard?.writeText(`https://escarapay.in/confirm/${order.confirm_token}`)}>
                📋 Copy
              </button>
            </div>
            <a href={`https://wa.me/${(order.buyer_phone||"").replace(/\D/g,"")}?text=${encodeURIComponent(`Hi! Your order "${order.product_name}" has been dispatched 📦\n\nPlease confirm delivery here — no login needed, just one tap:\n\n✅ https://escarapay.in/confirm/${order.confirm_token}\n\nHave an issue? Use the same link to report it.\n\n— via EscaraPay 🛡️`)}`}
              target="_blank" rel="noreferrer"
              style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,background:"#25D366",color:"#fff",padding:"10px",borderRadius:8,textDecoration:"none",fontWeight:700,fontSize:13,width:"100%"}}>
              <span style={{fontSize:18}}>💬</span> Send via WhatsApp
            </a>
          </div>
        )}
        {isSeller && order.status==="token_paid" && (
          <div style={{marginBottom:12}}>
            <label className="label">Courier Tracking Number *</label>
            <input className="input" placeholder="Courier tracking number (e.g. DTDC123456)" value={tracking} onChange={e=>setTracking(e.target.value)} style={{marginBottom:8}} />
            <button className="btn-gold" style={{width:"100%"}} onClick={async()=>{
              if(!tracking){setMsg("❌ Please enter a tracking number!"); return;}
              setLoading(true);
              const r = await dispatchOrder(order.id, tracking, sellerId);
              setLoading(false);
              if(r.success){
                onDispatch(order.id, tracking, r.data?.confirmUrl);
                setMsg("✅ Dispatched! Confirmation link sent to buyer via SMS/email.");
              } else setMsg("❌ "+r.error);
            }} disabled={loading}>{loading?"⏳...":"📦 Mark as Dispatched"}</button>
          </div>
        )}
        {!isSeller && order.status==="dispatched" && (
          <button className="btn-green" style={{width:"100%",padding:"11px",marginBottom:10}} onClick={async()=>{ setLoading(true); const r=await confirmDelivery(order.id); setLoading(false); if(r.success){onConfirmDelivery(order.id);onClose();}else setMsg("❌ "+r.error); }} disabled={loading}>{loading?"⏳...":"✅ Confirm Delivery Received"}</button>
        )}
        {["token_paid","dispatched"].includes(order.status) && !showDisputeForm && (
          <button className="btn-ghost" style={{width:"100%",marginBottom:8,color:"var(--red)",borderColor:"rgba(239,68,68,.3)"}} onClick={()=>setShowDisputeForm(true)}>⚠️ Raise a Dispute</button>
        )}
        {showDisputeForm && (
          <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:10,padding:12,marginBottom:12}}>
            <select className="select" value={disputeReason} onChange={e=>setDisputeReason(e.target.value)} style={{marginBottom:10}}>
              <option value="">-- Select a Reason --</option>
              {isSeller?(<><option value="Buyer not responding">Buyer is not responding</option><option value="False claim">Buyer is making a false claim</option></>)
               :(<><option value="Item not received">Item not received</option><option value="Wrong item">Wrong item received</option><option value="Damaged">Item received damaged</option><option value="Seller not responding">Seller not responding</option></>)}
            </select>
            <div style={{display:"flex",gap:8}}>
              <button className="btn-ghost" style={{flex:1}} onClick={()=>setShowDisputeForm(false)}>Cancel</button>
              <button className="btn-red" style={{flex:2,padding:"9px"}} onClick={async()=>{ if(!disputeReason){setMsg("❌ Please select a reason!"); return;} setLoading(true); const r=await raiseDispute(order.id,disputeReason,isSeller?"seller":"buyer"); setLoading(false); if(r.success){onDispute&&onDispute(order.id);setMsg("✅ Dispute raised successfully!");}else setMsg("❌ "+r.error); }} disabled={loading}>{loading?"⏳...":"Submit"}</button>
            </div>
          </div>
        )}
        {msg && <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,marginBottom:10,color:msg.startsWith("✅")?"var(--green)":"var(--red)"}}>{msg}</div>}
        {["token_paid","dispatched","delivered"].includes(order.status) && (
          <button className="btn-ghost" style={{width:"100%",marginBottom:8}} onClick={()=>downloadReceipt(order, isSeller?"seller":"buyer")}>📄 Download Token Receipt</button>
        )}
        <button className="btn-ghost" style={{width:"100%"}} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

/* ══════════ STAT COUNT COMPONENT ══════════ */
function StatCount({ target, suffix, label, started }) {
  const val = useCountUp(target, 1800, started);
  return (
    <div style={{textAlign:"center"}}>
      <div className="syne" style={{
        fontSize:"clamp(32px,4vw,52px)",fontWeight:800,color:"#fff",lineHeight:1,marginBottom:6,
        letterSpacing:"-1px"
      }}>
        {val.toLocaleString("en-IN")}{suffix}
      </div>
      <div style={{fontSize:13,color:"rgba(255,255,255,.65)",fontWeight:500}}>{label}</div>
    </div>
  );
}

/* ══════════ SCROLL ANIMATION HOOK ══════════ */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = "1";
          e.target.style.transform = "translateY(0)";
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => {
      el.style.opacity = "0";
      el.style.transform = "translateY(28px)";
      el.style.transition = "opacity .6s ease, transform .6s ease";
      io.observe(el);
    });
    return () => io.disconnect();
  }, []);
}

/* ══════════ COUNT UP HOOK ══════════ */
function useCountUp(target, duration = 1800, started = false) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!started) return;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const prog = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - prog, 3);
      setVal(Math.floor(eased * target));
      if (prog < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [started, target, duration]);
  return val;
}

/* ══════════ LANDING ══════════ */
/* ══════════ TYPEWRITER COMPONENT ══════════ */
function TypeWriter({ words, dark }) {
  const [idx, setIdx] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [pause, setPause] = useState(false);

  useEffect(() => {
    if (pause) { const t = setTimeout(() => setPause(false), 1800); return () => clearTimeout(t); }
    const word = words[idx];
    if (!deleting && displayed === word) { setPause(true); setDeleting(true); return; }
    if (deleting && displayed === "") { setDeleting(false); setIdx((idx + 1) % words.length); return; }
    const speed = deleting ? 40 : 80;
    const t = setTimeout(() => {
      setDisplayed(deleting ? word.slice(0, displayed.length - 1) : word.slice(0, displayed.length + 1));
    }, speed);
    return () => clearTimeout(t);
  }, [displayed, deleting, pause, idx, words]);

  return (
    <span style={{
      color: "var(--gold)",
      borderRight: "3px solid var(--gold)",
      paddingRight: 4,
      animation: "blinkCursor 0.8s step-end infinite",
      minWidth: 2,
      display: "inline-block",
    }}>{displayed}</span>
  );
}

/* ══════════ RTO LOSS CALCULATOR ══════════ */
function RTOCalculator({ onEnter }) {
  const [orders, setOrders]     = useState(50);
  const [avgValue, setAvgValue] = useState(800);
  const [rtoRate, setRtoRate]   = useState(25);
  const [tokenPct, setTokenPct] = useState(20);
  const [category, setCategory] = useState("clothing");
  const [shown, setShown]       = useState(false);

  const categoryRTO = { clothing:28, electronics:18, footwear:32, accessories:22, beauty:15, other:25 };

  // Auto-set RTO rate when category changes
  const handleCategory = (c) => { setCategory(c); setRtoRate(categoryRTO[c]); };

  // Calculations
  const rtoOrders       = Math.round(orders * rtoRate / 100);
  const shippingCost    = 80; // avg ₹80 per RTO
  const returnShipping  = 60;
  const handlingCost    = 30;
  const lossPerRTO      = shippingCost + returnShipping + handlingCost;
  const monthlyLoss     = rtoOrders * lossPerRTO;
  const yearlyLoss      = monthlyLoss * 12;

  // With EscaraPay
  const tokenAmount     = Math.round(avgValue * tokenPct / 100);
  const tokenCollected  = rtoOrders * tokenAmount;
  const netSaving       = Math.max(0, tokenCollected - (rtoOrders * shippingCost));
  const yearlySaving    = netSaving * 12;
  const roi             = monthlyLoss > 0 ? Math.round((netSaving / monthlyLoss) * 100) : 0;

  const fmt = (n) => n >= 100000 ? `₹${(n/100000).toFixed(1)}L` : n >= 1000 ? `₹${(n/1000).toFixed(1)}K` : `₹${n}`;

  return (
    <div style={{padding:"80px clamp(16px,5vw,40px)",background:"var(--bg)"}}>
      <div style={{maxWidth:860,margin:"0 auto"}}>

        {/* Header */}
        <div className="reveal" style={{textAlign:"center",marginBottom:44}}>
          <span style={{display:"inline-block",background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.2)",borderRadius:100,padding:"4px 16px",fontSize:11,fontWeight:700,color:"#ef4444",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:12}}>
            FREE TOOL
          </span>
          <h2 className="syne" style={{fontWeight:900,fontSize:"clamp(24px,4vw,38px)",marginBottom:10}}>
            Calculate Your RTO Losses 🧮
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:520,margin:"0 auto"}}>
            See exactly how much money you're losing to returns — and how much EscaraPay can save you.
          </p>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:20}}>

          {/* INPUT SIDE */}
          <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:20,padding:"28px 24px"}}>
            <div style={{fontWeight:700,fontSize:14,color:"var(--muted)",textTransform:"uppercase",letterSpacing:"1px",marginBottom:20}}>Your Business</div>

            {/* Category */}
            <div style={{marginBottom:18}}>
              <label style={{fontSize:12,fontWeight:600,color:"var(--muted)",display:"block",marginBottom:8}}>Product Category</label>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6}}>
                {[["clothing","👗 Clothing"],["electronics","📱 Electronics"],["footwear","👟 Footwear"],["accessories","💍 Accessories"],["beauty","💄 Beauty"],["other","📦 Other"]].map(([val,label])=>(
                  <button key={val} onClick={()=>handleCategory(val)}
                    style={{padding:"7px 4px",borderRadius:8,border:`1.5px solid ${category===val?"var(--gold)":"var(--border)"}`,background:category===val?"rgba(250,189,0,.1)":"transparent",color:category===val?"var(--gold)":"var(--muted)",fontSize:11,fontWeight:600,cursor:"pointer",transition:"all .15s"}}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Monthly Orders */}
            <div style={{marginBottom:18}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--muted)"}}>Monthly Orders</label>
                <span style={{fontSize:14,fontWeight:800,color:"var(--gold)"}}>{orders}</span>
              </div>
              <input type="range" min={10} max={500} step={5} value={orders}
                onChange={e=>setOrders(Number(e.target.value))}
                style={{width:"100%",accentColor:"var(--gold)"}} />
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--muted)",marginTop:3}}>
                <span>10</span><span>500</span>
              </div>
            </div>

            {/* Avg Order Value */}
            <div style={{marginBottom:18}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--muted)"}}>Avg Order Value</label>
                <span style={{fontSize:14,fontWeight:800,color:"var(--gold)"}}>₹{avgValue}</span>
              </div>
              <input type="range" min={200} max={5000} step={50} value={avgValue}
                onChange={e=>setAvgValue(Number(e.target.value))}
                style={{width:"100%",accentColor:"var(--gold)"}} />
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--muted)",marginTop:3}}>
                <span>₹200</span><span>₹5,000</span>
              </div>
            </div>

            {/* RTO Rate */}
            <div style={{marginBottom:18}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--muted)"}}>RTO Rate</label>
                <span style={{fontSize:14,fontWeight:800,color:"#ef4444"}}>{rtoRate}%</span>
              </div>
              <input type="range" min={5} max={60} step={1} value={rtoRate}
                onChange={e=>setRtoRate(Number(e.target.value))}
                style={{width:"100%",accentColor:"#ef4444"}} />
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--muted)",marginTop:3}}>
                <span>5%</span><span>60%</span>
              </div>
            </div>

            {/* Token % */}
            <div>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--muted)"}}>EscaraPay Token %</label>
                <span style={{fontSize:14,fontWeight:800,color:"var(--green)"}}>{tokenPct}%</span>
              </div>
              <input type="range" min={10} max={50} step={5} value={tokenPct}
                onChange={e=>setTokenPct(Number(e.target.value))}
                style={{width:"100%",accentColor:"#10b981"}} />
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--muted)",marginTop:3}}>
                <span>10%</span><span>50%</span>
              </div>
            </div>
          </div>

          {/* RESULTS SIDE */}
          <div style={{display:"flex",flexDirection:"column",gap:12}}>

            {/* Without EscaraPay */}
            <div style={{background:"rgba(239,68,68,.06)",border:"1px solid rgba(239,68,68,.2)",borderRadius:16,padding:"20px 22px",flex:1}}>
              <div style={{fontSize:12,fontWeight:700,color:"#ef4444",textTransform:"uppercase",letterSpacing:"1px",marginBottom:14}}>😢 Without EscaraPay</div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
                  <span style={{color:"var(--muted)"}}>RTO Orders/month</span>
                  <strong style={{color:"#ef4444"}}>{rtoOrders} orders</strong>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
                  <span style={{color:"var(--muted)"}}>Loss per RTO</span>
                  <strong style={{color:"#ef4444"}}>₹{lossPerRTO}</strong>
                </div>
                <div style={{height:1,background:"rgba(239,68,68,.15)"}}/>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:13,color:"var(--muted)"}}>Monthly Loss</span>
                  <strong style={{fontSize:18,color:"#ef4444"}}>{fmt(monthlyLoss)}</strong>
                </div>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:13,color:"var(--muted)"}}>Yearly Loss</span>
                  <strong style={{fontSize:22,color:"#ef4444",fontFamily:"'Syne',sans-serif"}}>{fmt(yearlyLoss)}</strong>
                </div>
              </div>
            </div>

            {/* With EscaraPay */}
            <div style={{background:"rgba(16,185,129,.06)",border:"1px solid rgba(16,185,129,.25)",borderRadius:16,padding:"20px 22px",flex:1}}>
              <div style={{fontSize:12,fontWeight:700,color:"var(--green)",textTransform:"uppercase",letterSpacing:"1px",marginBottom:14}}>✅ With EscaraPay</div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
                  <span style={{color:"var(--muted)"}}>Token per RTO order</span>
                  <strong style={{color:"var(--green)"}}>₹{tokenAmount} collected</strong>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
                  <span style={{color:"var(--muted)"}}>Tokens collected</span>
                  <strong style={{color:"var(--green)"}}>{fmt(tokenCollected)}</strong>
                </div>
                <div style={{height:1,background:"rgba(16,185,129,.2)"}}/>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:13,color:"var(--muted)"}}>Monthly Saving</span>
                  <strong style={{fontSize:18,color:"var(--green)"}}>{fmt(netSaving)}</strong>
                </div>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:13,color:"var(--muted)"}}>Yearly Saving</span>
                  <strong style={{fontSize:22,color:"var(--green)",fontFamily:"'Syne',sans-serif"}}>{fmt(yearlySaving)}</strong>
                </div>
              </div>
            </div>

            {/* ROI Badge */}
            <div style={{background:"linear-gradient(135deg,var(--gold),#f59e0b)",borderRadius:14,padding:"16px 20px",textAlign:"center"}}>
              <div style={{fontSize:11,fontWeight:700,color:"rgba(0,0,0,.6)",letterSpacing:"1px",marginBottom:4}}>YOUR ROI WITH ESCARAPAY</div>
              <div className="syne" style={{fontSize:36,fontWeight:900,color:"#000"}}>{roi}%</div>
              <div style={{fontSize:12,color:"rgba(0,0,0,.7)",marginTop:2}}>return on every token collected</div>
            </div>

          </div>
        </div>

        {/* CTA */}
        <div style={{marginTop:32,textAlign:"center",padding:"28px 20px",background:"var(--surface)",borderRadius:18,border:"1px solid var(--border)"}}>
          <div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>
            Stop losing {fmt(monthlyLoss)} every month 🛑
          </div>
          <p style={{color:"var(--muted)",fontSize:14,marginBottom:20}}>
            Start collecting tokens today — free to set up, takes 2 minutes.
          </p>
          <button className="btn-gold" style={{padding:"13px 36px",fontSize:15,borderRadius:12}}
            onClick={()=>onEnter("seller")}>
            Start Protecting My Sales →
          </button>
          <button className="btn-ghost" style={{padding:"13px 24px"}}
            onClick={()=>{ window.history.pushState({},"","/rto-calculator"); window._goToPage("rto-calculator"); }}>
            📊 Detailed Calculator
          </button>
        </div>

      </div>
    </div>
  );
}

function Landing({ onEnter, onTrack, dark, onToggle, lang, onLangToggle }) {
  const t = T[lang] || T.hl;
  const [statsStarted, setStatsStarted] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const statsRef = useScrollReveal ? null : null;
  useScrollReveal();

  const LT = {
    en: {
      heroTag: "India's Trusted Payment Protection Platform",
      heroH1a: "Escara Pay",
      heroH1b: "Stop RTO Losses & Scale Your Business with Escara Pay.",
      heroDesc: "Escara Pay ensures secure online transactions by protecting both buyers and sellers. We safeguard payments until the product is delivered, reducing fraud and building trust.",
      ctaSeller: "Login as Seller",
      ctaBuyer: "Login as Buyer",
      howTitle: "How Escara Pay Works?",
      whyTitle: "Why Choose Escara Pay?",
      whySub: "Trade with Confidence & Grow Without Risk",
      tokenTitle: "Token Hold System",
      tokenSub: "Your money is safe. Always.",
      steps: [
        { num:"01", icon:"📝", title:"Register & Agree", desc:"Both parties sign up and agree on price and terms." },
        { num:"02", icon:"🔗", title:"Generate Payment Link", desc:"The Seller creates a secure Escara Pay order link directly from their dashboard." },
        { num:"03", icon:"💬", title:"Share via WhatsApp", desc:"The link is sent instantly to the Buyer via WhatsApp for quick and easy access." },
        { num:"04", icon:"🔐", title:"Secure Deposit", desc:"The Buyer opens the link and pays the funds into Escara Pay's secure protected vault." },
        { num:"05", icon:"🚚", title:"Ship & Track", desc:"The Seller delivers the goods and provides tracking details." },
        { num:"06", icon:"✅", title:"Inspect & Release", desc:"Once the Buyer approves the delivery, Escara Pay releases the payment to the Seller." },
      ],
      benefits: [
        { icon:"🛡️", title:"Zero Fraud Risk", desc:"Eliminate the fear of 'payment-not-received' or 'item-not-shipped' scams.", color:"rgba(14,165,233,.15)", bdr:"rgba(14,165,233,.35)" },
        { icon:"📦", title:"Guaranteed RTO Protection", desc:"Escara Pay discourages casual or fake orders and protects your margins.", color:"rgba(5,150,105,.15)", bdr:"rgba(5,150,105,.35)" },
        { icon:"⚡", title:"2-Minute Rapid Setup", desc:"Our streamlined onboarding process lets you create your first secure payment link in just 2 minutes.", color:"rgba(240,180,41,.15)", bdr:"rgba(240,180,41,.35)" },
        { icon:"💬", title:"WhatsApp-Native Experience", desc:"Create, share, and track your protected orders directly within WhatsApp.", color:"rgba(37,211,102,.15)", bdr:"rgba(37,211,102,.35)" },
        { icon:"🔒", title:"Cashfree-Powered Security", desc:"Cashfree's infrastructure ensures every payment is encrypted and 100% secure.", color:"rgba(124,58,237,.15)", bdr:"rgba(124,58,237,.35)" },
        { icon:"⚖️", title:"Expert Dispute Resolution", desc:"Our mediators review the evidence and provide a fast, fair resolution.", color:"rgba(239,68,68,.15)", bdr:"rgba(239,68,68,.35)" },
      ],
      tokenCards: [
        { icon:"🔒", title:"Funds Securely Held", desc:"All buyer payments are locked in EscaraPay's secure protected vault — inaccessible to either party until conditions are met.", color:"rgba(14,165,233,.12)", bdr:"rgba(14,165,233,.3)" },
        { icon:"✅", title:"Released After Approval", desc:"Payment is only released to the Seller after the Buyer confirms delivery and satisfaction. No disputes, no delays.", color:"rgba(5,150,105,.12)", bdr:"rgba(5,150,105,.3)" },
        { icon:"⚠️", title:"Dispute Protection", desc:"Raise a dispute within 7 days. Our expert mediators review evidence and ensure a fair, fast resolution for both parties.", color:"rgba(240,180,41,.12)", bdr:"rgba(240,180,41,.3)" },
      ],
    },
    hi: {
      heroTag: "भारत का भरोसेमंद पेमेंट प्रोटेक्शन प्लेटफॉर्म",
      heroH1a: "एस्करा पे",
      heroH1b: "RTO नुकसान रोकें और बिज़नेस बढ़ाएं।",
      heroDesc: "Escara Pay आपके हर ऑनलाइन लेनदेन को सुरक्षित बनाता है। हम buyer और seller दोनों के payments तब तक सुरक्षित रखते हैं जब तक delivery verify न हो — fraud मुक्त, भरोसेमंद।",
      ctaSeller: "सेलर लॉगिन",
      ctaBuyer: "बायर लॉगिन",
      howTitle: "एस्करा पे कैसे काम करता है?",
      whyTitle: "एस्करा पे क्यों चुनें?",
      whySub: "विश्वास के साथ व्यापार करें और बिना जोखिम के बढ़ें",
      tokenTitle: "टोकन होल्ड सिस्टम",
      tokenSub: "आपका पैसा हमेशा सुरक्षित है।",
      steps: [
        { num:"01", icon:"📝", title:"रजिस्टर करें और सहमत हों", desc:"दोनों पक्ष साइन अप करते हैं और कीमत व शर्तों पर सहमत होते हैं।" },
        { num:"02", icon:"🔗", title:"पेमेंट लिंक बनाएं", desc:"सेलर अपने डैशबोर्ड से सीधे एक सुरक्षित एस्करा पे ऑर्डर लिंक बनाता है।" },
        { num:"03", icon:"💬", title:"व्हाट्सऐप पर शेयर करें", desc:"लिंक तुरंत व्हाट्सऐप के जरिए बायर को भेजा जाता है।" },
        { num:"04", icon:"🔐", title:"सुरक्षित जमा", desc:"बायर लिंक खोलता है और फंड एस्करा पे के सुरक्षित vault में जमा करता है।" },
        { num:"05", icon:"🚚", title:"भेजें और ट्रैक करें", desc:"सेलर सामान डिलीवर करता है और ट्रैकिंग डिटेल्स देता है।" },
        { num:"06", icon:"✅", title:"जांचें और रिलीज करें", desc:"बायर की मंजूरी के बाद एस्करा पे सेलर को पेमेंट रिलीज करता है।" },
      ],
      benefits: [
        { icon:"🛡️", title:"ज़ीरो फ्रॉड रिस्क", desc:"'पेमेंट नहीं मिली' या 'आइटम नहीं भेजा' जैसे स्कैम का डर खत्म।", color:"rgba(14,165,233,.15)", bdr:"rgba(14,165,233,.35)" },
        { icon:"📦", title:"RTO सुरक्षा गारंटी", desc:"एस्करा पे फर्जी ऑर्डर रोकता है और आपका मार्जिन बचाता है।", color:"rgba(5,150,105,.15)", bdr:"rgba(5,150,105,.35)" },
        { icon:"⚡", title:"2 मिनट में सेटअप", desc:"हमारी streamlined process से सिर्फ 2 मिनट में पहला secure payment link बनाएं।", color:"rgba(240,180,41,.15)", bdr:"rgba(240,180,41,.35)" },
        { icon:"💬", title:"व्हाट्सऐप नेटिव", desc:"व्हाट्सऐप में सीधे ऑर्डर बनाएं, शेयर करें और ट्रैक करें।", color:"rgba(37,211,102,.15)", bdr:"rgba(37,211,102,.35)" },
        { icon:"🔒", title:"रेजरपे पावर्ड सिक्योरिटी", desc:"रेजरपे का इन्फ्रास्ट्रक्चर हर पेमेंट को एन्क्रिप्टेड और 100% सुरक्षित रखता है।", color:"rgba(124,58,237,.15)", bdr:"rgba(124,58,237,.35)" },
        { icon:"⚖️", title:"विशेषज्ञ विवाद समाधान", desc:"हमारे मध्यस्थ सबूत देखकर तेज़ और निष्पक्ष निर्णय देते हैं।", color:"rgba(239,68,68,.15)", bdr:"rgba(239,68,68,.35)" },
      ],
      tokenCards: [
        { icon:"🔒", title:"फंड सुरक्षित रखे जाते हैं", desc:"सभी बायर पेमेंट एस्करा पे के secure vault में lock रहते हैं जब तक शर्तें पूरी न हों।", color:"rgba(14,165,233,.12)", bdr:"rgba(14,165,233,.3)" },
        { icon:"✅", title:"मंजूरी के बाद रिलीज", desc:"बायर की पुष्टि के बाद ही सेलर को पेमेंट जाती है।", color:"rgba(5,150,105,.12)", bdr:"rgba(5,150,105,.3)" },
        { icon:"⚠️", title:"विवाद सुरक्षा", desc:"7 दिनों में विवाद उठाएं। हमारे विशेषज्ञ तेज़ और निष्पक्ष समाधान देते हैं।", color:"rgba(240,180,41,.12)", bdr:"rgba(240,180,41,.3)" },
      ],
    },
    hl: {
      heroTag: "India Ka Trusted Payment Protection Platform",
      heroH1a: "Escara Pay",
      heroH1b: "RTO Losses Rokein & Business Badhao.",
      heroDesc: "Escara Pay aapke har online transaction ko secure banata hai. Hum buyer aur seller dono ke payments tab tak safe rakhte hain jab tak delivery verify na ho — fraud-free, trustworthy.",
      ctaSeller: "Login as Seller",
      ctaBuyer: "Login as Buyer",
      howTitle: "Escara Pay Kaise Kaam Karta Hai?",
      whyTitle: "Escara Pay Kyun Choose Karein?",
      whySub: "Trade with Confidence & Grow Without Risk",
      tokenTitle: "Token Hold System",
      tokenSub: "Aapka paisa hamesha safe hai.",
      steps: [
        { num:"01", icon:"📝", title:"Register & Agree", desc:"Dono parties sign up karti hain aur price aur terms par agree karti hain." },
        { num:"02", icon:"🔗", title:"Generate Payment Link", desc:"Seller apne dashboard se seedha ek secure Escara Pay order link banata hai." },
        { num:"03", icon:"💬", title:"Share via WhatsApp", desc:"Link turant WhatsApp ke zariye Buyer ko bheja jaata hai." },
        { num:"04", icon:"🔐", title:"Secure Deposit", desc:"Buyer link kholkar funds Escara Pay ke secure vault mein pay karta hai." },
        { num:"05", icon:"🚚", title:"Ship & Track", desc:"Seller saamaan deliver karta hai aur tracking details deta hai." },
        { num:"06", icon:"✅", title:"Inspect & Release", desc:"Buyer ki approval ke baad Escara Pay Seller ko payment release karta hai." },
      ],
      benefits: [
        { icon:"🛡️", title:"Zero Fraud Risk", desc:"'Payment nahi mili' ya 'item nahi bheja' jaisi scams ka darr khatam.", color:"rgba(14,165,233,.15)", bdr:"rgba(14,165,233,.35)" },
        { icon:"📦", title:"Guaranteed RTO Protection", desc:"Escara Pay fake orders rokta hai aur aapka margin bachata hai.", color:"rgba(5,150,105,.15)", bdr:"rgba(5,150,105,.35)" },
        { icon:"⚡", title:"2-Minute Rapid Setup", desc:"Hamare streamlined process se sirf 2 minute mein pehla secure payment link banao.", color:"rgba(240,180,41,.15)", bdr:"rgba(240,180,41,.35)" },
        { icon:"💬", title:"WhatsApp-Native Experience", desc:"WhatsApp mein seedha orders banao, share karo aur track karo.", color:"rgba(37,211,102,.15)", bdr:"rgba(37,211,102,.35)" },
        { icon:"🔒", title:"Cashfree-Powered Security", desc:"Cashfree ka infrastructure har payment ko encrypted aur 100% secure rakhta hai.", color:"rgba(124,58,237,.15)", bdr:"rgba(124,58,237,.35)" },
        { icon:"⚖️", title:"Expert Dispute Resolution", desc:"Hamare mediators evidence dekhkar fast aur fair resolution dete hain.", color:"rgba(239,68,68,.15)", bdr:"rgba(239,68,68,.35)" },
      ],
      tokenCards: [
        { icon:"🔒", title:"Funds Securely Held", desc:"Saari buyer payments EscaraPay ke secure protected vault mein lock rehti hain — tab tak jab tak conditions meet na ho.", color:"rgba(14,165,233,.12)", bdr:"rgba(14,165,233,.3)" },
        { icon:"✅", title:"Buyer Approval ke Baad Release", desc:"Payment sirf tab Seller ko milti hai jab Buyer delivery confirm kare. Koi dispute, koi delay nahi.", color:"rgba(5,150,105,.12)", bdr:"rgba(5,150,105,.3)" },
        { icon:"⚠️", title:"Dispute Protection", desc:"7 din mein dispute raise karo. Hamare expert mediators evidence review karke fair aur fast resolution dete hain.", color:"rgba(240,180,41,.12)", bdr:"rgba(240,180,41,.3)" },
      ],
    },
  };

  const lc = LT[lang] || LT.hl;

  // ── Reset meta to homepage on landing ──
  useEffect(() => {
    updateMeta({
      title: "EscaraPay | WhatsApp Seller Payment Protection — Stop RTO & Fraud | India",
      description: "EscaraPay — India's #1 payment protection platform for WhatsApp & Instagram sellers. Stop RTO losses, prevent COD fraud, and protect every transaction with our token-based Safe Pay system. Free for first 100 sellers.",
      url: "https://www.escarapay.in/",
      image: "https://www.escarapay.in/og-image.png"
    });
  }, []);

  // ── Stats IntersectionObserver ──
  useEffect(() => {
    const el = document.getElementById("stats-section");
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setStatsStarted(true); io.disconnect(); }
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // ── Static content (no translation needed) ──
  const STATS = [
    { val:1200, suffix:"+", label: lang==="hi"?"ऑर्डर प्रोटेक्ट हुए": lang==="en"?"Orders Protected":"Orders Protected" },
    { val:98,   suffix:"%", label: lang==="hi"?"सफल डिलीवरी":lang==="en"?"Successful Deliveries":"Successful Deliveries" },
    { val:4,    suffix:" hr",label:lang==="hi"?"औसत विवाद समाधान":lang==="en"?"Avg Dispute Resolution":"Avg Dispute Resolution" },
    { val:500,  suffix:"K+",label:lang==="hi"?"₹ सुरक्षित रखे":lang==="en"?"₹ Secured":"₹ Secured" },
  ];

  const COMPARE = {
    head: lang==="hi"?["विकल्प","EscaraPay","Direct UPI","Cash on Delivery"]:["Option","EscaraPay","Direct UPI","Cash on Delivery"],
    rows: [
      { f: lang==="hi"?"फ्रॉड से सुरक्षा":lang==="en"?"Fraud Protection":"Fraud Protection",               a:"✅", b:"❌", c:"⚠️" },
      { f: lang==="hi"?"RTO सुरक्षा":lang==="en"?"RTO Protection":"RTO Protection",                         a:"✅", b:"❌", c:"❌" },
      { f: lang==="hi"?"टोकन होल्ड सिस्टम":lang==="en"?"Token Hold System":"Token Hold System",            a:"✅", b:"❌", c:"❌" },
      { f: lang==="hi"?"विवाद समाधान":lang==="en"?"Dispute Resolution":"Dispute Resolution",                a:"✅", b:"❌", c:"⚠️" },
      { f: lang==="hi"?"WhatsApp नेटिव":lang==="en"?"WhatsApp Native":"WhatsApp Native",                   a:"✅", b:"⚠️", c:"❌" },
      { f: lang==="hi"?"2 मिनट सेटअप":lang==="en"?"2-Min Setup":"2-Min Setup",                             a:"✅", b:"✅", c:"❌" },
      { f: lang==="hi"?"पेमेंट एनक्रिप्शन":lang==="en"?"Payment Encryption":"Payment Encryption",          a:"✅", b:"✅", c:"❌" },
    ],
  };

  const FAQS = lang==="hi" ? [
    { q:"EscaraPay पर न्यूनतम टोकन राशि क्या है?", a:"न्यूनतम टोकन ₹200 है। यह ऑर्डर वैल्यू का एक प्रतिशत होता है जो एस्क्रो में सुरक्षित रखा जाता है।" },
    { q:"अगर सेलर ने आइटम नहीं भेजा तो क्या होगा?", a:"अगर सेलर निर्धारित समय में आइटम नहीं भेजता, तो टोकन पूरी तरह बायर को वापस कर दिया जाएगा।" },
    { q:"टोकन का पैसा सेलर को कब मिलेगा?", a:"डिलीवरी की पुष्टि के बाद 7 दिनों में या जब बायर खुद कन्फर्म कर दे, तभी पैसा रिलीज होता है।" },
    { q:"क्या EscaraPay RBI से approved है?", a:"EscaraPay Cashfree के ज़रिए पेमेंट प्रोसेस करता है जो RBI-compliant और PCI DSS certified है।" },
    { q:"विवाद कैसे उठाएं?", a:"डिलीवरी के 7 दिनों के अंदर अपने डैशबोर्ड में जाकर 'Raise Dispute' बटन दबाएं। हमारी टीम 24 घंटे में जवाब देगी।" },
    { q:"क्या कोई hidden charges हैं?", a:"नहीं। केवल 2% Cashfree gateway fee है जो बायर को पेमेंट के समय दिखाई जाती है। कोई छुपी हुई फीस नहीं।" },
  ] : lang==="en" ? [
    { q:"What is the minimum token amount on EscaraPay?", a:"The minimum token is ₹200. It is a percentage of the order value that is held securely in our protected vault until delivery is confirmed." },
    { q:"What if the seller doesn't ship the item?", a:"If the seller fails to ship within the agreed time, the full token amount is automatically refunded to the buyer." },
    { q:"When does the seller receive the token payment?", a:"The payment is released to the seller within 7 days of delivery confirmation, or immediately when the buyer manually confirms receipt." },
    { q:"Is EscaraPay approved by RBI?", a:"EscaraPay processes payments via Cashfree, which is fully RBI-compliant and PCI DSS Level 1 certified, ensuring maximum security." },
    { q:"How do I raise a dispute?", a:"Within 7 days of delivery, go to your dashboard and click 'Raise Dispute'. Our team will investigate and respond within 24 hours." },
    { q:"Are there any hidden charges?", a:"No hidden charges. Only a 2% Cashfree gateway fee is applied, which is shown transparently at the time of payment." },
  ] : [
    { q:"EscaraPay pe minimum token kitna hota hai?", a:"Minimum token ₹200 hai. Yeh order value ka ek percentage hota hai jo delivery confirm hone tak protected vault mein safe rakha jaata hai." },
    { q:"Agar seller ne item nahi bheja toh kya hoga?", a:"Agar seller decided time mein item nahi bhejta, toh poora token amount buyer ko automatically wapas kar diya jaata hai." },
    { q:"Seller ko token payment kab milegi?", a:"Delivery confirmation ke 7 din ke andar, ya jab buyer khud confirm kare — tab payment seller ko release hoti hai." },
    { q:"Kya EscaraPay RBI se approved hai?", a:"EscaraPay Cashfree ke zariye payments process karta hai jo RBI-compliant aur PCI DSS Level 1 certified hai." },
    { q:"Dispute kaise raise karein?", a:"Delivery ke 7 din ke andar dashboard mein jaao aur 'Raise Dispute' button dabao. Hamari team 24 ghante mein jawab degi." },
    { q:"Koi hidden charges hain kya?", a:"Koi hidden charge nahi. Sirf 2% Cashfree gateway fee hai jo payment ke waqt clearly dikhti hai." },
  ];

  return (
    <div style={{minHeight:"100vh"}}>
      {/* ── NAV ── */}
      <nav className="nav">
        <Logo />
        <div style={{display:"flex",gap:5,alignItems:"center",flexShrink:0}}>
          <LangToggle lang={lang} onToggle={onLangToggle} />
          <ThemeToggle dark={dark} onToggle={onToggle} />
          <button className="btn-ghost" style={{padding:"7px 10px",fontSize:12,whiteSpace:"nowrap",color:"var(--muted)"}} onClick={onTrack}>
            📦 <span className="hide-m">Track</span>
          </button>
          {/* Desktop only — hide on mobile since hero CTA buttons are visible */}
          <button className="btn-ghost hide-m" style={{padding:"7px 10px",fontSize:12,whiteSpace:"nowrap"}} onClick={()=>onEnter("buyer")}>
            🛍️ {lc.ctaBuyer}
          </button>
          <button className="btn-gold hide-m" style={{padding:"7px 10px",fontSize:12,whiteSpace:"nowrap"}} onClick={()=>onEnter("seller")}>
            🏪 {lc.ctaSeller}
          </button>
        </div>
      </nav>

      {/* ── HERO ── */}
      <div style={{
        position:"relative",overflow:"hidden",
        background: dark
          ? "linear-gradient(160deg,#05080f 0%,#091525 40%,#0a0e1a 100%)"
          : "linear-gradient(160deg,#f0f8ff 0%,#e0f0ff 40%,#f5faff 100%)",
        padding:"clamp(70px,12vw,120px) clamp(16px,5vw,40px) clamp(80px,10vw,110px)",
        textAlign:"center"
      }}>
        {/* Animated background grid */}
        <div style={{
          position:"absolute",inset:0,
          backgroundImage: dark
            ? "radial-gradient(circle at 1px 1px, rgba(14,165,233,.08) 1px, transparent 0)"
            : "radial-gradient(circle at 1px 1px, rgba(14,165,233,.06) 1px, transparent 0)",
          backgroundSize:"40px 40px",
          pointerEvents:"none"
        }} />

        {/* Glowing orbs */}
        <div style={{position:"absolute",top:"-80px",left:"5%",width:500,height:500,borderRadius:"50%",background:"rgba(14,165,233,.06)",filter:"blur(90px)",pointerEvents:"none",animation:"glowPulse 6s ease-in-out infinite"}} />
        <div style={{position:"absolute",bottom:"-60px",right:"5%",width:400,height:400,borderRadius:"50%",background:"rgba(56,189,248,.05)",filter:"blur(80px)",pointerEvents:"none",animation:"glowPulse 8s ease-in-out infinite reverse"}} />
        <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:600,height:300,borderRadius:"50%",background:"rgba(14,165,233,.03)",filter:"blur(60px)",pointerEvents:"none"}} />

        {/* Live badge */}
        <div style={{animation:"slideUpFade .6s ease both",marginBottom:20}}>
          <span style={{
            display:"inline-flex",alignItems:"center",gap:8,
            background: dark?"rgba(14,165,233,.1)":"rgba(14,165,233,.08)",
            border:"1px solid rgba(14,165,233,.25)",
            borderRadius:100,padding:"7px 18px",
            fontSize:12,fontWeight:600,color:"var(--gold)",letterSpacing:".5px"
          }}>
            <span style={{
              width:8,height:8,borderRadius:"50%",background:"#22c55e",display:"inline-block",
              boxShadow:"0 0 0 3px rgba(34,197,94,.2)",animation:"dotPulse 1.5s ease-in-out infinite"
            }} />
            {lc.heroTag}
          </span>
        </div>

        {/* H1 with typewriter */}
        <h1 className="syne" style={{
          fontSize:"clamp(38px,6.5vw,80px)",fontWeight:800,lineHeight:1.05,
          marginBottom:16,letterSpacing:"-2px",
          animation:"slideUpFade .7s .1s ease both"
        }}>
          <span className="shimmer">{lc.heroH1a}</span>
        </h1>

        {/* Typewriter subtitle */}
        <h2 className="syne" style={{
          fontSize:"clamp(18px,3vw,32px)",fontWeight:700,lineHeight:1.3,marginBottom:10,
          color: dark?"rgba(255,255,255,.9)":"rgba(12,35,64,.85)",
          animation:"slideUpFade .7s .2s ease both"
        }}>
          {lang==="en" ? (
            <>Stop <TypeWriter words={["RTO Losses","Fake Orders","Payment Fraud","Buyer Disputes"]} dark={dark} /> Forever</>
          ) : lang==="hi" ? (
            <>रोकें <TypeWriter words={["RTO नुकसान","फेक ऑर्डर","पेमेंट फ्रॉड"]} dark={dark} /> हमेशा के लिए</>
          ) : (
            <>Rokein <TypeWriter words={["RTO Loss","Fake Orders","Payment Fraud","Buyer Disputes"]} dark={dark} /> Hamesha</>
          )}
        </h2>

        <p style={{
          color:"var(--muted)",fontSize:"clamp(14px,1.6vw,17px)",
          maxWidth:540,margin:"0 auto 40px",lineHeight:1.8,
          animation:"slideUpFade .7s .3s ease both"
        }}>
          {lc.heroDesc}
        </p>

        {/* CTA Buttons */}
        <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap",marginBottom:48,animation:"slideUpFade .7s .4s ease both"}}>
          <button
            className="btn-gold"
            style={{
              fontSize:15,padding:"15px 40px",borderRadius:14,letterSpacing:".3px",
              boxShadow:"0 8px 32px rgba(14,165,233,.35)",
              animation:"pulseCyan 2.5s infinite"
            }}
            onClick={()=>onEnter("seller")}
          >
            🏪 {lc.ctaSeller}
          </button>
          <button
            className="btn-outline"
            style={{fontSize:15,padding:"14px 40px",borderRadius:14,letterSpacing:".3px"}}
            onClick={()=>onEnter("buyer")}
          >
            🛍️ {lc.ctaBuyer}
          </button>
        </div>

        {/* Trust chips — staggered animation */}
        <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
          {[
            {icon:"🔒",text:"Cashfree Secured",delay:".5s"},
            {icon:"🛡️",text:"Payment Protected",delay:".6s"},
            {icon:"⚡",text:"RBI Compliant",delay:".7s"},
            {icon:"✅",text:"2-Min Setup",delay:".8s"},
            {icon:"🏆",text:"MSME Registered",delay:".9s"},
          ].map(chip=>(
            <span key={chip.text} style={{
              display:"inline-flex",alignItems:"center",gap:6,
              background: dark?"rgba(255,255,255,.04)":"rgba(14,165,233,.06)",
              border:"1px solid",
              borderColor: dark?"rgba(255,255,255,.08)":"rgba(14,165,233,.15)",
              borderRadius:100,padding:"6px 14px",
              fontSize:11,fontWeight:600,color:"var(--muted)",
              animation:`chipFadeIn .5s ${chip.delay} ease both`,
              backdropFilter:"blur(8px)",
              transition:"all .2s"
            }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor="rgba(14,165,233,.4)";e.currentTarget.style.color="var(--gold)";e.currentTarget.style.background=dark?"rgba(14,165,233,.1)":"rgba(14,165,233,.1)";}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=dark?"rgba(255,255,255,.08)":"rgba(14,165,233,.15)";e.currentTarget.style.color="var(--muted)";e.currentTarget.style.background=dark?"rgba(255,255,255,.04)":"rgba(14,165,233,.06)";}}
            >
              {chip.icon} {chip.text}
            </span>
          ))}
        </div>
      </div>

      {/* ── RTO LOSS CALCULATOR ── */}
      <RTOCalculator onEnter={onEnter} />

      {/* ── HOW IT WORKS ── */}
      <div id="how-it-works" style={{padding:"80px clamp(16px,5vw,40px)",background:"var(--surface)"}}>
        <div className="reveal" style={{textAlign:"center",marginBottom:52}}>
          <span style={{
            display:"inline-block",background:"rgba(14,165,233,.1)",
            border:"1px solid rgba(14,165,233,.2)",borderRadius:100,
            padding:"4px 16px",fontSize:11,fontWeight:700,color:"var(--gold)",
            letterSpacing:"2px",textTransform:"uppercase",marginBottom:14
          }}>PROCESS</span>
          <h2 className="syne" style={{fontSize:"clamp(26px,3.5vw,44px)",fontWeight:800,marginBottom:14,letterSpacing:"-0.5px"}}>
            {lc.howTitle}
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:480,margin:"0 auto",lineHeight:1.6}}>
            {lang==="hi"?"सरल, सुरक्षित, और तेज़ — बस 6 स्टेप्स में।":"Simple, secure, and fast — in just 6 steps."}
          </p>
        </div>

        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",
          gap:20,maxWidth:980,margin:"0 auto"
        }}>
          {lc.steps.map((step,i)=>(
            <div key={step.num} className="card" style={{
              padding:"26px 22px",
              background: dark?"var(--surface)":"#fff",
              position:"relative",overflow:"hidden",
              transition:"transform .25s,box-shadow .25s,border-color .25s",
              cursor:"default"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 16px 40px rgba(14,165,233,.12)";e.currentTarget.style.borderColor="rgba(14,165,233,.35)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";e.currentTarget.style.borderColor="var(--border)";}}
            >
              {/* Step number accent */}
              <div style={{
                position:"absolute",top:14,right:16,
                fontFamily:"'Outfit',sans-serif",fontWeight:800,fontSize:32,
                color: dark?"rgba(255,255,255,.04)":"rgba(14,165,233,.06)",
                lineHeight:1,userSelect:"none"
              }}>{step.num}</div>

              <div style={{
                width:46,height:46,borderRadius:12,marginBottom:16,
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,
                background: i%2===0
                  ? dark?"rgba(14,165,233,.15)":"rgba(14,165,233,.1)"
                  : dark?"rgba(56,189,248,.12)":"rgba(56,189,248,.1)",
                border:`1px solid ${i%2===0?"rgba(14,165,233,.25)":"rgba(56,189,248,.2)"}`,
              }}>
                {step.icon}
              </div>

              <div style={{
                display:"inline-block",
                background:"rgba(14,165,233,.12)",border:"1px solid rgba(14,165,233,.25)",
                borderRadius:100,padding:"2px 10px",fontSize:10,fontWeight:700,
                color:"var(--gold)",letterSpacing:"1px",textTransform:"uppercase",marginBottom:10
              }}>Step {step.num}</div>

              <h3 className="syne" style={{fontWeight:700,fontSize:16,marginBottom:8,lineHeight:1.3}}>
                {step.title}
              </h3>
              <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.7,margin:0}}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ── WHY CHOOSE ── */}
      <div style={{padding:"80px clamp(16px,5vw,40px)",background:"var(--sf2)"}}>
        <div className="reveal" style={{textAlign:"center",marginBottom:52}}>
          <p style={{fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10}}>BENEFITS</p>
          <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,40px)",fontWeight:800,marginBottom:12,letterSpacing:"-0.5px"}}>
            {lc.whyTitle}
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:460,margin:"0 auto",lineHeight:1.6}}>
            {lc.whySub}
          </p>
        </div>

        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(270px,1fr))",
          gap:18,maxWidth:980,margin:"0 auto"
        }}>
          {lc.benefits.map(b=>(
            <div key={b.title} className="card" style={{
              background:b.color,borderColor:b.bdr,
              padding:"26px 22px",
              transition:"transform .25s,box-shadow .25s",cursor:"default"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 14px 36px rgba(0,0,0,.1)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={{
                width:48,height:48,borderRadius:14,marginBottom:16,
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,
                background: dark?"rgba(0,0,0,.2)":"rgba(255,255,255,.6)",
                border:`1px solid ${b.bdr}`,
              }}>
                {b.icon}
              </div>
              <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:8,lineHeight:1.3}}>
                {b.title}
              </h3>
              <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.7,margin:0}}>
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ── TOKEN HOLD SYSTEM ── */}
      <div style={{padding:"70px clamp(16px,5vw,40px)",background:"var(--surface)"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <p style={{fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10}}>SECURITY</p>
          <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,40px)",fontWeight:800,marginBottom:12,letterSpacing:"-0.5px"}}>
            {lc.tokenTitle}
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:440,margin:"0 auto",lineHeight:1.6}}>
            {lc.tokenSub}
          </p>
        </div>

        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(270px,1fr))",
          gap:20,maxWidth:900,margin:"0 auto 44px"
        }}>
          {lc.tokenCards.map(card=>(
            <div key={card.title} className="card" style={{
              background:card.color,borderColor:card.bdr,
              padding:"30px 24px",textAlign:"center",
              transition:"transform .25s,box-shadow .25s"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 14px 36px rgba(0,0,0,.1)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={{
                width:56,height:56,borderRadius:16,margin:"0 auto 18px",
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,
                background: dark?"rgba(0,0,0,.2)":"rgba(255,255,255,.65)",
                border:`1px solid ${card.bdr}`,
              }}>
                {card.icon}
              </div>
              <h3 className="syne" style={{fontWeight:700,fontSize:16,marginBottom:10,lineHeight:1.3}}>
                {card.title}
              </h3>
              <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.75,margin:0}}>
                {card.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Row inside token section */}
        <div style={{textAlign:"center"}}>
          <div style={{
            display:"inline-flex",flexDirection:"column",alignItems:"center",gap:16,
            background: dark?"rgba(14,165,233,.06)":"rgba(14,165,233,.05)",
            border:"1px solid rgba(14,165,233,.2)",borderRadius:20,
            padding:"32px 40px",maxWidth:480,width:"100%"
          }}>
            <div style={{fontSize:36}}>🚀</div>
            <div className="syne" style={{fontWeight:800,fontSize:20,lineHeight:1.3}}>
              {lang==="hi"?"आज ही शुरू करें!":lang==="en"?"Start for Free Today!":"Aaj Hi Shuru Karo!"}
            </div>
            <p style={{color:"var(--muted)",fontSize:13,lineHeight:1.6,margin:0}}>
              {lang==="hi"?"EscaraPay के साथ हर डील सुरक्षित बनाएं।":lang==="en"?"Make every deal safe with EscaraPay.":"EscaraPay ke saath har deal safe banao."}
            </p>
            <div style={{display:"flex",gap:10,flexWrap:"wrap",justifyContent:"center"}}>
              <button className="btn-gold pulse" style={{padding:"12px 28px",fontSize:14}} onClick={()=>onEnter("seller")}>🏪 {lc.ctaSeller}</button>
              <button className="btn-outline" style={{padding:"11px 28px",fontSize:14}} onClick={()=>onEnter("buyer")}>🛍️ {lc.ctaBuyer}</button>
            </div>
          </div>
        </div>
      </div>

      {/* ══ TOKEN RELEASE — 3 CONDITIONS ══ */}
      <div className="reveal" style={{padding:"80px clamp(16px,5vw,40px)",background:"var(--sf2)"}}>
        <div style={{maxWidth:960,margin:"0 auto"}}>
          {/* Header */}
          <div style={{textAlign:"center",marginBottom:56}}>
            <p style={{fontSize:11,fontWeight:700,color:"var(--gold)",letterSpacing:"2.5px",textTransform:"uppercase",marginBottom:12}}>
              {lang==="hi"?"टोकन रिलीज सिस्टम":lang==="en"?"TOKEN RELEASE SYSTEM":"TOKEN RELEASE SYSTEM"}
            </p>
            <h2 className="syne" style={{fontSize:"clamp(26px,3.8vw,44px)",fontWeight:800,marginBottom:14,letterSpacing:"-0.8px",lineHeight:1.15}}>
              {lang==="hi"?"टोकन कब किसे मिलेगा?":lang==="en"?"When & Who Gets the Token?":"Token Kab Kisko Milega?"}
            </h2>
            <p style={{color:"var(--muted)",fontSize:15,maxWidth:480,margin:"0 auto",lineHeight:1.7}}>
              {lang==="hi"?"हर scenario में EscaraPay सही फैसला करता है — ऑटोमेटिक और फेयर।"
               :lang==="en"?"In every scenario, EscaraPay makes the right call — automatic and fair."
               :"Har scenario mein EscaraPay sahi faisla karta hai — automatic aur fair."}
            </p>
          </div>

          {/* 3 Condition Cards */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:24,marginBottom:48}}>

            {/* Card 1 — Successful Delivery → Seller */}
            <div className="reveal" style={{
              borderRadius:20,overflow:"hidden",
              border:`2px solid rgba(16,185,129,.35)`,
              background: dark?"rgba(16,185,129,.06)":"rgba(16,185,129,.05)",
              transition:"transform .3s,box-shadow .3s",cursor:"default"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-6px)";e.currentTarget.style.boxShadow="0 24px 60px rgba(16,185,129,.15)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
            >
              {/* Top accent bar */}
              <div style={{height:4,background:"linear-gradient(90deg,#10B981,#34D399)"}} />
              <div style={{padding:"28px 26px"}}>
                {/* Icon */}
                <div style={{
                  width:60,height:60,borderRadius:18,marginBottom:20,
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,
                  background:"rgba(16,185,129,.15)",border:"1px solid rgba(16,185,129,.3)"
                }}>✅</div>
                {/* Condition label */}
                <div style={{
                  display:"inline-block",background:"rgba(16,185,129,.15)",
                  border:"1px solid rgba(16,185,129,.3)",borderRadius:100,
                  padding:"3px 12px",fontSize:11,fontWeight:700,color:"var(--green)",
                  letterSpacing:"1px",textTransform:"uppercase",marginBottom:14
                }}>
                  {lang==="hi"?"स्थिति 1":lang==="en"?"Condition 1":"Condition 1"}
                </div>
                <h3 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:10,lineHeight:1.25,color:"var(--text)"}}>
                  {lang==="hi"?"डिलीवरी सफल रही":lang==="en"?"Successful Delivery":"Delivery Successful Hui"}
                </h3>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.8,marginBottom:20}}>
                  {lang==="hi"?"बायर ने डिलीवरी कन्फर्म कर दी या 7 दिन बिना विवाद के बीत गए।"
                   :lang==="en"?"Buyer confirms delivery, or 7 days pass without a dispute."
                   :"Buyer ne delivery confirm kar di ya 7 din bina dispute ke beet gaye."}
                </p>
                {/* Result arrow */}
                <div style={{
                  display:"flex",alignItems:"center",gap:12,
                  background:"rgba(16,185,129,.1)",border:"1px solid rgba(16,185,129,.25)",
                  borderRadius:12,padding:"14px 16px"
                }}>
                  <div style={{fontSize:20}}>🏪</div>
                  <div>
                    <div style={{fontSize:11,color:"var(--muted)",fontWeight:600,letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:2}}>
                      {lang==="hi"?"टोकन जाता है":lang==="en"?"Token Goes To":"Token Jaata Hai"}
                    </div>
                    <div className="syne" style={{fontWeight:800,fontSize:16,color:"var(--green)"}}>
                      {lang==="hi"?"→ सेलर को ✓":lang==="en"?"→ Seller ✓":"→ Seller ko ✓"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 — Fraud Seller / Not Shipped → Buyer */}
            <div className="reveal" style={{
              borderRadius:20,overflow:"hidden",
              border:`2px solid rgba(239,68,68,.35)`,
              background: dark?"rgba(239,68,68,.05)":"rgba(239,68,68,.04)",
              transition:"transform .3s,box-shadow .3s",cursor:"default"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-6px)";e.currentTarget.style.boxShadow="0 24px 60px rgba(239,68,68,.12)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={{height:4,background:"linear-gradient(90deg,#EF4444,#F87171)"}} />
              <div style={{padding:"28px 26px"}}>
                <div style={{
                  width:60,height:60,borderRadius:18,marginBottom:20,
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,
                  background:"rgba(239,68,68,.15)",border:"1px solid rgba(239,68,68,.3)"
                }}>🚨</div>
                <div style={{
                  display:"inline-block",background:"rgba(239,68,68,.12)",
                  border:"1px solid rgba(239,68,68,.3)",borderRadius:100,
                  padding:"3px 12px",fontSize:11,fontWeight:700,color:"var(--red)",
                  letterSpacing:"1px",textTransform:"uppercase",marginBottom:14
                }}>
                  {lang==="hi"?"स्थिति 2":lang==="en"?"Condition 2":"Condition 2"}
                </div>
                <h3 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:10,lineHeight:1.25,color:"var(--text)"}}>
                  {lang==="hi"?"सेलर ने डिलीवर नहीं किया":lang==="en"?"Seller Didn't Deliver":"Seller Ne Deliver Nahi Kiya"}
                </h3>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.8,marginBottom:20}}>
                  {lang==="hi"?"सेलर ने आइटम नहीं भेजा, या फ्रॉड सेलर निकला — बायर ने dispute raise किया।"
                   :lang==="en"?"Seller failed to ship, or turned out to be fraudulent — buyer raised a dispute."
                   :"Seller ne item nahi bheja, ya fraud seller nikla — buyer ne dispute raise kiya."}
                </p>
                <div style={{
                  display:"flex",alignItems:"center",gap:12,
                  background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",
                  borderRadius:12,padding:"14px 16px"
                }}>
                  <div style={{fontSize:20}}>🛍️</div>
                  <div>
                    <div style={{fontSize:11,color:"var(--muted)",fontWeight:600,letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:2}}>
                      {lang==="hi"?"टोकन जाता है":lang==="en"?"Token Goes To":"Token Jaata Hai"}
                    </div>
                    <div className="syne" style={{fontWeight:800,fontSize:16,color:"var(--red)"}}>
                      {lang==="hi"?"→ बायर को (Refund) ✓":lang==="en"?"→ Buyer (Full Refund) ✓":"→ Buyer ko (Refund) ✓"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 — Buyer Cancels After Dispatch → Seller (RTO) */}
            <div className="reveal" style={{
              borderRadius:20,overflow:"hidden",
              border:`2px solid rgba(36,161,226,.35)`,
              background: dark?"rgba(36,161,226,.06)":"rgba(36,161,226,.05)",
              transition:"transform .3s,box-shadow .3s",cursor:"default"
            }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-6px)";e.currentTarget.style.boxShadow="0 24px 60px rgba(36,161,226,.12)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={{height:4,background:"linear-gradient(90deg,#24A1E2,#4BB3E9)"}} />
              <div style={{padding:"28px 26px"}}>
                <div style={{
                  width:60,height:60,borderRadius:18,marginBottom:20,
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,
                  background:"rgba(36,161,226,.15)",border:"1px solid rgba(36,161,226,.3)"
                }}>📦</div>
                <div style={{
                  display:"inline-block",background:"rgba(36,161,226,.12)",
                  border:"1px solid rgba(36,161,226,.3)",borderRadius:100,
                  padding:"3px 12px",fontSize:11,fontWeight:700,color:"var(--gold)",
                  letterSpacing:"1px",textTransform:"uppercase",marginBottom:14
                }}>
                  {lang==="hi"?"स्थिति 3":lang==="en"?"Condition 3":"Condition 3"}
                </div>
                <h3 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:10,lineHeight:1.25,color:"var(--text)"}}>
                  {lang==="hi"?"बायर ने Dispatch के बाद Cancel किया":lang==="en"?"Buyer Cancels After Dispatch":"Buyer Ne Dispatch Ke Baad Cancel Kiya"}
                </h3>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.8,marginBottom:20}}>
                  {lang==="hi"?"सेलर ने माल भेज दिया, लेकिन बायर ने बीच में cancel कर दिया (RTO)।"
                   :lang==="en"?"Seller already shipped the item, but buyer cancelled mid-way causing an RTO."
                   :"Seller ne maal bhej diya, lekin buyer ne beech mein cancel kar diya — RTO hua."}
                </p>
                <div style={{
                  display:"flex",alignItems:"center",gap:12,
                  background:"rgba(36,161,226,.1)",border:"1px solid rgba(36,161,226,.2)",
                  borderRadius:12,padding:"14px 16px"
                }}>
                  <div style={{fontSize:20}}>🏪</div>
                  <div>
                    <div style={{fontSize:11,color:"var(--muted)",fontWeight:600,letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:2}}>
                      {lang==="hi"?"टोकन जाता है":lang==="en"?"Token Goes To":"Token Jaata Hai"}
                    </div>
                    <div className="syne" style={{fontWeight:800,fontSize:16,color:"var(--gold)"}}>
                      {lang==="hi"?"→ सेलर को (RTO Cover) ✓":lang==="en"?"→ Seller (RTO Cover) ✓":"→ Seller ko (RTO Cover) ✓"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom guarantee strip */}
          <div style={{
            background: dark
              ? "linear-gradient(135deg,rgba(36,161,226,.1),rgba(74,28,129,.1))"
              : "linear-gradient(135deg,rgba(36,161,226,.07),rgba(74,28,129,.06))",
            border:"1px solid rgba(36,161,226,.2)",borderRadius:16,
            padding:"22px 28px",
            display:"flex",alignItems:"center",gap:16,flexWrap:"wrap",justifyContent:"center",
            textAlign:"center"
          }}>
            <span style={{fontSize:28}}>🛡️</span>
            <div>
              <div className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>
                {lang==="hi"?"EscaraPay Guarantee":lang==="en"?"EscaraPay Guarantee":"EscaraPay Guarantee"}
              </div>
              <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.6}}>
                {lang==="hi"?"हमारी टीम हर dispute को 24 घंटे में review करती है और सबूत के आधार पर fair decision देती है।"
                 :lang==="en"?"Our team reviews every dispute within 24 hours and delivers a fair, evidence-based decision."
                 :"Hamari team har dispute ko 24 ghante mein review karti hai aur fair decision deti hai."}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="reveal" style={{padding:"70px clamp(16px,5vw,40px)",background:"var(--sf2)"}}>
        <div style={{maxWidth:860,margin:"0 auto"}}>
          {/* Top label */}
          <div style={{textAlign:"center",marginBottom:48}}>
            <p style={{fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10}}>EARLY ACCESS</p>
            <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,40px)",fontWeight:800,marginBottom:14,letterSpacing:"-0.5px"}}>
              {lang==="hi"?"पहले 100 में शामिल हों":lang==="en"?"Join Our First 100 Sellers":"Pehle 100 Sellers Mein Shaamil Ho"}
            </h2>
            <p style={{color:"var(--muted)",fontSize:15,maxWidth:500,margin:"0 auto",lineHeight:1.7}}>
              {lang==="hi"?"EscaraPay अभी launch हो रहा है। पहले 100 sellers को lifetime benefits मिलेंगे।"
               :lang==="en"?"EscaraPay is just launching. Our first 100 sellers get exclusive lifetime benefits."
               :"EscaraPay abhi launch ho raha hai. Pehle 100 sellers ko exclusive lifetime benefits milenge."}
            </p>
          </div>

          {/* Benefits grid */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:18,marginBottom:44}}>
            {[
              { icon:"🎯", color:"rgba(36,161,226,.15)", bdr:"rgba(36,161,226,.3)",
                title: lang==="hi"?"ज़ीरो प्लेटफॉर्म फीस":lang==="en"?"Zero Platform Fee":"Zero Platform Fee",
                desc: lang==="hi"?"पहले 100 sellers के लिए हमारी platform fee बिल्कुल माफ।":lang==="en"?"Our platform fee is completely waived for the first 100 sellers.":"Pehle 100 sellers ke liye hamaari platform fee bilkul maaf." },
              { icon:"⚡", color:"rgba(74,28,129,.15)", bdr:"rgba(74,28,129,.3)",
                title: lang==="hi"?"प्रायोरिटी सपोर्ट":lang==="en"?"Priority Support":"Priority Support",
                desc: lang==="hi"?"Early sellers को 24/7 dedicated support मिलेगी — कोई भी समस्या तुरंत सुलझेगी।":lang==="en"?"Early sellers get dedicated 24/7 support — every issue resolved instantly.":"Early sellers ko 24/7 dedicated support milegi — koi bhi problem turant suljhegi." },
              { icon:"🔒", color:"rgba(16,185,129,.15)", bdr:"rgba(16,185,129,.3)",
                title: lang==="hi"?"Cashfree सिक्योर पेमेंट":lang==="en"?"Cashfree Secured":"Cashfree Secured",
                desc: lang==="hi"?"हर पेमेंट RBI-compliant Cashfree से secure है — आपका और buyer का पैसा safe.":lang==="en"?"Every payment secured via RBI-compliant Cashfree — your money, always safe.":"Har payment RBI-compliant Cashfree se secure hai — aapka aur buyer ka paisa safe." },
              { icon:"📊", color:"rgba(240,180,41,.12)", bdr:"rgba(240,180,41,.3)",
                title: lang==="hi"?"फीडबैक से प्लेटफॉर्म शेप करें":lang==="en"?"Shape the Platform":"Platform Shape Karo",
                desc: lang==="hi"?"Early users के suggestions से ही हम features बनाएंगे। आपकी आवाज़ सुनी जाएगी।":lang==="en"?"We build features based on early user feedback. Your voice matters here.":"Early users ke suggestions se hi hum features banayenge. Aapki awaaz suni jayegi." },
            ].map((b,i)=>(
              <div key={i} className="card reveal" style={{
                background:b.color,borderColor:b.bdr,padding:"24px 22px",
                transition:"transform .25s,box-shadow .25s",
              }}
                onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 14px 36px rgba(0,0,0,.1)";}}
                onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}
              >
                <div style={{fontSize:28,marginBottom:12}}>{b.icon}</div>
                <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:8}}>{b.title}</h3>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.75,margin:0}}>{b.desc}</p>
              </div>
            ))}
          </div>

          {/* Slots counter */}
          <div style={{
            background: dark?"rgba(36,161,226,.07)":"rgba(36,161,226,.05)",
            border:"1px solid rgba(36,161,226,.2)",
            borderRadius:20,padding:"32px 28px",textAlign:"center"
          }}>
            <div style={{
              display:"inline-flex",alignItems:"center",gap:8,
              background:"rgba(36,161,226,.12)",border:"1px solid rgba(36,161,226,.25)",
              borderRadius:100,padding:"6px 16px",marginBottom:18,
              fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"1px",textTransform:"uppercase"
            }}>
              <span style={{width:7,height:7,borderRadius:"50%",background:"var(--green)",display:"inline-block",animation:"dotPulse 1.5s ease-in-out infinite"}}/>
              {lang==="hi"?"अभी लाइव हो रहा है":lang==="en"?"Now Live":"Abhi Live Ho Raha Hai"}
            </div>
            <h3 className="syne" style={{fontWeight:800,fontSize:"clamp(20px,3vw,30px)",marginBottom:10,letterSpacing:"-0.5px"}}>
              {lang==="hi"?"सीमित Early Access Slots":lang==="en"?"Limited Early Access Slots":"Limited Early Access Slots"}
            </h3>
            <p style={{color:"var(--muted)",fontSize:14,marginBottom:24,lineHeight:1.7,maxWidth:400,margin:"0 auto 24px"}}>
              {lang==="hi"?"अभी register करें और India ke top payment protection platform का हिस्सा बनें।"
               :lang==="en"?"Register now and be part of India's most trusted payment protection platform."
               :"Abhi register karo aur India ke top payment protection platform ka hissa bano."}
            </p>
            <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
              <button className="btn-gold pulse" style={{fontSize:15,padding:"13px 36px",borderRadius:12}} onClick={()=>onEnter("seller")}>
                🏪 {lc.ctaSeller}
              </button>
              <button className="btn-outline" style={{fontSize:15,padding:"12px 36px",borderRadius:12}} onClick={()=>onEnter("buyer")}>
                🛍️ {lc.ctaBuyer}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── COMPARISON TABLE ── */}
      <div className="reveal" style={{padding:"70px clamp(16px,5vw,40px)",background:"var(--surface)"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <p style={{fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10}}>COMPARISON</p>
          <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,40px)",fontWeight:800,marginBottom:12,letterSpacing:"-0.5px"}}>
            {lang==="hi"?"EscaraPay vs बाकी तरीके":lang==="en"?"EscaraPay vs Other Methods":"EscaraPay vs Baaki Tarike"}
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:440,margin:"0 auto",lineHeight:1.6}}>
            {lang==="hi"?"देखो क्यों EscaraPay सबसे आगे है":lang==="en"?"See why EscaraPay leads the way":"Dekho kyun EscaraPay sabse aage hai"}
          </p>
        </div>
        <div style={{maxWidth:780,margin:"0 auto",overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"separate",borderSpacing:0}}>
            <thead>
              <tr>
                {COMPARE.head.map((h,i)=>(
                  <th key={i} style={{
                    padding:"14px 18px",
                    textAlign: i===0?"left":"center",
                    fontSize:13,fontFamily:"'Outfit',sans-serif",fontWeight:700,
                    background: i===1
                      ? "linear-gradient(135deg,rgba(14,165,233,.2),rgba(56,189,248,.15))"
                      : "var(--sf2)",
                    color: i===1?"var(--gold)":"var(--muted)",
                    borderBottom:"2px solid var(--border)",
                    borderTop:"1px solid var(--border)",
                    borderLeft: i===0?"1px solid var(--border)":"none",
                    borderRight:"1px solid var(--border)",
                    borderRadius: i===0?"12px 0 0 0":i===COMPARE.head.length-1?"0 12px 0 0":"0",
                    position:"relative"
                  }}>
                    {i===1 && (
                      <div style={{position:"absolute",top:-1,left:"50%",transform:"translateX(-50%)",background:"var(--gold)",color:dark?"#000":"#fff",fontSize:9,fontWeight:800,padding:"2px 10px",borderRadius:100,whiteSpace:"nowrap",letterSpacing:"1px"}}>
                        ⭐ BEST
                      </div>
                    )}
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {COMPARE.rows.map((row,ri)=>(
                <tr key={ri}>
                  <td style={{padding:"13px 18px",fontSize:13,fontWeight:500,background:"var(--sf2)",borderBottom:"1px solid var(--border)",borderLeft:"1px solid var(--border)",borderRight:"1px solid var(--border)",color:"var(--text)"}}>{row.f}</td>
                  <td style={{padding:"13px 18px",textAlign:"center",fontSize:16,background:dark?"rgba(14,165,233,.07)":"rgba(14,165,233,.04)",borderBottom:"1px solid rgba(14,165,233,.15)",borderRight:"1px solid var(--border)"}}>{row.a}</td>
                  <td style={{padding:"13px 18px",textAlign:"center",fontSize:16,background:"var(--surface)",borderBottom:"1px solid var(--border)",borderRight:"1px solid var(--border)"}}>{row.b}</td>
                  <td style={{padding:"13px 18px",textAlign:"center",fontSize:16,background:"var(--surface)",borderBottom:"1px solid var(--border)",borderRight:"1px solid var(--border)"}}>{row.c}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{marginTop:10,fontSize:11,color:"var(--muted)",textAlign:"center"}}>
            ✅ = {lang==="hi"?"पूरी तरह":lang==="en"?"Fully Supported":"Fully Supported"} &nbsp;⚠️ = {lang==="hi"?"आंशिक":lang==="en"?"Partial":"Partial"} &nbsp;❌ = {lang==="hi"?"नहीं":lang==="en"?"Not Available":"Not Available"}
          </div>
        </div>
      </div>

      {/* ── ECOMMERCE INTEGRATION SECTION ── */}
      <div className="reveal" style={{padding:"80px clamp(16px,5vw,40px)",background:"var(--surface)"}}>
        <div style={{maxWidth:1060,margin:"0 auto"}}>
          {/* Header */}
          <div style={{textAlign:"center",marginBottom:52}}>
            <span style={{
              display:"inline-block",background:"rgba(14,165,233,.1)",
              border:"1px solid rgba(14,165,233,.2)",borderRadius:100,
              padding:"4px 16px",fontSize:11,fontWeight:700,color:"var(--gold)",
              letterSpacing:"2px",textTransform:"uppercase",marginBottom:14
            }}>ECOMMERCE INTEGRATION</span>
            <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,42px)",fontWeight:800,marginBottom:14,letterSpacing:"-0.5px"}}>
              {lang==="hi"
                ? <>🏪 अपने ऑनलाइन स्टोर को<br/>EscaraPay से जोड़ें</>
                : lang==="en"
                  ? <>🏪 Connect Your Online Store<br/>to EscaraPay</>
                  : <>🏪 Apne Online Store ko<br/>EscaraPay se Jodo</>}
            </h2>
            <p style={{color:"var(--muted)",fontSize:15,maxWidth:520,margin:"0 auto",lineHeight:1.7}}>
              {lang==="hi"
                ? <>Shopify, Wix, WooCommerce, या कोई भी वेबसाइट — <strong>एक लाइन का कोड</strong> add करें और सभी COD orders automatically protect होंगे।</>
                : lang==="en"
                  ? <>Shopify, Wix, WooCommerce, or any website — add <strong>one line of code</strong> and every COD order gets automatically protected.</>
                  : <>Shopify, Wix, WooCommerce, ya koi bhi website — <strong>ek line ka code</strong> add karo aur sab COD orders automatically protect ho jayenge.</>}
            </p>
          </div>

          {/* How it works — 3 steps */}
          {(()=>{
            const steps = lang==="hi"
              ? [
                  { step:"01", icon:"🛒", title:"Buyer COD Order Karta Hai", desc:"Buyer aapke Shopify ya Wix store pe COD select karta hai aur order place karta hai." },
                  { step:"02", icon:"⚡", title:"EscaraPay Auto-Create", desc:"Milliseconds mein order aapke EscaraPay dashboard mein aa jaata hai — koi manual kaam nahi." },
                  { step:"03", icon:"💳", title:"Buyer Token Pay Karta Hai", desc:"Buyer ko turant email aata hai token pay karne ka. Token pay hone ke baad dispatch karo." },
                ]
              : lang==="en"
              ? [
                  { step:"01", icon:"🛒", title:"Buyer Places COD Order", desc:"Buyer selects COD on your Shopify or Wix store and places the order normally." },
                  { step:"02", icon:"⚡", title:"EscaraPay Auto-Creates", desc:"In milliseconds, the order appears in your EscaraPay dashboard — zero manual work." },
                  { step:"03", icon:"💳", title:"Buyer Pays Token", desc:"Buyer instantly receives a token payment email. Dispatch only after token is paid." },
                ]
              : [
                  { step:"01", icon:"🛒", title:"Buyer COD Order Karta Hai", desc:"Buyer aapke Shopify ya Wix store pe COD select karta hai aur order place karta hai." },
                  { step:"02", icon:"⚡", title:"EscaraPay Auto-Create", desc:"Milliseconds mein order aapke EscaraPay dashboard mein aata hai — koi manual kaam nahi." },
                  { step:"03", icon:"💳", title:"Buyer Token Pay Karta Hai", desc:"Buyer ko turant email aata hai token pay karne ka. Token pay hone ke baad aap dispatch karo." },
                ];
            return (
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:20,marginBottom:48}}>
                {steps.map(s=>(
                  <div key={s.step} className="card" style={{padding:"28px 22px",position:"relative",overflow:"hidden"}}>
                    <div style={{position:"absolute",top:12,right:16,fontSize:48,fontWeight:900,color:"rgba(14,165,233,.07)",fontFamily:"monospace",lineHeight:1,pointerEvents:"none"}}>{s.step}</div>
                    <div style={{fontSize:32,marginBottom:14}}>{s.icon}</div>
                    <div className="syne" style={{fontWeight:700,fontSize:15,marginBottom:8}}>{s.title}</div>
                    <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>{s.desc}</div>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* Platform badges + Code */}
          <div style={{
            background:dark?"rgba(255,255,255,.03)":"rgba(14,165,233,.04)",
            border:"1px solid rgba(14,165,233,.15)",
            borderRadius:16,padding:"28px clamp(14px,4vw,24px)",marginBottom:40,
          }}>
            <div style={{textAlign:"center",marginBottom:20}}>
              <div className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>
                {lang==="en" ? "Works with every platform" : lang==="hi" ? "हर प्लेटफॉर्म के साथ काम करता है" : "Works with every platform"}
              </div>
              <div style={{fontSize:13,color:"var(--muted)"}}>
                {lang==="en"
                  ? "Seller just adds one line of code to their site"
                  : lang==="hi"
                    ? "Seller को बस एक लाइन का code apni site mein add karna hai"
                    : "Seller ko bas ek line ka code apni site mein add karna hai"}
              </div>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:10,justifyContent:"center",marginBottom:20}}>
              {[
                {icon:"🛒",name:"Shopify"},
                {icon:"🌐",name:"Wix"},
                {icon:"🔌",name:"WooCommerce"},
                {icon:"📄",name:"HTML Sites"},
                {icon:"📦",name:"Custom Stores"},
                {icon:"⚡",name:"Any Platform"},
              ].map(p=>(
                <div key={p.name} style={{
                  display:"flex",alignItems:"center",gap:7,
                  background:dark?"rgba(255,255,255,.06)":"#fff",
                  border:"1px solid var(--border)",borderRadius:40,
                  padding:"6px 14px",fontSize:12,fontWeight:600,
                  boxShadow:"0 1px 3px rgba(0,0,0,.06)",
                }}>
                  <span style={{fontSize:15}}>{p.icon}</span>
                  <span>{p.name}</span>
                </div>
              ))}
            </div>

            {/* ✅ FIXED: Code snippet — responsive with horizontal scroll */}
            <div style={{
              background:"#0c1929",
              borderRadius:12,
              border:"1px solid rgba(255,255,255,.08)",
              overflow:"hidden",
            }}>
              {/* Top bar */}
              <div style={{background:"rgba(255,255,255,.04)",padding:"8px 14px",display:"flex",alignItems:"center",gap:6,borderBottom:"1px solid rgba(255,255,255,.06)"}}>
                <span style={{width:10,height:10,borderRadius:"50%",background:"#ef4444",display:"inline-block"}}/>
                <span style={{width:10,height:10,borderRadius:"50%",background:"#f59e0b",display:"inline-block"}}/>
                <span style={{width:10,height:10,borderRadius:"50%",background:"#22c55e",display:"inline-block"}}/>
                <span style={{fontSize:11,color:"rgba(255,255,255,.3)",marginLeft:6}}>
                  {lang==="en" ? "Add this one line to your website" : "Apni website mein ye ek line add karo"}
                </span>
              </div>
              {/* Code — horizontal scroll on mobile */}
              <div style={{overflowX:"auto",padding:"14px 16px",WebkitOverflowScrolling:"touch"}}>
                <pre style={{
                  margin:0,
                  fontFamily:"'Courier New',Courier,monospace",
                  fontSize:"clamp(11px,2.5vw,13px)",
                  color:"#e2e8f0",
                  lineHeight:1.8,
                  whiteSpace:"pre",
                  minWidth:"max-content",
                }}><span style={{color:"rgba(255,255,255,.3)"}}>{lang==="en"
                  ? "<!-- Add this ONE line before </body> -->"
                  : "<!-- Sirf ye ek line </body> se pehle add karo -->"}</span>{"\n"}<span style={{color:"#7dd3fc"}}>&lt;script</span>{" "}<span style={{color:"#86efac"}}>src</span><span style={{color:"#7dd3fc"}}>="</span><span style={{color:"#fde68a"}}>https://escarapay.in/sdk/escara.js</span><span style={{color:"#7dd3fc"}}>"</span>{"\n       "}<span style={{color:"#86efac"}}>data-seller-id</span><span style={{color:"#7dd3fc"}}>="</span><span style={{color:"#fde68a"}}>YOUR_SELLER_ID</span><span style={{color:"#7dd3fc"}}>"&gt;&lt;/script&gt;</span></pre>
              </div>
            </div>

            <div style={{textAlign:"center",marginTop:12,fontSize:12,color:"var(--muted)",lineHeight:1.8}}>
              {lang==="en"
                ? "✅ Badge shown automatically · ✅ COD orders auto-detected · ✅ Buyer email sent instantly"
                : "✅ Badge automatic dikhega · ✅ COD orders auto-detect honge · ✅ Buyer ko turant email jayega"}
            </div>
          </div>

          {/* 2 cards — Social vs Website */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:16,marginBottom:40}}>
            <div className="card" style={{padding:"24px",border:"1px solid rgba(245,158,11,.3)",background:"rgba(245,158,11,.04)"}}>
              <div style={{fontSize:28,marginBottom:10}}>📱</div>
              <div className="syne" style={{fontWeight:800,fontSize:16,marginBottom:8}}>
                {lang==="en" ? "Social Media Seller" : "Social Media Seller"}
              </div>
              <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>
                {lang==="en"
                  ? <>Selling on Instagram, WhatsApp or Facebook?<br/><strong>Create orders manually</strong> from the seller dashboard and share payment links.</>
                  : <>Instagram, WhatsApp, Facebook pe sell karte ho?<br/><strong>Manual order create karo</strong> seller dashboard se — buyer ko payment link share karo.</>}
              </div>
              <div style={{marginTop:14,display:"flex",gap:8,flexWrap:"wrap"}}>
                {["📎 WhatsApp Link","📊 Dashboard","🔔 Auto Reminder"].map(t=>(
                  <span key={t} style={{fontSize:11,background:"rgba(245,158,11,.12)",color:"var(--gold)",padding:"3px 10px",borderRadius:20,fontWeight:600}}>{t}</span>
                ))}
              </div>
            </div>
            <div className="card" style={{padding:"24px",border:"1px solid rgba(14,165,233,.3)",background:"rgba(14,165,233,.04)"}}>
              <div style={{fontSize:28,marginBottom:10}}>🏪</div>
              <div className="syne" style={{fontWeight:800,fontSize:16,marginBottom:8}}>
                {lang==="en" ? "Website Store Seller" : "Website Store Seller"}
              </div>
              <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>
                {lang==="en"
                  ? <>Have a store on Shopify, Wix or WooCommerce?<br/><strong>Set up once</strong> — every COD order will be automatically protected by EscaraPay.</>
                  : <>Shopify, Wix, WooCommerce pe store hai?<br/><strong>Ek baar setup karo</strong> — har COD order automatically EscaraPay se protect hoga.</>}
              </div>
              <div style={{marginTop:14,display:"flex",gap:8,flexWrap:"wrap"}}>
                {["⚡ Auto-Orders","🛡️ Trust Badge","📧 Auto Email"].map(t=>(
                  <span key={t} style={{fontSize:11,background:"rgba(14,165,233,.12)",color:"var(--blue)",padding:"3px 10px",borderRadius:20,fontWeight:600}}>{t}</span>
                ))}
              </div>
            </div>
          </div>

          {/* CTA */}
          <div style={{textAlign:"center"}}>
            <div className="syne" style={{fontWeight:700,fontSize:18,marginBottom:8}}>
              {lang==="en" ? "Connect Your Store — For Free" : "Apna Store Connect Karo — Free Mein"}
            </div>
            <div style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>
              {lang==="en"
                ? "After registration, find the complete setup guide in Dashboard → Integration tab."
                : "Registration ke baad Dashboard → Integration tab mein sab setup guide available hai."}
            </div>
            <button className="cta-btn" onClick={onEnter} style={{fontSize:15,padding:"14px 36px"}}>
              🚀 {lang==="en" ? "Start for Free" : "Start for Free"}
            </button>
          </div>
        </div>
      </div>

      {/* ── FAQ ── */}
      <div className="reveal" style={{padding:"70px clamp(16px,5vw,40px)",background:"var(--sf2)"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <p style={{fontSize:12,fontWeight:700,color:"var(--gold)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10}}>FAQ</p>
          <h2 className="syne" style={{fontSize:"clamp(24px,3.5vw,40px)",fontWeight:800,marginBottom:12,letterSpacing:"-0.5px"}}>
            {lang==="hi"?"अक्सर पूछे जाने वाले सवाल":lang==="en"?"Frequently Asked Questions":"Aksar Puche Jaane Waale Sawaal"}
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:420,margin:"0 auto",lineHeight:1.6}}>
            {lang==="hi"?"कोई सवाल? हमारे पास जवाब है।":lang==="en"?"Any questions? We have the answers.":"Koi sawaal? Hamare paas jawab hai."}
          </p>
        </div>
        <div style={{maxWidth:720,margin:"0 auto",display:"flex",flexDirection:"column",gap:10}}>
          {FAQS.map((faq,i)=>(
            <div key={i} className="card" style={{
              padding:0,overflow:"hidden",
              border: openFaq===i?"1px solid rgba(14,165,233,.4)":"1px solid var(--border)",
              transition:"border-color .2s"
            }}>
              <button
                onClick={()=>setOpenFaq(openFaq===i?null:i)}
                style={{
                  width:"100%",padding:"18px 20px",
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  background:"transparent",border:"none",cursor:"pointer",
                  fontFamily:"'Outfit',sans-serif",fontWeight:700,fontSize:14,
                  color:"var(--text)",textAlign:"left",gap:12
                }}
              >
                <span>{faq.q}</span>
                <span style={{
                  width:24,height:24,borderRadius:"50%",flexShrink:0,
                  background: openFaq===i?"rgba(14,165,233,.2)":"var(--sf2)",
                  display:"flex",alignItems:"center",justifyContent:"center",
                  fontSize:14,color:"var(--gold)",transition:"all .2s",
                  transform: openFaq===i?"rotate(45deg)":"rotate(0deg)"
                }}>+</span>
              </button>
              {openFaq===i && (
                <div style={{padding:"0 20px 18px",fontSize:13,color:"var(--muted)",lineHeight:1.8,borderTop:"1px solid var(--border)",paddingTop:14}}>
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
        <div style={{textAlign:"center",marginTop:32}}>
          <span style={{fontSize:13,color:"var(--muted)"}}>
            {lang==="hi"?"और सवाल हैं? ":lang==="en"?"More questions? ":"Aur sawaal hain? "}
          </span>
          <span style={{fontSize:13,color:"var(--gold)",fontWeight:600,cursor:"pointer",textDecoration:"underline"}} onClick={()=>window._goToPage("contact")}>
            {lang==="hi"?"हमसे संपर्क करें →":lang==="en"?"Contact Us →":"Contact Karo →"}
          </span>
        </div>
      </div>

      {/* ── TRUST BAR ── */}
      <div style={{
        background: dark?"rgba(14,165,233,.07)":"rgba(14,165,233,.06)",
        borderTop:"1px solid var(--border)",borderBottom:"1px solid var(--border)",
        padding:"16px 20px"
      }}>
        <div style={{maxWidth:900,margin:"0 auto",display:"flex",justifyContent:"center",alignItems:"center",gap:"clamp(18px,4vw,52px)",flexWrap:"wrap"}}>
          {[
            {icon:"🔒",text:"Secure Payments"},
            {icon:"🛡️",text:"Payment Protection"},
            {icon:"⚡",text:"Fast & Safe"},
            {icon:"✅",text:"Powered by Cashfree (RBI Compliant)"},
          ].map(b=>(
            <div key={b.text} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:600,color:"var(--gold)",whiteSpace:"nowrap"}}>
              <span>{b.icon}</span><span>{b.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── FOOTER ── */}
      <footer style={{background:dark?"#08080f":"#0c2340",padding:"48px 20px 24px",color:"#fff"}}>
        <div style={{maxWidth:960,margin:"0 auto"}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:32,marginBottom:36}}>
            <div>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                <img src={LOGO_SRC} alt="EscaraPay" style={{height:28,objectFit:"contain"}} onError={e=>e.target.style.display="none"} />
                <span style={{fontFamily:"'Outfit',sans-serif",fontWeight:800,fontSize:16,color:"#fff"}}>EscaraPay</span>
              </div>
              <p style={{fontSize:12,color:"rgba(255,255,255,.5)",lineHeight:1.85,marginBottom:12}}>India's trusted payment protection platform for WhatsApp & Instagram sellers.</p>
              <div style={{fontSize:11,color:"rgba(255,255,255,.35)"}}>MSME Reg: UDYAM-UP-23-0036110<br/>CIN: Applied for Registration</div>
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:1.2,marginBottom:14}}>Company</div>
              {[["About Us","about"],["Contact Us","contact"],["Blog","blogs"],["RTO Calculator","rto-calculator"],["How It Works","how"]].map(([l,s])=>(
                <div key={l} style={{fontSize:13,color:"rgba(255,255,255,.65)",marginBottom:9,cursor:"pointer",transition:"color .2s"}}
                  onMouseEnter={e=>e.target.style.color="#fff"}
                  onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.65)"}
                  onClick={()=>{
                    if(s==="how"){
                      const el=document.getElementById("how-it-works");
                      if(el){ el.scrollIntoView({behavior:"smooth"}); }
                    } else if(s==="rto-calculator"){
                      window.history.pushState({},"","/rto-calculator");
                      window._goToPage("rto-calculator");
                    } else window._goToPage(s);
                  }}>{l}</div>
              ))}
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:1.2,marginBottom:14}}>Legal</div>
              {[["Terms & Conditions","terms"],["Privacy Policy","privacy"],["Refund Policy","refund"],["Dispute Resolution","dispute"]].map(([l,s])=>(
                <div key={l} style={{fontSize:13,color:"rgba(255,255,255,.65)",marginBottom:9,cursor:"pointer",transition:"color .2s"}}
                  onMouseEnter={e=>e.target.style.color="#fff"}
                  onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.65)"}
                  onClick={()=>window._goToPage(s)}>{l}</div>
              ))}
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:1.2,marginBottom:14}}>Contact</div>
              <div style={{fontSize:13,color:"rgba(255,255,255,.65)",marginBottom:7}}>📧 support@escarapay.in</div>
              <div style={{fontSize:13,color:"rgba(255,255,255,.65)",marginBottom:7}}>⚖️ legal@escarapay.in</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,.35)",marginTop:14,lineHeight:1.8}}>Response time: 24 hours<br/>Mon–Sat, 10AM–6PM IST</div>
              {/* Social Media Icons */}
              <div style={{marginTop:18}}>
                <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:1.2,marginBottom:12}}>Follow Us</div>
                <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  {[
                    {href:"https://www.instagram.com/escarapay?igsh=MXZrNXA0bnZ0c3hkbQ==",label:"Instagram",color:"#E1306C",svg:<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>},
                    {href:"https://x.com/EscaraPay",label:"X (Twitter)",color:"#fff",svg:<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>},
                    {href:"https://www.linkedin.com/company/escara-pay/",label:"LinkedIn",color:"#0A66C2",svg:<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>},
                    {href:"https://www.pinterest.com/escarapay/",label:"Pinterest",color:"#E60023",svg:<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>},
                  ].map(({href,label,color,svg})=>(
                    <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                      style={{width:36,height:36,borderRadius:8,background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.12)",display:"flex",alignItems:"center",justifyContent:"center",color,transition:"all .2s",textDecoration:"none"}}
                      onMouseEnter={e=>{e.currentTarget.style.background=color+"33";e.currentTarget.style.borderColor=color+"66";}}
                      onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,.08)";e.currentTarget.style.borderColor="rgba(255,255,255,.12)";}}>
                      {svg}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div style={{borderTop:"1px solid rgba(255,255,255,.08)",paddingTop:20,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
            <div style={{fontSize:11,color:"rgba(255,255,255,.35)"}}>© 2026 EscaraPay (India) · MSME Reg: UDYAM-UP-23-0036110. All rights reserved. | Jurisdiction: Uttar Pradesh, India</div>
            <div style={{display:"flex",gap:16}}>
              {[["Terms","terms"],["Privacy","privacy"],["Refund","refund"],["Dispute","dispute"]].map(([l,s])=>(
                <span key={l} style={{fontSize:11,color:"rgba(255,255,255,.35)",cursor:"pointer",transition:"color .2s"}}
                  onMouseEnter={e=>e.target.style.color="rgba(255,255,255,.7)"}
                  onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.35)"}
                  onClick={()=>window._goToPage(s)}>{l}</span>
              ))}
            </div>
          </div>
        </div>
      </footer>
      {/* ── MOBILE STICKY CTA ── */}
      <div style={{
        position:"fixed",bottom:0,left:0,right:0,zIndex:200,
        background: dark?"rgba(12,12,22,.97)":"rgba(255,255,255,.97)",
        backdropFilter:"blur(20px)",
        borderTop:"1px solid var(--border)",
        padding:"10px 16px max(10px, env(safe-area-inset-bottom))",
        display:"flex",gap:10,alignItems:"center",
        boxShadow:"0 -8px 30px rgba(0,0,0,.12)"
      }} className="hide-d">
        <button className="btn-outline" style={{flex:1,padding:"11px",fontSize:13,borderRadius:10}} onClick={()=>onEnter("buyer")}>
          🛍️ {lc.ctaBuyer}
        </button>
        <button className="btn-gold" style={{flex:1,padding:"12px",fontSize:13,borderRadius:10}} onClick={()=>onEnter("seller")}>
          🏪 {lc.ctaSeller}
        </button>
      </div>
    </div>
  );
}
// ── Validation helpers ──
const validateEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
const validatePhone = (p) => /^\d{10}$/.test(p);
const validatePAN   = (p) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(p);
const validateGST   = (g) => /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}$/.test(g);
const validatePass  = (p) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{6,}$/.test(p);

function FieldError({ msg }) {
  if (!msg) return null;
  return <div style={{fontSize:11,color:"var(--red)",marginTop:3}}>⚠️ {msg}</div>;
}

/* ══════════ PROFILE MODAL ══════════ */
function ProfileModal({ user, userId, userType, onClose, onUpdate }) {
  const [form, setForm] = useState({ name: user, email: "", phone: "", currentPass: "", newPass: "" });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (form.email && !validateEmail(form.email)) e.email = "Enter a valid email";
    if (form.phone && !validatePhone(form.phone)) e.phone = "Please enter a valid 10-digit phone number";
    if (form.newPass && !validatePass(form.newPass)) e.newPass = "Min 6 chars, 1 capital, 1 small, 1 number, 1 special (!@#$)";
    if (form.newPass && !form.currentPass) e.newPass = "Enter your current password to set a new one";
    return e;
  };

  const handleSave = async () => {
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length > 0) return;
    setLoading(true);
    setMsg("");
    try {
      // Step 1 — Profile update (name, email, phone)
      const res = await fetch(`${BACKEND_URL}/api/users/${userId}/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId, name: form.name, email: form.email || undefined, phone: form.phone || undefined }),
      });
      const data = await res.json();
      if (!data.success) { setLoading(false); setMsg("❌ " + data.error); return; }

      // Step 2 — Password change (only if new password entered)
      if (form.newPass && form.currentPass) {
        const pr = await fetch(`${BACKEND_URL}/api/auth/change-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId, current_password: form.currentPass, new_password: form.newPass }),
        });
        const pd = await pr.json();
        setLoading(false);
        if (!pd.success) { setMsg("❌ Password: " + pd.error); return; }
        setMsg("✅ Profile and password updated successfully!");
      } else {
        setLoading(false);
        setMsg("✅ Profile updated successfully!");
      }
      onUpdate(form.name);
    } catch(err) { setLoading(false); setMsg("❌ Could not connect to server. Please try again."); }
  };

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:380}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h3 className="syne" style={{fontWeight:800,fontSize:18}}>My Profile</h3>
          <button className="btn-ghost" style={{padding:"4px 10px",fontSize:12}} onClick={onClose}>✕</button>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20,padding:12,background:"var(--sf2)",borderRadius:12}}>
          <div className="avatar" style={{width:44,height:44,fontSize:18}}>{user[0]}</div>
          <div><div style={{fontWeight:700,fontSize:15}}>{user}</div><div style={{fontSize:12,color:"var(--muted)",marginTop:2}}>{userType === "seller" ? "🏪 Seller" : "🛍️ Buyer"}</div></div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div>
            <label className="label">Full Name *</label>
            <input className="input" value={form.name} onChange={e=>{setForm({...form,name:e.target.value});setErrors({...errors,name:""});}} />
            <FieldError msg={errors.name} />
          </div>
          <div>
            <label className="label">Email Address</label>
            <input className="input" placeholder="new@email.com" value={form.email} onChange={e=>{setForm({...form,email:e.target.value});setErrors({...errors,email:""});}} />
            <FieldError msg={errors.email} />
          </div>
          <div>
            <label className="label">Phone Number</label>
            <input className="input" placeholder="10 digit number" maxLength={10} value={form.phone} onChange={e=>{setForm({...form,phone:e.target.value.replace(/\D/g,"")});setErrors({...errors,phone:""});}} />
            <FieldError msg={errors.phone} />
          </div>
          <div style={{height:1,background:"var(--border)",margin:"4px 0"}} />
          <div style={{fontSize:12,fontWeight:600,color:"var(--muted)"}}>🔑 Change Password <span style={{fontWeight:400}}>(optional — leave blank to keep current)</span></div>
          <div>
            <label className="label">Current Password</label>
            <input className="input" type="password" placeholder="Enter your current password" value={form.currentPass||""} onChange={e=>setForm({...form,currentPass:e.target.value})} />
          </div>
          <div>
            <label className="label">New Password</label>
            <input className="input" type="password" placeholder="Min 6 characters" value={form.newPass} onChange={e=>{setForm({...form,newPass:e.target.value});setErrors({...errors,newPass:""});}} />
            <FieldError msg={errors.newPass} />
            <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>Min 6 chars, 1 capital, 1 small, 1 number, 1 special</div>
          </div>
          {msg && <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,color:msg.startsWith("✅")?"var(--green)":"var(--red)"}}>{msg}</div>}
          <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handleSave}>{loading?"⏳ Saving...":"💾 Save Changes"}</button>
        </div>
      </div>
    </div>
  );
}

function Auth({ type, onLogin, onBack, dark, onToggle }) {
  const [mode, setMode] = useState("login");        // login | register
  const [loginMethod, setLoginMethod] = useState("password"); // password | otp
  const [form, setForm] = useState({name:"",email:"",password:"",shop:"",phone:"",pan:"",gst:"",sellerType:null,websiteUrl:""});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  // OTP states
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);
  const [otpMsg, setOtpMsg] = useState("");
  // Register OTP states
  const [regOtpSent, setRegOtpSent] = useState(false);
  const [regOtpVerified, setRegOtpVerified] = useState(false);
  const [regVerificationToken, setRegVerificationToken] = useState("");
  const [regOtp, setRegOtp] = useState("");
  const [regOtpMsg, setRegOtpMsg] = useState("");
  // Forgot Password states
  const [forgotMode, setForgotMode] = useState(false); // show forgot password flow
  const [forgotStep, setForgotStep] = useState(1);     // 1=email, 2=otp+newpass
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotOtp, setForgotOtp] = useState("");
  const [forgotNewPass, setForgotNewPass] = useState("");
  const [forgotConfirm, setForgotConfirm] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotTimer, setForgotTimer] = useState(0);

  useEffect(() => {
    if (forgotTimer <= 0) return;
    const t = setTimeout(() => setForgotTimer(forgotTimer - 1), 1000);
    return () => clearTimeout(t);
  }, [forgotTimer]);

  // OTP countdown timer
  useEffect(() => {
    if (otpTimer <= 0) return;
    const t = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
    return () => clearTimeout(t);
  }, [otpTimer]);

  const validate = () => {
    const e = {};
    if (mode === "register") {
      if (!form.name.trim()) e.name = "Name is required";
      if (!validateEmail(form.email)) e.email = "Enter a valid email (e.g. example@gmail.com)";
      if (!validatePhone(form.phone)) e.phone = "Enter a valid 10-digit phone number";
      if (!validatePass(form.password)) e.password = "Min 6 chars, 1 capital, 1 small, 1 number, 1 special char (!@#$%)";
      if (type === "seller" && form.pan && !validatePAN(form.pan)) e.pan = "PAN format: ABCDE1234F";
      if (type === "seller" && form.gst && !validateGST(form.gst)) e.gst = "GST number must be 15 characters";
      if (type === "seller" && !form.pan && !form.gst) e.pan = "Either PAN or GST number is required";
    } else {
      if (!validateEmail(form.email)) e.email = "Enter a valid email";
      if (loginMethod === "password" && !form.password) e.password = "Please enter your password";
    }
    return e;
  };

  // Password login / Register
  const handle = async () => {
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length > 0) return;
    // Registration requires email verification
    if (mode === "register" && !regOtpVerified) {
      alert("❌ Please verify your email first using the button below.");
      return;
    }
    setLoading(true);
    const result = mode === "register"
      ? await registerUser(form.name,form.email,form.phone,type,form.password,form.shop||"",form.pan||"",form.gst||"",form.sellerType||null,form.websiteUrl||"",regVerificationToken)
      : await loginUser(form.email,form.password,type);
    setLoading(false);
    if (result.success) {
      const u = result.data.user;
      onLogin(type, u.name, u.id, u.phone||form.phone||"", u.seller_type||null, u.website_url||"");
    } else alert("❌ " + result.error);
  };

  // Send Register OTP
  const handleSendRegisterOTP = async () => {
    if (!validateEmail(form.email)) { setErrors({...errors, email:"Enter a valid email"}); return; }
    if (!form.name.trim()) { setErrors({...errors, name:"Please enter your name first"}); return; }
    setLoading(true); setRegOtpMsg("");
    const r = await sendRegisterOTP(form.email, form.name, type);
    setLoading(false);
    if (r.success) { setRegOtpSent(true); setOtpTimer(60); setRegOtpMsg("✅ " + r.message); }
    else setRegOtpMsg("❌ " + r.error);
  };

  // Verify Register OTP
  const handleVerifyRegisterOTP = async () => {
    if (!regOtp || regOtp.length !== 6) { setRegOtpMsg("❌ Please enter the 6-digit OTP"); return; }
    setLoading(true); setRegOtpMsg("");
    const r = await verifyRegisterOTP(form.email, regOtp);
    setLoading(false);
    if (r.success) { setRegOtpVerified(true); setRegVerificationToken(r.verification_token || ""); setRegOtpMsg("✅ Email verified! You can now create your account."); }
    else setRegOtpMsg("❌ " + r.error);
  };

  // Send OTP
  const handleSendOTP = async () => {
    if (!validateEmail(form.email)) { setErrors({email:"Enter a valid email"}); return; }
    setLoading(true); setOtpMsg("");
    const r = await sendOTP(form.email, type);
    setLoading(false);
    if (r.success) {
      setOtpSent(true);
      setOtpTimer(60);
      setOtpMsg("✅ " + r.message);
    } else {
      setOtpMsg("❌ " + r.error);
    }
  };

  // Verify OTP
  const handleVerifyOTP = async () => {
    if (!otp || otp.length !== 6) { setOtpMsg("❌ Please enter the 6-digit OTP"); return; }
    setLoading(true); setOtpMsg("");
    const r = await verifyOTP(form.email, type, otp);
    setLoading(false);
    if (r.success) {
      const u = r.data.user;
      onLogin(type, u.name, u.id, u.phone||"", u.seller_type||null, u.website_url||"");
    } else {
      setOtpMsg("❌ " + r.error);
    }
  };

  const setField = (field, val) => { setForm({...form,[field]:val}); setErrors({...errors,[field]:""}); };

  // ── Forgot Password handlers ──
  const handleForgotSendOTP = async () => {
    if (!forgotEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(forgotEmail)) {
      setForgotMsg("❌ Please enter a valid email address"); return;
    }
    setForgotLoading(true); setForgotMsg("");
    try {
      const r = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ email: forgotEmail, role: type }),
      });
      const d = await r.json();
      setForgotLoading(false);
      if (d.success) { setForgotStep(2); setForgotTimer(60); setForgotMsg("✅ OTP sent! Please check your email inbox."); }
      else setForgotMsg("❌ " + d.error);
    } catch(e) { setForgotLoading(false); setForgotMsg("❌ Could not connect to server. Please try again."); }
  };

  const handleForgotReset = async () => {
    if (!forgotOtp || forgotOtp.length !== 6) { setForgotMsg("❌ Please enter the 6-digit OTP"); return; }
    if (!forgotNewPass || forgotNewPass.length < 6) { setForgotMsg("❌ Password must be at least 6 characters"); return; }
    if (forgotNewPass !== forgotConfirm) { setForgotMsg("❌ Passwords do not match"); return; }
    setForgotLoading(true); setForgotMsg("");
    try {
      const r = await fetch(`${BACKEND_URL}/api/auth/reset-password`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ email: forgotEmail, role: type, otp: forgotOtp, new_password: forgotNewPass }),
      });
      const d = await r.json();
      setForgotLoading(false);
      if (d.success) {
        setForgotMsg("✅ Password reset successful! You can now log in.");
        setTimeout(() => { setForgotMode(false); setForgotStep(1); setForgotEmail(""); setForgotOtp(""); setForgotNewPass(""); setForgotConfirm(""); setForgotMsg(""); }, 2000);
      } else setForgotMsg("❌ " + d.error);
    } catch(e) { setForgotLoading(false); setForgotMsg("❌ Could not connect to server. Please try again."); }
  };

  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onBack} /><div style={{display:"flex",gap:8,alignItems:"center"}}><ThemeToggle dark={dark} onToggle={onToggle} /><button className="btn-ghost" onClick={onBack}>← Back</button></div></nav>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"calc(100vh - 62px)",padding:20}}>
        <div className="modal" style={{maxWidth:410}}>
          <div style={{textAlign:"center",marginBottom:22}}>
            <img src={LOGO_SRC} alt="EscaraPay" style={{height:52,marginBottom:12,objectFit:"contain"}} onError={e=>e.target.style.display="none"} />
            <h2 className="syne" style={{fontWeight:800,fontSize:21,marginBottom:4}}>
              {mode==="login"?"Welcome Back!":`${type==="seller"?"Seller":"Buyer"} Registration`}
            </h2>
          </div>

          {/* Login / Register tabs */}
          <div style={{display:"flex",gap:5,marginBottom:20,background:"var(--sf2)",padding:4,borderRadius:10}}>
            {["login","register"].map(m=>(
              <button key={m} onClick={()=>{setMode(m);setErrors({});setOtpSent(false);setOtp("");setOtpMsg("");setRegOtpSent(false);setRegOtp("");setRegOtpVerified(false);setRegOtpMsg("");}}
                style={{flex:1,padding:"8px",border:"none",borderRadius:8,cursor:"pointer",
                  background:mode===m?"var(--gold)":"transparent",
                  color:mode===m?(dark?"#0a0a0f":"#fff"):"var(--muted)",
                  fontFamily:"'Outfit',sans-serif",fontWeight:600,fontSize:13,transition:"all .2s"}}>
                {m==="login"?"Login":"Register"}
              </button>
            ))}
          </div>

          {/* Login Method toggle — only on login mode */}
          {mode==="login" && (
            <div style={{display:"flex",gap:5,marginBottom:16,background:"var(--sf2)",padding:3,borderRadius:8}}>
              {[["password","🔑 Password"],["otp","📧 Email OTP"]].map(([m,l])=>(
                <button key={m} onClick={()=>{setLoginMethod(m);setOtpSent(false);setOtp("");setOtpMsg("");setErrors({});}}
                  style={{flex:1,padding:"6px",border:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,
                    background:loginMethod===m?"var(--surface)":"transparent",
                    color:loginMethod===m?"var(--gold)":"var(--muted)",
                    boxShadow:loginMethod===m?"0 1px 4px rgba(0,0,0,.1)":"none",
                    fontFamily:"'DM Sans',sans-serif",transition:"all .2s"}}>
                  {l}
                </button>
              ))}
            </div>
          )}

          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {/* Register fields */}
            {mode==="register" && (
              <div>
                <label className="label">Full Name *</label>
                <input className="input" placeholder="Meena Devi" value={form.name} onChange={e=>setField("name",e.target.value)} />
                <FieldError msg={errors.name} />
              </div>
            )}
            {mode==="register"&&type==="seller" && (
              <div>
                <label className="label">Shop Name</label>
                <input className="input" placeholder="Meena Crafts" value={form.shop} onChange={e=>setField("shop",e.target.value)} />
              </div>
            )}

            {/* Email — always show */}
            <div>
              <label className="label">Email *</label>
              <input className="input" placeholder="your@email.com" type="email" value={form.email}
                onChange={e=>setField("email",e.target.value)} />
              <FieldError msg={errors.email} />
            </div>

            {/* Email Verification for Register */}
            {mode==="register" && (
              <div style={{background: regOtpVerified?"rgba(5,150,105,.08)":"rgba(14,165,233,.06)", border:`1px solid ${regOtpVerified?"rgba(5,150,105,.3)":"rgba(14,165,233,.2)"}`, borderRadius:10, padding:12}}>
                <div style={{fontSize:12,fontWeight:600,marginBottom:8,color:regOtpVerified?"var(--green)":"var(--gold)"}}>
                  {regOtpVerified ? "✅ Email Verified!" : "📧 Verify Your Email (Required)"}
                </div>
                {!regOtpVerified && (
                  <>
                    {!regOtpSent ? (
                      <button className="btn-ghost" style={{width:"100%",fontSize:13,color:"var(--gold)",borderColor:"rgba(14,165,233,.3)"}}
                        onClick={handleSendRegisterOTP} disabled={loading}>
                        {loading?"⏳ Sending OTP...":"📧 Send Verification OTP"}
                      </button>
                    ) : (
                      <div style={{display:"flex",flexDirection:"column",gap:8}}>
                        <input className="input" placeholder="6-digit OTP" maxLength={6} value={regOtp}
                          onChange={e=>setRegOtp(e.target.value.replace(/\D/g,""))}
                          style={{fontSize:20,letterSpacing:6,textAlign:"center",fontWeight:700}} />
                        <button className="btn-ghost" style={{width:"100%",fontSize:13,color:"var(--green)",borderColor:"rgba(5,150,105,.3)"}}
                          onClick={handleVerifyRegisterOTP} disabled={loading}>
                          {loading?"⏳ Verifying...":"✅ Verify OTP"}
                        </button>
                        <div style={{textAlign:"center"}}>
                          {otpTimer > 0
                            ? <span style={{fontSize:11,color:"var(--muted)"}}>⏰ Resend in {otpTimer}s</span>
                            : <button className="btn-ghost" style={{fontSize:11,padding:"3px 10px"}} onClick={handleSendRegisterOTP}>🔄 Resend</button>}
                        </div>
                      </div>
                    )}
                  </>
                )}
                {regOtpMsg && <div style={{fontSize:12,marginTop:6,color:regOtpMsg.startsWith("✅")?"var(--green)":"var(--red)"}}>{regOtpMsg}</div>}
              </div>
            )}

            {/* Phone — register only */}
            {mode==="register" && (
              <div>
                <label className="label">Phone Number * (10 digits)</label>
                <input className="input" placeholder="9876543210" maxLength={10} value={form.phone}
                  onChange={e=>setField("phone",e.target.value.replace(/\D/g,""))} />
                <FieldError msg={errors.phone} />
              </div>
            )}

            {/* Password login */}
            {(mode==="register" || loginMethod==="password") && (
              <div>
                <label className="label">Password *</label>
                <input className="input" type="password" placeholder="••••••••" value={form.password}
                  onChange={e=>setField("password",e.target.value)} />
                <FieldError msg={errors.password} />
                {mode==="register" && !errors.password && <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>Min 6 chars, 1 capital, 1 small, 1 number, 1 special (!@#$%)</div>}
                {mode==="login" && loginMethod==="password" && (
                  <div style={{textAlign:"right",marginTop:5}}>
                    <span style={{fontSize:12,color:"var(--gold)",cursor:"pointer",textDecoration:"underline"}}
                      onClick={()=>{ setForgotMode(true); setForgotEmail(form.email||""); setForgotStep(1); setForgotMsg(""); }}>
                      🔑 Forgot Password?
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* ── Forgot Password Inline Flow ── */}
            {forgotMode && mode==="login" && (
              <div style={{background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.25)",borderRadius:12,padding:16}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                  <div style={{fontWeight:700,fontSize:14,color:"var(--gold)"}}>🔑 Password Reset</div>
                  <button className="btn-ghost" style={{padding:"2px 8px",fontSize:11}} onClick={()=>{ setForgotMode(false); setForgotStep(1); setForgotMsg(""); }}>✕</button>
                </div>
                {forgotStep===1 && (
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    <div style={{fontSize:12,color:"var(--muted)"}}>Enter your registered email — we'll send a reset OTP</div>
                    <input className="input" type="email" placeholder="your@email.com"
                      value={forgotEmail} onChange={e=>setForgotEmail(e.target.value.toLowerCase())}
                      onKeyDown={e=>e.key==="Enter"&&handleForgotSendOTP()} />
                    <button className="btn-gold" style={{width:"100%",padding:10,fontSize:13}} onClick={handleForgotSendOTP} disabled={forgotLoading}>
                      {forgotLoading?"⏳ Sending...":"📧 Send Reset OTP"}
                    </button>
                  </div>
                )}
                {forgotStep===2 && (
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.3)",borderRadius:8,padding:10,fontSize:12,color:"var(--green)"}}>
                      ✅ OTP sent to <strong>{forgotEmail}</strong>
                    </div>
                    <div>
                      <label className="label">6-Digit OTP *</label>
                      <input className="input" placeholder="123456" maxLength={6} value={forgotOtp}
                        onChange={e=>setForgotOtp(e.target.value.replace(/\D/g,""))}
                        style={{fontSize:20,letterSpacing:6,textAlign:"center",fontWeight:700}} />
                    </div>
                    <div>
                      <label className="label">New Password *</label>
                      <input className="input" type="password" placeholder="Min 6 characters"
                        value={forgotNewPass} onChange={e=>setForgotNewPass(e.target.value)} />
                    </div>
                    <div>
                      <label className="label">Confirm New Password *</label>
                      <input className="input" type="password" placeholder="Confirm your new password"
                        value={forgotConfirm} onChange={e=>setForgotConfirm(e.target.value)}
                        onKeyDown={e=>e.key==="Enter"&&handleForgotReset()} />
                    </div>
                    <button className="btn-gold" style={{width:"100%",padding:10,fontSize:13}} onClick={handleForgotReset} disabled={forgotLoading}>
                      {forgotLoading?"⏳ Resetting...":"✅ Reset Password"}
                    </button>
                    <div style={{textAlign:"center",fontSize:12}}>
                      {forgotTimer>0
                        ? <span style={{color:"var(--muted)"}}>⏰ Resend in {forgotTimer}s</span>
                        : <span style={{color:"var(--gold)",cursor:"pointer",textDecoration:"underline"}} onClick={()=>{ setForgotStep(1); setForgotMsg(""); }}>🔄 Request New OTP</span>
                      }
                    </div>
                  </div>
                )}
                {forgotMsg && (
                  <div style={{marginTop:8,padding:"8px 12px",borderRadius:8,background:"var(--sf2)",fontSize:12,
                    color:forgotMsg.startsWith("✅")?"var(--green)":"var(--red)",fontWeight:500}}>
                    {forgotMsg}
                  </div>
                )}
              </div>
            )}

            {/* KYC for seller register */}
            {mode==="register"&&type==="seller" && (
              <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:10,padding:12}}>
                <div style={{fontSize:12,fontWeight:600,marginBottom:8,color:"var(--gold)"}}>📋 KYC Details (At least one required)</div>
                <div>
                  <label className="label">PAN Card (ABCDE1234F)</label>
                  <input className="input" placeholder="ABCDE1234F" value={form.pan} maxLength={10}
                    onChange={e=>setField("pan",e.target.value.replace(/[^A-Z0-9]/g,"").toUpperCase())} style={{marginBottom:4}} />
                  <FieldError msg={errors.pan} />
                </div>
                <div style={{textAlign:"center",fontSize:12,color:"var(--muted)",margin:"8px 0"}}>— or —</div>
                <div>
                  <label className="label">GST Number (15 chars)</label>
                  <input className="input" placeholder="27ABCDE1234F1Z5" value={form.gst} maxLength={15}
                    onChange={e=>setField("gst",e.target.value.replace(/[^A-Z0-9]/g,"").toUpperCase())} style={{marginBottom:4}} />
                  <FieldError msg={errors.gst} />
                </div>
              </div>
            )}

            {/* ── Seller Type Selection (Optional) ── */}
            {mode==="register"&&type==="seller" && (
              <div style={{background:"rgba(245,158,11,.06)",border:"1px solid rgba(245,158,11,.25)",borderRadius:10,padding:14}}>
                <div style={{fontSize:12,fontWeight:700,marginBottom:10,color:"var(--gold)"}}>
                  🏪 What kind of seller are you?
                  <span style={{color:"var(--muted)",fontWeight:400,fontSize:11,marginLeft:6}}>(Optional — can change later)</span>
                </div>
                <div style={{display:"flex",gap:10,marginBottom:form.sellerType==="website"?12:0}}>
                  <div onClick={()=>setField("sellerType", form.sellerType==="social_media"?null:"social_media")} style={{
                    flex:1,padding:14,borderRadius:12,cursor:"pointer",textAlign:"center",transition:"all .15s",
                    border:`2px solid ${form.sellerType==="social_media"?"var(--gold)":"var(--border)"}`,
                    background:form.sellerType==="social_media"?"rgba(245,158,11,.12)":"transparent",
                  }}>
                    <div style={{fontSize:26,marginBottom:5}}>📱</div>
                    <div style={{fontWeight:700,fontSize:13}}>Social Media</div>
                    <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>Instagram, WhatsApp, Facebook</div>
                  </div>
                  <div onClick={()=>setField("sellerType", form.sellerType==="website"?null:"website")} style={{
                    flex:1,padding:14,borderRadius:12,cursor:"pointer",textAlign:"center",transition:"all .15s",
                    border:`2px solid ${form.sellerType==="website"?"var(--gold)":"var(--border)"}`,
                    background:form.sellerType==="website"?"rgba(245,158,11,.12)":"transparent",
                  }}>
                    <div style={{fontSize:26,marginBottom:5}}>🏪</div>
                    <div style={{fontWeight:700,fontSize:13}}>Website Store</div>
                    <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>Shopify, Wix, WooCommerce</div>
                  </div>
                </div>
                {form.sellerType==="website" && (
                  <div>
                    <label className="label">Store Website URL <span style={{color:"var(--muted)",fontWeight:400}}>(Optional)</span></label>
                    <input className="input" placeholder="https://yourstore.com" value={form.websiteUrl}
                      onChange={e=>setField("websiteUrl",e.target.value)} />
                    <div style={{fontSize:11,color:"var(--muted)",marginTop:4}}>You can set up auto COD protection for your store from the dashboard.</div>
                  </div>
                )}
                {!form.sellerType && (
                  <div style={{textAlign:"center",fontSize:11,color:"var(--muted)",marginTop:4}}>
                    Click to select · You can also set this later in Profile Settings
                  </div>
                )}
              </div>
            )}

            {/* OTP login flow */}
            {mode==="login" && loginMethod==="otp" && (
              <div>
                {!otpSent ? (
                  <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handleSendOTP} disabled={loading}>
                    {loading?"⏳ Sending OTP...":"📧 Send OTP to My Email"}
                  </button>
                ) : (
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.3)",borderRadius:10,padding:12,fontSize:13,color:"var(--green)"}}>
                      ✅ OTP sent to <strong>{form.email}</strong> — please check your inbox!
                    </div>
                    <div>
                      <label className="label">6-Digit OTP *</label>
                      <input className="input" placeholder="123456" maxLength={6} value={otp}
                        onChange={e=>setOtp(e.target.value.replace(/\D/g,""))}
                        style={{fontSize:22,letterSpacing:6,textAlign:"center",fontWeight:700}}
                        onKeyDown={e=>e.key==="Enter"&&handleVerifyOTP()} />
                    </div>
                    <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handleVerifyOTP} disabled={loading}>
                      {loading?"⏳ Verifying...":"✅ Verify OTP & Login"}
                    </button>
                    <div style={{textAlign:"center"}}>
                      {otpTimer > 0 ? (
                        <span style={{fontSize:12,color:"var(--muted)"}}>⏰ Resend in {otpTimer}s</span>
                      ) : (
                        <button className="btn-ghost" style={{fontSize:12,padding:"4px 12px"}} onClick={handleSendOTP}>
                          🔄 Resend OTP
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Password login button */}
            {(mode==="register" || loginMethod==="password") && (
              <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handle} disabled={loading}>
                {loading?"⏳ Processing...":mode==="login"?"Login":"Create Account"}
              </button>
            )}

            {/* OTP message */}
            {otpMsg && (
              <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,
                color:otpMsg.startsWith("✅")?"var(--green)":"var(--red)",fontWeight:500}}>
                {otpMsg}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


/* ══════════ SELLER INTEGRATION COMPONENT ══════════ */
function SellerIntegration({ userId, BACKEND_URL }) {
  const [keyInfo,    setKeyInfo]    = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [generating, setGenerating] = useState(false);
  const [newKey,     setNewKey]     = useState("");
  const [copied,     setCopied]     = useState("");
  const [platform,   setPlatform]   = useState("universal");

  const authHdr = () => {
    const t = localStorage.getItem("escara_auth_token") || "";
    return t
      ? { "Content-Type": "application/json", "Authorization": `Bearer ${t}` }
      : { "Content-Type": "application/json" };
  };

  const WEBHOOK_URLS = {
    universal:   `${BACKEND_URL}/api/integrations/order`,
    shopify:     `${BACKEND_URL}/api/integrations/shopify/webhook`,
    woocommerce: `${BACKEND_URL}/api/integrations/woocommerce/webhook`,
    other:       `${BACKEND_URL}/api/integrations/order`,
  };

  useEffect(() => {
    const load = async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/integrations/my-key`, { headers: authHdr() });
        const d = await r.json();
        if (d.success) setKeyInfo(d);
      } catch(e) {}
      setLoading(false);
    };
    if (userId) load();
  }, [userId, BACKEND_URL]);

  const handleGenerate = async () => {
    if (keyInfo?.hasKey) {
      if (!window.confirm(
        "⚠️ Regenerating will invalidate your current API key.\n\nAll existing integrations will break until you update the key in your store.\n\nContinue?"
      )) return;
    }
    setGenerating(true);
    setNewKey("");
    try {
      const r = await fetch(`${BACKEND_URL}/api/integrations/generate-key`, {
        method: "POST", headers: authHdr(),
      });
      const d = await r.json();
      if (d.success) {
        setNewKey(d.api_key);
        const mk = d.api_key.slice(0, 12) + "••••••••••••" + d.api_key.slice(-4);
        setKeyInfo(prev => ({ ...prev, hasKey: true, masked_key: mk, webhooks_count: prev?.webhooks_count || 0 }));
      } else {
        alert("❌ " + (d.error || "Failed to generate key. Please try again."));
      }
    } catch(e) {
      alert("❌ Connection error. Please try again.");
    }
    setGenerating(false);
  };

  const copyText = (text, label) => {
    navigator.clipboard?.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(""), 2000);
  };

  const platforms = [
    { id: "universal",   label: "🌐 Universal / Wix" },
    { id: "shopify",     label: "🛒 Shopify" },
    { id: "woocommerce", label: "🔌 WooCommerce" },
    { id: "other",       label: "📦 Custom / API" },
  ];

  const displayKey        = newKey || (keyInfo?.hasKey ? keyInfo.masked_key : "");
  const currentWebhookUrl = WEBHOOK_URLS[platform] || WEBHOOK_URLS.universal;
  const shopifyUrl        = `${WEBHOOK_URLS.shopify}?key=${newKey || (keyInfo?.hasKey ? "[YOUR_API_KEY]" : "YOUR_API_KEY")}`;

  const samplePayload = JSON.stringify({
    buyer_name: "Priya Sharma", buyer_phone: "9876543210",
    buyer_email: "priya@example.com", product_name: "Handmade Silk Saree",
    order_amount: 2500, token_pct: 10, platform_order_id: "YOUR-ORDER-123"
  }, null, 2);

  const curlKey     = newKey || displayKey || "YOUR_API_KEY";
  const curlExample = `curl -X POST "${WEBHOOK_URLS.universal}" \\\n  -H "Content-Type: application/json" \\\n  -H "x-api-key: ${curlKey}" \\\n  -d '{"buyer_name":"Priya Sharma","buyer_phone":"9876543210","buyer_email":"priya@example.com","product_name":"Silk Saree","order_amount":2500}'`;

  const universalSteps = [
    "Generate your API Key below (click the button).",
    "Copy the Webhook URL shown below for your platform.",
    "In your store/platform, set up an automation triggered on COD order placement that sends a POST request to the Webhook URL.",
    "Include your API key in the request header: x-api-key: YOUR_KEY",
    "EscaraPay instantly creates the order, emails the buyer a token payment link, and adds the order to your dashboard.",
    "After buyer pays the token, order appears as 'Token Paid' in your dashboard — dispatch as usual.",
  ];
  const shopifySteps = [
    "Generate your API Key below.",
    "In Shopify Admin → Settings → Notifications → scroll down → Webhooks → Create webhook.",
    "Event: Order creation | Format: JSON",
    "Delivery URL: paste the Shopify URL shown below (your key is already embedded).",
    "Save. Every new Shopify COD order will auto-create in EscaraPay and buyer gets a payment email instantly.",
    "Prepaid Shopify orders (Razorpay, PayTM etc.) are automatically skipped — EscaraPay only processes COD.",
  ];
  const wooSteps = [
    "Generate your API Key below.",
    "In WordPress Admin → WooCommerce → Settings → Advanced → Webhooks → Add webhook.",
    "Name: EscaraPay COD | Status: Active | Topic: Order created | Delivery URL: paste URL below.",
    "For the x-api-key header, use WP Webhooks Pro plugin, or use Zapier/Make to forward WooCommerce COD orders.",
    "Using Zapier? Trigger: WooCommerce New Order → Action: Webhooks POST to Universal URL with x-api-key header.",
    "Only COD/Cash on Delivery orders are processed — prepaid orders return a 'skipped' response automatically.",
  ];

  if (loading) return <div style={{padding:40,textAlign:"center",color:"var(--muted)"}}>⏳ Loading integration settings...</div>;

  return (
    <div className="fu">
      <div style={{marginBottom:22}}>
        <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:4}}>Ecommerce Integration 🔗</h1>
        <p style={{color:"var(--muted)",fontSize:13,margin:0}}>Auto-protect COD orders from your Shopify, Wix, WooCommerce, or any custom website.</p>
      </div>

      {keyInfo?.hasKey && (
        <div className="g3" style={{marginBottom:20}}>
          {[
            {label:"Webhook Orders",value:keyInfo.webhooks_count||0,icon:"⚡",color:"var(--gold)"},
            {label:"Integration",   value:"Active",                  icon:"✅",color:"var(--green)"},
            {label:"Mode",          value:"Live",                    icon:"🔴",color:"var(--blue)"},
          ].map(s=>(
            <div key={s.label} className="stat-card">
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <div style={{fontSize:11,color:"var(--muted)",marginBottom:6}}>{s.label}</div>
                  <div className="syne" style={{fontSize:22,fontWeight:800,color:s.color}}>{s.value}</div>
                </div>
                <span style={{fontSize:22}}>{s.icon}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── API KEY ── */}
      <div className="card" style={{marginBottom:16}}>
        <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>🔑 Your API Key</h3>
        <p style={{color:"var(--muted)",fontSize:12,marginBottom:14}}>Use this key to authenticate requests from your store to EscaraPay. Keep it secret.</p>

        {newKey && (
          <div style={{background:"rgba(34,197,94,.1)",border:"1px solid rgba(34,197,94,.4)",borderRadius:10,padding:14,marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:700,color:"#059669",marginBottom:8}}>✅ New API Key generated — Copy it now! It won't be shown again in full.</div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
              <code style={{background:"var(--sf2)",padding:"8px 12px",borderRadius:8,fontSize:12,fontFamily:"monospace",color:"var(--gold)",wordBreak:"break-all",flex:1}}>{newKey}</code>
              <button className="btn-gold" style={{padding:"8px 14px",fontSize:12,whiteSpace:"nowrap"}} onClick={()=>copyText(newKey,"key")}>
                {copied==="key"?"✅ Copied!":"📋 Copy Key"}
              </button>
            </div>
          </div>
        )}

        {!newKey && keyInfo?.hasKey && (
          <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:14,background:"var(--sf2)",borderRadius:10,padding:"10px 14px"}}>
            <code style={{fontSize:13,fontFamily:"monospace",color:"var(--muted)",flex:1}}>{keyInfo.masked_key}</code>
            <span style={{fontSize:11,color:"var(--muted)"}}>Hidden for security</span>
          </div>
        )}

        {!keyInfo?.hasKey && !newKey && (
          <div style={{background:"rgba(245,158,11,.08)",border:"1px solid rgba(245,158,11,.3)",borderRadius:10,padding:14,marginBottom:14}}>
            <div style={{fontSize:13,color:"#92400e",fontWeight:600}}>⚠️ No API key yet. Generate one below to start integrating your store.</div>
          </div>
        )}

        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <button className="btn-gold" style={{fontSize:13,padding:"10px 20px"}} onClick={handleGenerate} disabled={generating}>
            {generating?"⏳ Generating...":keyInfo?.hasKey?"🔄 Regenerate Key":"🔑 Generate API Key"}
          </button>
          {keyInfo?.created_at && <span style={{fontSize:11,color:"var(--muted)"}}>Created: {new Date(keyInfo.created_at).toLocaleDateString("en-IN")}</span>}
        </div>
        {keyInfo?.hasKey && <p style={{fontSize:11,color:"var(--muted)",marginTop:8}}>⚠️ Regenerating will break existing integrations until you update the key in your store.</p>}
      </div>

      {/* ── WEBHOOK URL ── */}
      <div className="card" style={{marginBottom:16}}>
        <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>🌐 Webhook URL</h3>
        <p style={{color:"var(--muted)",fontSize:12,marginBottom:14}}>Send COD order data from your store to this URL. Select your platform:</p>

        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14}}>
          {platforms.map(p=>(
            <div key={p.id} onClick={()=>setPlatform(p.id)} style={{
              padding:"6px 14px",borderRadius:20,fontSize:12,fontWeight:600,cursor:"pointer",
              border:`1px solid ${platform===p.id?"var(--gold)":"var(--border)"}`,
              background:platform===p.id?"rgba(245,158,11,.12)":"transparent",
              color:platform===p.id?"var(--gold)":"var(--muted)",transition:"all .15s",
            }}>{p.label}</div>
          ))}
        </div>

        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <code style={{background:"var(--sf2)",padding:"10px 14px",borderRadius:8,fontSize:11,fontFamily:"monospace",color:"var(--blue)",wordBreak:"break-all",flex:1,lineHeight:1.6}}>
            {platform==="shopify"?shopifyUrl:currentWebhookUrl}
          </code>
          <button className="btn-ghost" style={{padding:"9px 14px",fontSize:12,whiteSpace:"nowrap"}} onClick={()=>copyText(platform==="shopify"?shopifyUrl:currentWebhookUrl,"url")}>
            {copied==="url"?"✅ Copied!":"📋 Copy"}
          </button>
        </div>
        {platform==="shopify"
          ? <p style={{fontSize:11,color:"var(--muted)",marginTop:8}}>💡 For Shopify, your API key is embedded in the URL — no extra header needed.</p>
          : <p style={{fontSize:11,color:"var(--muted)",marginTop:8}}>💡 Send header: <code style={{background:"var(--sf2)",padding:"2px 6px",borderRadius:4}}>x-api-key: {displayKey||"YOUR_API_KEY"}</code></p>
        }
      </div>

      {/* ── INSTRUCTIONS ── */}
      <div className="card">
        <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:16}}>📋 Setup Instructions</h3>

        {(platform==="universal"||platform==="other") && (
          <div>
            <div style={{fontWeight:700,fontSize:13,marginBottom:12,color:"var(--gold)"}}>
              {platform==="other"?"📦 Any Platform / Custom API":"🌐 Universal / Wix / Custom"}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
              {universalSteps.map((step,i)=>(
                <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                  <div style={{background:"var(--gold)",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0,marginTop:2}}>{i+1}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.65}}>{step}</div>
                </div>
              ))}
            </div>
            <div style={{background:"var(--sf2)",border:"1px solid var(--border)",borderRadius:10,padding:14,marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:700}}>📝 Required JSON Body</div>
                <button className="btn-ghost" style={{padding:"4px 10px",fontSize:11}} onClick={()=>copyText(samplePayload,"payload")}>{copied==="payload"?"✅ Copied!":"📋 Copy"}</button>
              </div>
              <pre style={{fontSize:11,color:"var(--muted)",margin:0,overflowX:"auto",lineHeight:1.7,fontFamily:"monospace"}}>{samplePayload}</pre>
              <div style={{marginTop:10,fontSize:11,color:"var(--muted)",lineHeight:1.8}}>
                <strong>Required:</strong> buyer_name, order_amount (min ₹200), and at least one of buyer_phone / buyer_email<br/>
                <strong>Optional:</strong> token_pct (5–100, default 10%), platform_order_id (for your reference)
              </div>
            </div>
            <div style={{background:"var(--sf2)",border:"1px solid var(--border)",borderRadius:10,padding:14,marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:700}}>🧪 Test with cURL</div>
                <button className="btn-ghost" style={{padding:"4px 10px",fontSize:11}} onClick={()=>copyText(curlExample,"curl")}>{copied==="curl"?"✅ Copied!":"📋 Copy"}</button>
              </div>
              <pre style={{fontSize:10,color:"var(--muted)",margin:0,lineHeight:1.8,fontFamily:"monospace",whiteSpace:"pre-wrap",wordBreak:"break-all"}}>{curlExample}</pre>
            </div>
            <div style={{background:"var(--sf2)",border:"1px solid var(--border)",borderRadius:10,padding:14}}>
              <div style={{fontSize:12,fontWeight:700,marginBottom:8}}>✅ Success Response</div>
              <pre style={{fontSize:11,color:"var(--muted)",margin:0,fontFamily:"monospace",lineHeight:1.7}}>{`{\n  "success": true,\n  "escara_order_id": "EP-ABCD1234",\n  "payment_link": "https://escarapay.in/pay/EP-ABCD1234",\n  "token_amount": 250,\n  "buyer_pays": 255,\n  "message": "Order created. Buyer notified via email."\n}`}</pre>
            </div>
          </div>
        )}

        {platform==="shopify" && (
          <div>
            <div style={{fontWeight:700,fontSize:13,marginBottom:12,color:"#5c6ac4"}}>🛒 Shopify Native Webhook Setup</div>
            <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
              {shopifySteps.map((step,i)=>(
                <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                  <div style={{background:"#5c6ac4",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0,marginTop:2}}>{i+1}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.65}}>{step}</div>
                </div>
              ))}
            </div>
            <div style={{background:"rgba(92,106,196,.08)",border:"1px solid rgba(92,106,196,.3)",borderRadius:10,padding:14}}>
              <div style={{fontWeight:700,fontSize:12,marginBottom:6,color:"#5c6ac4"}}>🔗 Your Shopify Webhook URL (key embedded):</div>
              <code style={{fontSize:11,wordBreak:"break-all",color:"var(--gold)",fontFamily:"monospace",lineHeight:1.7,display:"block"}}>{shopifyUrl}</code>
              <button className="btn-ghost" style={{marginTop:10,padding:"6px 14px",fontSize:12}} onClick={()=>copyText(shopifyUrl,"shopify")}>{copied==="shopify"?"✅ Copied!":"📋 Copy Shopify URL"}</button>
            </div>
            <div style={{background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.2)",borderRadius:10,padding:14,marginTop:12}}>
              <div style={{fontWeight:700,fontSize:12,marginBottom:4}}>ℹ️ Shopify fields auto-parsed:</div>
              <code style={{fontSize:11,color:"var(--muted)",fontFamily:"monospace",lineHeight:2,display:"block"}}>
                buyer_name ← billing_address.first_name + last_name<br/>
                buyer_email ← email<br/>
                buyer_phone ← billing_address.phone (last 10 digits)<br/>
                product_name ← line_items names + quantities<br/>
                order_amount ← total_price<br/>
                platform_order_id ← SHOPIFY-order_number
              </code>
            </div>
          </div>
        )}

        {platform==="woocommerce" && (
          <div>
            <div style={{fontWeight:700,fontSize:13,marginBottom:12,color:"#7f54b3"}}>🔌 WooCommerce Webhook Setup</div>
            <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
              {wooSteps.map((step,i)=>(
                <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                  <div style={{background:"#7f54b3",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0,marginTop:2}}>{i+1}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.65}}>{step}</div>
                </div>
              ))}
            </div>
            <div style={{background:"rgba(127,84,179,.08)",border:"1px solid rgba(127,84,179,.3)",borderRadius:10,padding:14}}>
              <div style={{fontWeight:700,fontSize:12,marginBottom:6,color:"#7f54b3"}}>🔗 WooCommerce Delivery URL:</div>
              <code style={{fontSize:11,wordBreak:"break-all",color:"var(--gold)",fontFamily:"monospace",display:"block",lineHeight:1.7}}>{WEBHOOK_URLS.woocommerce}</code>
              <button className="btn-ghost" style={{marginTop:10,padding:"6px 14px",fontSize:12}} onClick={()=>copyText(WEBHOOK_URLS.woocommerce,"woo")}>{copied==="woo"?"✅ Copied!":"📋 Copy URL"}</button>
              <div style={{borderTop:"1px solid var(--border)",marginTop:12,paddingTop:12}}>
                <div style={{fontWeight:700,fontSize:12,marginBottom:6,color:"#7f54b3"}}>🔁 Using Zapier / Make? Map these fields:</div>
                <code style={{fontSize:11,color:"var(--muted)",fontFamily:"monospace",lineHeight:2,display:"block"}}>
                  buyer_name ← billing.first_name + billing.last_name<br/>
                  buyer_email ← billing.email<br/>
                  buyer_phone ← billing.phone (10 digits)<br/>
                  product_name ← line_items[0].name<br/>
                  order_amount ← total<br/>
                  platform_order_id ← id
                </code>
              </div>
            </div>
          </div>
        )}

        <div style={{marginTop:20,padding:14,background:"rgba(239,68,68,.05)",border:"1px solid rgba(239,68,68,.18)",borderRadius:10}}>
          <div style={{fontWeight:700,fontSize:12,marginBottom:6}}>⚠️ Important Notes</div>
          <div style={{fontSize:12,color:"var(--muted)",lineHeight:2}}>
            • Only COD/Cash-on-Delivery orders need EscaraPay — prepaid orders are automatically skipped.<br/>
            • Buyer gets a token payment email instantly after webhook. Dispatch only after token is paid.<br/>
            • Min order amount: ₹200 · Max: ₹5,00,000 · Default token: 10% of order amount.<br/>
            • Webhook orders appear in your dashboard under Orders with status "Pending".<br/>
            • Need help? <a href="mailto:support@escarapay.in" style={{color:"var(--blue)"}}>support@escarapay.in</a>
          </div>
        </div>
      </div>
    </div>
  );
}


/* ══════════ SELLER SETTINGS COMPONENT ══════════ */
function SellerSettings({ userId, userName, BACKEND_URL, onTypeUpdate }) {
  const [form, setForm] = useState({ shop_name:"", phone:"", upi_id:"", seller_type:null, website_url:"" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const authHdrSS = () => {
    const t = localStorage.getItem("escara_auth_token") || "";
    return t ? { "Content-Type":"application/json","Authorization":`Bearer ${t}` } : { "Content-Type":"application/json" };
  };

  useEffect(() => {
    const load = async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/users/${userId}/profile`, { headers: authHdrSS() });
        const d = await r.json();
        if (d.success && d.user) {
          setForm({
            shop_name:   d.user.shop_name  || "",
            phone:       d.user.phone      || "",
            upi_id:      d.user.upi_id     || "",
            seller_type: d.user.seller_type|| null,
            website_url: d.user.website_url|| "",
          });
        }
      } catch(e) {}
      setLoading(false);
    };
    if (userId) load();
  }, [userId, BACKEND_URL]);

  const handleSave = async () => {
    setSaving(true); setMsg("");
    try {
      const r = await fetch(`${BACKEND_URL}/api/users/${userId}/update-profile`, {
        method:"POST", headers: authHdrSS(),
        body: JSON.stringify({ ...form, user_id: userId }),
      });
      const d = await r.json();
      setSaving(false);
      if (d.success) {
        setMsg("✅ Profile updated successfully!");
        if (onTypeUpdate) onTypeUpdate(form.seller_type, form.website_url);
      } else setMsg("❌ " + (d.error || "Update failed"));
    } catch(e) { setSaving(false); setMsg("❌ Could not connect to server."); }
  };

  const sellerTypes = [
    { id:"social_media", icon:"📱", label:"Social Media", desc:"Instagram, WhatsApp, Facebook" },
    { id:"website",      icon:"🏪", label:"Website Store", desc:"Shopify, Wix, WooCommerce" },
  ];

  if (loading) return <div style={{padding:40,textAlign:"center",color:"var(--muted)"}}>⏳ Loading...</div>;

  return (
    <div className="fu">
      <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:22}}>Settings</h1>

      {/* ── Seller Type Card ── */}
      <div className="card" style={{maxWidth:480,marginBottom:16}}>
        <h3 className="syne" style={{fontWeight:700,marginBottom:4,fontSize:15}}>🏪 Seller Type</h3>
        <p style={{color:"var(--muted)",fontSize:12,marginBottom:14}}>Helps EscaraPay personalise your dashboard and features.</p>
        <div style={{display:"flex",gap:10,marginBottom:form.seller_type==="website"?14:0}}>
          {sellerTypes.map(st=>(
            <div key={st.id} onClick={()=>setForm({...form,seller_type:form.seller_type===st.id?null:st.id})} style={{
              flex:1,padding:14,borderRadius:12,cursor:"pointer",textAlign:"center",transition:"all .15s",
              border:`2px solid ${form.seller_type===st.id?"var(--gold)":"var(--border)"}`,
              background:form.seller_type===st.id?"rgba(245,158,11,.1)":"transparent",
            }}>
              <div style={{fontSize:26,marginBottom:4}}>{st.icon}</div>
              <div style={{fontWeight:700,fontSize:13}}>{st.label}</div>
              <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>{st.desc}</div>
              {form.seller_type===st.id && <div style={{marginTop:6,fontSize:11,color:"var(--gold)",fontWeight:700}}>✅ Selected</div>}
            </div>
          ))}
        </div>
        {form.seller_type==="website" && (
          <div>
            <label className="label">Store Website URL</label>
            <div style={{display:"flex",gap:8}}>
              <input className="input" style={{flex:1}} placeholder="https://yourstore.com"
                value={form.website_url} onChange={e=>setForm({...form,website_url:e.target.value})} />
              {form.website_url && (
                <button className="btn-ghost" style={{padding:"0 12px",fontSize:12,color:"var(--red)"}}
                  onClick={()=>setForm({...form,website_url:""})}>✕ Clear</button>
              )}
            </div>
            {form.website_url && safeUrl(form.website_url) && (
              <div style={{fontSize:11,color:"var(--muted)",marginTop:4}}>
                🔗 <a href={safeUrl(form.website_url)} target="_blank" rel="noopener noreferrer" style={{color:"var(--blue)"}}>{form.website_url}</a>
              </div>
            )}
            <div style={{marginTop:10,background:"rgba(245,158,11,.08)",border:"1px solid rgba(245,158,11,.25)",borderRadius:8,padding:10,fontSize:12,color:"#92400e"}}>
              💡 Go to <strong>Integration tab</strong> in sidebar to connect your store and auto-protect COD orders.
            </div>
          </div>
        )}
        {!form.seller_type && (
          <div style={{fontSize:11,color:"var(--muted)",textAlign:"center",marginTop:8}}>Click a card above to select your seller type</div>
        )}
      </div>

      {/* ── Profile & Payment Card ── */}
      <div className="card" style={{maxWidth:480}}>
        <h3 className="syne" style={{fontWeight:700,marginBottom:16,fontSize:15}}>Profile & Payment Details</h3>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label className="label">Shop Name</label>
            <input className="input" placeholder="Your Shop Name" value={form.shop_name} onChange={e=>setForm({...form,shop_name:e.target.value})} />
          </div>
          <div>
            <label className="label">Phone Number</label>
            <input className="input" placeholder="10-digit phone number" maxLength={10} value={form.phone} onChange={e=>setForm({...form,phone:e.target.value.replace(/[^0-9]/g,"")})} />
          </div>
          <div>
            <label className="label">UPI ID <span style={{color:"var(--green)",fontSize:11,fontWeight:600}}>★ For receiving payments</span></label>
            <input className="input" placeholder="yourname@upi (e.g. 9876543210@ybl)" value={form.upi_id} onChange={e=>setForm({...form,upi_id:e.target.value})} />
            <div style={{fontSize:11,color:"var(--muted)",marginTop:4}}>EscaraPay will send your earnings to this UPI ID after delivery confirmation.</div>
          </div>
          {msg && <div style={{padding:10,borderRadius:8,fontSize:13,fontWeight:600,background:msg.startsWith("✅")?"rgba(5,150,105,.1)":"rgba(239,68,68,.1)",color:msg.startsWith("✅")?"var(--green)":"var(--red)"}}>{msg}</div>}
          <button className="btn-gold" style={{padding:"12px"}} onClick={handleSave} disabled={saving}>{saving?"⏳ Saving...":"💾 Save Changes"}</button>
        </div>
        <div style={{marginTop:20,padding:14,background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.2)",borderRadius:10}}>
          <div style={{fontWeight:700,fontSize:13,marginBottom:6}}>💡 Why add UPI ID?</div>
          <div style={{fontSize:12,color:"var(--muted)",lineHeight:1.7}}>When a buyer confirms delivery, EscaraPay sends your 95% token amount to this UPI ID. Your UPI ID is kept private from buyers.</div>
        </div>
      </div>
    </div>
  );
}

/* ══════════ SELLER DASHBOARD ══════════ */
function SellerDB({ user, userId, onLogout, dark, onToggle, sellerType: initSellerType, websiteUrl: initWebsiteUrl }) {
  const [sellerType, setSellerType] = useState(initSellerType || null);
  const [websiteUrl, setWebsiteUrl] = useState(initWebsiteUrl || "");
  const [page, setPage] = useState("dashboard");
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showCreate, setShowCreate] = useState(false);
  const [showOrder, setShowOrder] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [userName, setUserName] = useState(user);
  const [newOrder, setNewOrder] = useState({product:"",amount:"",buyer_name:"",buyer_phone:"",token_pct:"10"});
  const [createdLink, setCreatedLink] = useState(null);
  const [creating, setCreating] = useState(false);
  const [toast, setToast] = useState("");

  useEffect(()=>{
    const load = async()=>{ setLoadingOrders(true); const r=await getSellerOrders(userId); if(r.success) setOrders(r.data.orders||[]); setLoadingOrders(false); };
    if(userId) load();
  },[userId]);

  const stats = {
    total: orders.length,
    active: orders.filter(o=>["token_paid","dispatched"].includes(o.status)).length,
    earned: orders.filter(o=>o.status==="delivered").reduce((a,o)=>a+(o.seller_receives||0),0),
    saved: orders.filter(o=>o.status==="cancelled_buyer").reduce((a,o)=>a+(o.seller_receives||0),0),
  };

  const tokenPreview = newOrder.amount ? calcToken(newOrder.amount,newOrder.token_pct) : 0;
  const rawToken = newOrder.amount ? Math.round(Number(newOrder.amount)*Number(newOrder.token_pct)/100) : 0;
  const minApplied = newOrder.amount && rawToken < MIN_TOKEN;
  const filteredOrders = filterStatus==="all" ? orders : orders.filter(o=>o.status===filterStatus);

  const handleCreateOrder = async()=>{
    if(!newOrder.product||!newOrder.amount) return;
    setCreating(true);
    const r = await apiCreateOrder(userId,newOrder.product,Number(newOrder.amount),Number(newOrder.token_pct),newOrder.buyer_name,newOrder.buyer_phone);
    setCreating(false);
    if(r.success){ setOrders([r.data.order,...orders]); setCreatedLink(r.data.paymentLink); setNewOrder({product:"",amount:"",buyer_name:"",buyer_phone:"",token_pct:"10"}); }
    else alert("❌ "+r.error);
  };

  const copyLink = (orderId) => { navigator.clipboard?.writeText(`${BASE_URL}/pay/${orderId}`); setToast("Link copied! Share on WhatsApp 🚀"); };
  const shareWhatsApp = (orderId, productName, tokenAmount) => {
    const link = `${BASE_URL}/pay/${orderId}`;
    const msg = `🛡️ *EscaraPay Secure Payment*\n\nProduct: ${productName}\nToken Amount: ₹${tokenAmount}\n\nPay securely via this link:\n${link}\n\n_Powered by EscaraPay_`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
  };

  const nav = [{id:"dashboard",icon:"📊",label:"Dashboard"},{id:"orders",icon:"📦",label:"Orders"},{id:"analytics",icon:"📈",label:"Analytics"},{id:"payments",icon:"💰",label:"Payments"},{id:"payouts",icon:"🏦",label:"Payouts"},{id:"settings",icon:"⚙️",label:"Settings"},{id:"integration",icon:"🔗",label:"Integration",badge:sellerType==="website"?"Live":null}];

  return (
    <div style={{minHeight:"100vh"}}>
      {toast && <Toast msg={toast} onDone={()=>setToast("")} />}
      {showProfile && <ProfileModal user={userName} userId={userId} userType="seller" onClose={()=>setShowProfile(false)} onUpdate={(n)=>setUserName(n)} />}
      <nav className="nav">
        <Logo />
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <ThemeToggle dark={dark} onToggle={onToggle} />
          <span className="badge bg hide-m">● Live</span>
          <div className="avatar" style={{cursor:"pointer"}} onClick={()=>setShowProfile(true)} title="Profile">{userName[0]}</div>
          <span className="hide-m" style={{fontSize:13,fontWeight:500,cursor:"pointer"}} onClick={()=>setShowProfile(true)}>{userName}</span>
          <button className="btn-ghost" style={{fontSize:12,padding:"6px 12px"}} onClick={onLogout}>Logout</button>
        </div>
      </nav>
      <div className="sidebar">
        <div style={{marginBottom:16,padding:"0 8px"}}><div style={{fontSize:10,color:"var(--muted)",fontWeight:700,textTransform:"uppercase",letterSpacing:".6px"}}>Seller Panel</div></div>
        {nav.map(n=>(<div key={n.id} className={`si ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span>{n.badge&&<span style={{marginLeft:"auto",background:"var(--green)",color:"#fff",borderRadius:8,fontSize:10,padding:"1px 6px",fontWeight:700,flexShrink:0}}>{n.badge}</span>}</div>))}
        <div style={{marginTop:"auto",paddingTop:16}}>
          <div className="card" style={{padding:14,background:"rgba(14,165,233,.08)",borderColor:"rgba(14,165,233,.2)"}}>
            <div style={{fontSize:11,color:"var(--gold)",fontWeight:700,marginBottom:4}}>Free Plan</div>
            <div style={{fontSize:12,color:"var(--muted)",marginBottom:10}}>5 orders/month free</div>
            <button className="btn-gold" style={{width:"100%",padding:"8px",fontSize:12}}>Upgrade Pro →</button>
          </div>
        </div>
      </div>
      {/* Mobile Bottom Nav */}
      <div className="mobile-nav">
        {nav.slice(0,4).map(n=>(<div key={n.id} className={`mni ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span></div>))}
        <div className="mni" onClick={onLogout}><span>🚪</span><span>Logout</span></div>
      </div>
      <div className="main">
        {page==="dashboard" && (
          <div className="fu">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22,flexWrap:"wrap",gap:10}}>
              <div><h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800}}>Welcome back, {user}! 👋</h1><p style={{color:"var(--muted)",marginTop:3,fontSize:13}}>Today's overview</p></div>
              <button className="btn-gold" style={{fontSize:13,padding:"9px 16px"}} onClick={()=>setShowCreate(true)}>+ New Order</button>
            </div>
            <div className="g4" style={{marginBottom:18}}>
              {[{label:"Total Orders",value:stats.total,icon:"📦",color:"var(--gold)"},{label:"Active Orders",value:stats.active,icon:"🔐",color:"var(--blue)"},{label:"Token Earned",value:`₹${stats.earned}`,icon:"💰",color:"var(--green)"},{label:"RTO Saved",value:`₹${stats.saved}`,icon:"🛡️",color:"var(--accent)"}].map(s=>(
                <div key={s.label} className="stat-card">
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div><div style={{fontSize:11,color:"var(--muted)",marginBottom:6}}>{s.label}</div><div className="syne" style={{fontSize:22,fontWeight:800,color:s.color}}>{s.value}</div></div>
                    <span style={{fontSize:20}}>{s.icon}</span>
                  </div>
                </div>
              ))}
            </div>
            {/* ── Integration Banner: Website Sellers ── */}
            {sellerType==="website" && (
              <div style={{background:"linear-gradient(135deg,rgba(245,158,11,.12),rgba(14,165,233,.08))",border:"1px solid rgba(245,158,11,.3)",borderRadius:14,padding:18,marginBottom:18,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
                <div style={{display:"flex",gap:14,alignItems:"center"}}>
                  <div style={{fontSize:36}}>🔗</div>
                  <div>
                    <div className="syne" style={{fontWeight:800,fontSize:15,marginBottom:3}}>Connect Your Store</div>
                    <div style={{fontSize:13,color:"var(--muted)"}}>Auto-protect every COD order from your website — no manual work.</div>
                    {websiteUrl && <div style={{fontSize:11,color:"var(--blue)",marginTop:3}}>🌐 {websiteUrl}</div>}
                  </div>
                </div>
                <button className="btn-gold" style={{fontSize:13,padding:"10px 18px",whiteSpace:"nowrap"}} onClick={()=>setPage("integration")}>
                  ⚡ Setup Integration →
                </button>
              </div>
            )}
            {/* ── Prompt: Unknown seller type ── */}
            {!sellerType && (
              <div style={{background:"rgba(14,165,233,.05)",border:"1px solid rgba(14,165,233,.2)",borderRadius:12,padding:12,marginBottom:18,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                <div style={{fontSize:13,color:"var(--muted)"}}>🏪 Have a website store? Connect it to auto-protect COD orders.</div>
                <button className="btn-ghost" style={{fontSize:12,padding:"6px 14px",whiteSpace:"nowrap"}} onClick={()=>setPage("settings")}>Set up →</button>
              </div>
            )}

            <div className="card" style={{overflowX:"auto"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <h3 className="syne" style={{fontWeight:700,fontSize:16}}>Recent Orders</h3>
                <button className="btn-ghost" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setPage("orders")}>View All →</button>
              </div>
              {loadingOrders ? <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading...</div>
               : orders.length===0 ? <div style={{textAlign:"center",padding:40,color:"var(--muted)"}}><div style={{fontSize:40,marginBottom:10}}>📦</div><div style={{fontWeight:600,marginBottom:6}}>No orders yet!</div><button className="btn-gold" style={{marginTop:8}} onClick={()=>setShowCreate(true)}>+ New Order Link</button></div>
               : (
                <table className="tbl">
                  <thead><tr><th>ID</th><th>Buyer</th><th>Product</th><th>Amount</th><th>Token</th><th>Status</th><th>Action</th></tr></thead>
                  <tbody>
                    {orders.slice(0,5).map(o=>(
                      <tr key={o.id}>
                        <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:12}}>{o.id}</span></td>
                        <td>{o.buyer_name||"—"}</td><td style={{color:"var(--muted)"}}>{o.product_name}</td>
                        <td style={{fontWeight:600}}>₹{o.order_amount}</td><td style={{color:"var(--green)",fontWeight:600}}>₹{o.token_amount}</td>
                        <td><Bdg status={o.status} /></td>
                        <td><div style={{display:"flex",gap:4}}>
                          <button className="btn-ghost" style={{padding:"4px 8px",fontSize:11}} onClick={()=>setShowOrder(o)}>Manage</button>
                          {o.status==="pending" && <button className="btn-whatsapp" style={{padding:"4px 8px",fontSize:11}} onClick={()=>shareWhatsApp(o.id,o.product_name,o.token_amount)}>🟢</button>}
                        </div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}

        {page==="orders" && (
          <div className="fu">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:10}}>
              <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800}}>All Orders</h1>
              <button className="btn-gold" style={{fontSize:13,padding:"9px 16px"}} onClick={()=>setShowCreate(true)}>+ New Order</button>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:18}}>
              <div className={`chip ${filterStatus==="all"?"active":""}`} onClick={()=>setFilterStatus("all")}>All ({orders.length})</div>
              {Object.entries(STATUS_META).map(([key,val])=>{ const count=orders.filter(o=>o.status===key).length; if(!count) return null; return <div key={key} className={`chip ${filterStatus===key?"active":""}`} onClick={()=>setFilterStatus(key)}>{val.icon} {val.label} ({count})</div>; })}
            </div>
            <div className="card" style={{padding:0,overflowX:"auto"}}>
              {loadingOrders ? <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading...</div> : (
                <table className="tbl">
                  <thead><tr><th>ID</th><th>Date</th><th>Buyer</th><th>Product</th><th>Amount</th><th>Token</th><th>Status</th><th>Action</th></tr></thead>
                  <tbody>
                    {filteredOrders.length===0 ? <tr><td colSpan={8} style={{textAlign:"center",color:"var(--muted)",padding:30}}>No orders found</td></tr>
                     : filteredOrders.map(o=>(
                      <tr key={o.id}>
                        <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</span></td>
                        <td style={{color:"var(--muted)",fontSize:11}}>{(o.created_at||"").split("T")[0]}</td>
                        <td>{o.buyer_name||"—"}</td><td style={{color:"var(--muted)"}}>{o.product_name}</td>
                        <td style={{fontWeight:600}}>₹{o.order_amount}</td><td style={{color:"var(--green)",fontWeight:600}}>₹{o.token_amount}</td>
                        <td><Bdg status={o.status} /></td>
                        <td><div style={{display:"flex",gap:4}}>
                          <button className="btn-ghost" style={{padding:"4px 8px",fontSize:11}} onClick={()=>setShowOrder(o)}>Manage</button>
                          {o.status==="pending" && <button className="btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"var(--gold)"}} onClick={()=>copyLink(o.id)}>📋</button>}
                          {o.status==="pending" && <button className="btn-whatsapp" style={{padding:"4px 8px",fontSize:11}} onClick={()=>shareWhatsApp(o.id,o.product_name,o.token_amount)}>🟢</button>}
                        </div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}

        {page==="analytics" && (
          <div className="fu">
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:22}}>Analytics</h1>
            <div className="g2">
              <div className="card">
                <h3 className="syne" style={{fontWeight:700,marginBottom:16,fontSize:15}}>Status Breakdown</h3>
                {orders.length===0 ? <div style={{color:"var(--muted)",fontSize:13}}>No orders found</div> : Object.entries(STATUS_META).map(([key,val])=>{ const count=orders.filter(o=>o.status===key).length; if(!count) return null; const pct=Math.round((count/orders.length)*100); return (<div key={key} style={{marginBottom:13}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:12}}>{val.icon} {val.label}</span><span style={{fontSize:12,color:"var(--muted)"}}>{count} ({pct}%)</span></div><div className="pbar"><div className="pfill" style={{width:`${pct}%`}} /></div></div>); })}
              </div>
              <div className="card">
                <h3 className="syne" style={{fontWeight:700,marginBottom:16,fontSize:15}}>Revenue</h3>
                {[["Total Orders",orders.length],["GMV",`₹${orders.reduce((a,o)=>a+(o.order_amount||0),0).toLocaleString()}`],["Token Collected",`₹${orders.reduce((a,o)=>a+(o.token_amount||0),0).toLocaleString()}`],["Commission",`₹${orders.reduce((a,o)=>a+(o.escara_commission||0),0)}`]].map(([l,v])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid var(--border)"}}><span style={{color:"var(--muted)",fontSize:13}}>{l}</span><span className="syne" style={{fontWeight:700,color:"var(--gold)"}}>{v}</span></div>
                ))}
              </div>
            </div>
          </div>
        )}
        {page==="payments" && (
          <div className="fu">
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:6}}>Payments & Earnings 💰</h1>
            <p style={{color:"var(--muted)",fontSize:13,marginBottom:22}}>An overview of all your transactions and earnings</p>

            {/* Summary Cards */}
            <div className="g3" style={{marginBottom:20}}>
              {[
                {label:"Total Token Collected",value:`₹${orders.filter(o=>o.status!=="pending").reduce((a,o)=>a+(o.token_amount||0),0).toLocaleString()}`,icon:"💰",color:"var(--gold)"},
                {label:"Earnings Released",value:`₹${orders.filter(o=>o.status==="delivered").reduce((a,o)=>a+(o.seller_receives||0),0).toLocaleString()}`,icon:"✅",color:"var(--green)"},
                {label:"In Hold",value:`₹${orders.filter(o=>["token_paid","dispatched"].includes(o.status)).reduce((a,o)=>a+(o.seller_receives||0),0).toLocaleString()}`,icon:"🔐",color:"var(--blue)"},
              ].map(s=>(
                <div key={s.label} className="stat-card">
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div><div style={{fontSize:11,color:"var(--muted)",marginBottom:6}}>{s.label}</div><div className="syne" style={{fontSize:22,fontWeight:800,color:s.color}}>{s.value}</div></div>
                    <span style={{fontSize:22}}>{s.icon}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Fee Structure */}
            <div className="card" style={{marginBottom:16}}>
              <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:16}}>💡 Fee Structure</h3>
              <div style={{display:"flex",flexDirection:"column",gap:0}}>
                {[
                  {label:"Token Amount (min)", value:"₹200", color:"var(--text)"},
                  {label:"Gateway Fee (Buyer pays)", value:"2%", color:"var(--muted)"},
                  {label:"EscaraPay Commission", value:"5%", color:"var(--red)"},
                  {label:"Seller Receives", value:"95% of token", color:"var(--green)", bold:true},
                  {label:"Buyer Cancels", value:"Token → Seller ✅", color:"var(--green)"},
                  {label:"Seller Doesn't Ship", value:"Token → Buyer ↩️", color:"var(--blue)"},
                ].map(r=>(
                  <div key={r.label} style={{display:"flex",justifyContent:"space-between",padding:"11px 0",borderBottom:"1px solid var(--border)"}}>
                    <span style={{fontSize:13,color:"var(--muted)"}}>{r.label}</span>
                    <span style={{fontSize:13,fontWeight:r.bold?700:600,color:r.color}}>{r.value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Transaction History */}
            <div className="card" style={{marginBottom:16}}>
              <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:16}}>📋 Order-wise Earnings</h3>
              {orders.length===0 ? (
                <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>No orders yet</div>
              ) : (
                <div style={{overflowX:"auto"}}>
                  <table className="tbl">
                    <thead><tr><th>Order ID</th><th>Product</th><th>Order Amt</th><th>Token</th><th>Commission</th><th>You Receive</th><th>Status</th></tr></thead>
                    <tbody>
                      {orders.map(o=>(
                        <tr key={o.id}>
                          <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</span></td>
                          <td style={{fontSize:12,color:"var(--muted)"}}>{o.product_name}</td>
                          <td style={{fontSize:12}}>₹{o.order_amount}</td>
                          <td style={{color:"var(--blue)",fontWeight:600,fontSize:12}}>₹{o.token_amount}</td>
                          <td style={{color:"var(--red)",fontSize:12}}>-₹{o.escara_commission||0}</td>
                          <td style={{color:"var(--green)",fontWeight:700,fontSize:12}}>₹{o.seller_receives||0}</td>
                          <td><Bdg status={o.status} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Payout Info */}
            <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:12,padding:16}}>
              <div className="syne" style={{fontWeight:700,fontSize:14,marginBottom:10}}>🏦 Payout System — Coming Soon!</div>
              <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>
                Cashfree Live mode active. Bank transfers processed after delivery:<br/>
                ✅ Direct bank transfer within 2-3 business days<br/>
                ✅ UPI instant payout<br/>
                ✅ Withdrawal history dashboard<br/>
                ✅ GST invoice generation
              </div>
            </div>
          </div>
        )}
        {page==="payouts" && (
          <div className="fu">
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:6}}>Payout History 🏦</h1>
            <p style={{color:"var(--muted)",fontSize:13,marginBottom:22}}>All released & delivered orders — payments you have received</p>

            {/* Summary */}
            {(() => {
              const released = orders.filter(o => ["delivered","cancelled_buyer"].includes(o.status));
              const totalPaid = released.reduce((a,o)=>a+(o.seller_receives||0),0);
              const thisMonth = released.filter(o => {
                const d = new Date(o.released_at || o.updated_at || o.created_at);
                const now = new Date();
                return d.getMonth()===now.getMonth() && d.getFullYear()===now.getFullYear();
              }).reduce((a,o)=>a+(o.seller_receives||0),0);
              const pending = orders.filter(o=>["token_paid","dispatched"].includes(o.status)).reduce((a,o)=>a+(o.seller_receives||0),0);
              return (
                <div className="g3" style={{marginBottom:20}}>
                  {[
                    {label:"Total Released",value:`₹${totalPaid.toLocaleString("en-IN")}`,icon:"✅",color:"var(--green)"},
                    {label:"This Month",value:`₹${thisMonth.toLocaleString("en-IN")}`,icon:"📅",color:"var(--gold)"},
                    {label:"In Escrow (Hold)",value:`₹${pending.toLocaleString("en-IN")}`,icon:"🔐",color:"var(--blue)"},
                  ].map(s=>(
                    <div key={s.label} className="stat-card">
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                        <div><div style={{fontSize:11,color:"var(--muted)",marginBottom:6}}>{s.label}</div><div className="syne" style={{fontSize:22,fontWeight:800,color:s.color}}>{s.value}</div></div>
                        <span style={{fontSize:22}}>{s.icon}</span>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Released Payouts Table */}
            <div className="card" style={{marginBottom:16}}>
              <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>✅ Released Payouts</h3>
              <p style={{color:"var(--muted)",fontSize:12,marginBottom:16}}>Delivered & buyer-cancelled orders — tokens credited to you</p>
              {orders.filter(o=>["delivered","cancelled_buyer"].includes(o.status)).length === 0 ? (
                <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>
                  <div style={{fontSize:36,marginBottom:8}}>💸</div>
                  <div>No payouts released yet</div>
                </div>
              ) : (
                <div style={{overflowX:"auto"}}>
                  <table className="tbl">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Product</th>
                        <th>Order Amt</th>
                        <th>Token</th>
                        <th>Commission (-5%)</th>
                        <th style={{color:"var(--green)"}}>You Received</th>
                        <th>Type</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.filter(o=>["delivered","cancelled_buyer"].includes(o.status)).map(o=>(
                        <tr key={o.id}>
                          <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</span></td>
                          <td style={{fontSize:12,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.product_name}</td>
                          <td style={{fontSize:12}}>₹{o.order_amount}</td>
                          <td style={{fontSize:12,color:"var(--blue)"}}>₹{o.token_amount}</td>
                          <td style={{fontSize:12,color:"var(--red)"}}>-₹{o.escara_commission||0}</td>
                          <td style={{fontSize:13,fontWeight:800,color:"var(--green)"}}>₹{o.seller_receives||0}</td>
                          <td>
                            {o.status==="delivered"
                              ? <span className="badge bg">✅ Delivered</span>
                              : <span className="badge bo">🛡️ Buyer Cancel</span>}
                          </td>
                          <td style={{fontSize:11,color:"var(--muted)",whiteSpace:"nowrap"}}>
                            {o.released_at ? new Date(o.released_at).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"})
                              : o.updated_at ? new Date(o.updated_at).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"})
                              : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* Total row */}
                  <div style={{background:"rgba(16,185,129,.06)",border:"1px solid rgba(16,185,129,.15)",borderRadius:"0 0 12px 12px",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontWeight:700,fontSize:13}}>Total Earnings</span>
                    <span className="syne" style={{fontWeight:800,fontSize:18,color:"var(--green)"}}>
                      ₹{orders.filter(o=>["delivered","cancelled_buyer"].includes(o.status)).reduce((a,o)=>a+(o.seller_receives||0),0).toLocaleString("en-IN")}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Escrow Hold */}
            {orders.filter(o=>["token_paid","dispatched"].includes(o.status)).length > 0 && (
              <div className="card" style={{marginBottom:16,borderColor:"rgba(56,189,248,.25)"}}>
                <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:4}}>🔐 In Escrow (Pending Release)</h3>
                <p style={{color:"var(--muted)",fontSize:12,marginBottom:14}}>These orders will be paid out once delivered</p>
                <div style={{overflowX:"auto"}}>
                  <table className="tbl">
                    <thead><tr><th>Order ID</th><th>Product</th><th>Token</th><th>Expected Payout</th><th>Status</th></tr></thead>
                    <tbody>
                      {orders.filter(o=>["token_paid","dispatched"].includes(o.status)).map(o=>(
                        <tr key={o.id}>
                          <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</span></td>
                          <td style={{fontSize:12}}>{o.product_name}</td>
                          <td style={{fontSize:12,color:"var(--blue)"}}>₹{o.token_amount}</td>
                          <td style={{fontSize:13,fontWeight:700,color:"var(--green)"}}>₹{o.seller_receives||0}</td>
                          <td><Bdg status={o.status} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

                        {/* Payout Status — Live */}
            {orders.filter(o=>["delivered","cancelled_buyer"].includes(o.status)).map(o=>(
              <div key={o.id} style={{
                background: o.payout_status==="paid"?"rgba(16,185,129,.06)":"rgba(251,146,60,.06)",
                border:`1px solid ${o.payout_status==="paid"?"rgba(16,185,129,.25)":"rgba(251,146,60,.25)"}`,
                borderRadius:12,padding:14,marginBottom:10
              }}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                  <div>
                    <div style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11,marginBottom:2}}>{o.id}</div>
                    <div style={{fontWeight:600,fontSize:14}}>{o.product_name}</div>
                    <div style={{fontSize:13,color:"var(--muted)",marginTop:3}}>
                      Token: ₹{o.token_amount} → <strong style={{color:"var(--green)"}}>You Received: ₹{o.seller_receives}</strong>
                    </div>
                  </div>
                  <div>{o.payout_status==="paid"?<span className="badge bg">✅ Payment Received</span>:<span className="badge borange">⏳ Payment Pending</span>}</div>
                </div>
                {o.payout_status==="paid" && (
                  <div style={{marginTop:10,padding:10,background:"rgba(16,185,129,.1)",borderRadius:8,fontSize:12}}>
                    <div style={{fontWeight:700,color:"var(--green)",marginBottom:6}}>💰 Payment Details:</div>
                    <div style={{display:"flex",flexDirection:"column",gap:4,color:"var(--muted)"}}>
                      {o.payout_method && <div>Method: <strong style={{color:"var(--text)"}}>{o.payout_method?.toUpperCase()}</strong></div>}
                      {o.payout_upi && <div>UPI ID: <strong style={{color:"var(--text)",fontFamily:"monospace"}}>{o.payout_upi}</strong></div>}
                      {o.payout_bank && <div>Bank: <strong style={{color:"var(--text)",fontFamily:"monospace"}}>{o.payout_bank}</strong></div>}
                      {o.payout_ref && <div>UTR/Ref No: <strong style={{color:"var(--gold)",fontFamily:"monospace",fontSize:13}}>{o.payout_ref}</strong></div>}
                      {o.payout_amount && <div>Amount: <strong style={{color:"var(--green)",fontSize:14}}>₹{o.payout_amount}</strong></div>}
                      {o.payout_at && <div>Date: <strong style={{color:"var(--text)"}}>{new Date(o.payout_at).toLocaleString("en-IN")}</strong></div>}
                      {o.payout_note && <div>Note: <strong style={{color:"var(--text)"}}>{o.payout_note}</strong></div>}
                    </div>
                  </div>
                )}
                {(!o.payout_status || o.payout_status==="pending") && (
                  <div style={{marginTop:8,fontSize:12,color:"var(--muted)",padding:"8px 10px",background:"rgba(251,146,60,.08)",borderRadius:8}}>
                    ⏳ Payment will be transferred to your UPI/Bank shortly. Queries? support@escarapay.in
                  </div>
                )}
              </div>
            ))}
            {orders.filter(o=>["delivered","cancelled_buyer"].includes(o.status)).length===0 && (
              <div style={{textAlign:"center",padding:24,color:"var(--muted)",background:"var(--sf2)",borderRadius:12}}>
                <div style={{fontSize:36,marginBottom:8}}>💸</div>
                <div style={{fontSize:13}}>No completed orders yet. Deliver orders to receive payment.</div>
              </div>
            )}
            <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:12,padding:14,marginTop:4}}>
              <div style={{fontWeight:700,fontSize:13,marginBottom:4}}>📞 Payment Query?</div>
              <div style={{fontSize:12,color:"var(--muted)"}}>support@escarapay.in | 24 hours mein reply</div>
            </div>
          </div>
        )}
        {page==="settings" && (
          <SellerSettings userId={userId} userName={user} BACKEND_URL={BACKEND_URL}
            onTypeUpdate={(st, wu) => { setSellerType(st); setWebsiteUrl(wu); }} />
        )}
        {page==="integration" && (
          <SellerIntegration userId={userId} BACKEND_URL={BACKEND_URL} />
        )}
      </div>

      {showCreate && (
        <div className="overlay" onClick={()=>{ if(!createdLink) setShowCreate(false); }}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            {!createdLink ? (
              <>
                <h3 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:4}}>New Protected Order</h3>
                <p style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>Create a secure payment link for your buyer</p>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div><label className="label">Product Name *</label><input className="input" placeholder="Handmade Bag" value={newOrder.product} onChange={e=>setNewOrder({...newOrder,product:e.target.value})} /></div>
                  <div className="g2">
                    <div><label className="label">Order Amount (₹) *</label><input className="input" type="number" placeholder="1500" value={newOrder.amount} onChange={e=>setNewOrder({...newOrder,amount:e.target.value})} /></div>
                    <div><label className="label">Token %</label><select className="select" value={newOrder.token_pct} onChange={e=>setNewOrder({...newOrder,token_pct:e.target.value})}><option value="5">5%</option><option value="10">10%</option><option value="15">15%</option><option value="20">20%</option></select></div>
                  </div>
                  {newOrder.amount && <div style={{background:"rgba(14,165,233,.1)",border:"1px solid rgba(14,165,233,.25)",borderRadius:10,padding:14}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Buyer Bharenga</div><div className="syne" style={{fontSize:24,fontWeight:800,color:"var(--gold)"}}>₹{Math.round(tokenPreview*1.02)}</div>{minApplied&&<div style={{fontSize:11,color:"var(--muted)",marginTop:4}}>Minimum token ₹200 applied</div>}</div>}
                  <div><label className="label">Buyer Name</label><input className="input" placeholder="Rahul Sharma" value={newOrder.buyer_name} onChange={e=>setNewOrder({...newOrder,buyer_name:e.target.value})} /></div>
                  <div><label className="label">Buyer WhatsApp *</label><input className="input" placeholder="9876543210" value={newOrder.buyer_phone} onChange={e=>setNewOrder({...newOrder,buyer_phone:e.target.value})} /></div>
                  <div style={{display:"flex",gap:10}}>
                    <button className="btn-ghost" style={{flex:1}} onClick={()=>setShowCreate(false)}>Cancel</button>
                    <button className="btn-gold" style={{flex:2}} onClick={handleCreateOrder} disabled={!newOrder.product||!newOrder.amount||creating}>{creating?"⏳ Creating...":"🔗 Generate Link"}</button>
                  </div>
                </div>
              </>
            ) : (
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:46,marginBottom:12}}>🎉</div>
                <h3 className="syne" style={{fontWeight:800,fontSize:21,marginBottom:8}}>Order Link Ready!</h3>
                <div style={{background:"var(--sf2)",borderRadius:10,padding:12,marginBottom:14,border:"1px solid var(--border)",wordBreak:"break-all"}}><code style={{fontSize:12,color:"var(--gold)"}}>{createdLink}</code></div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn-ghost" style={{flex:1}} onClick={()=>{ navigator.clipboard?.writeText(createdLink); setToast("Link copied!"); }}>📋 Copy</button>
                  <button className="btn-whatsapp" style={{flex:1,justifyContent:"center"}} onClick={()=>{ window.open(`https://wa.me/?text=${encodeURIComponent("🛡️ EscaraPay Payment Link:\n"+createdLink)}`, "_blank"); }}>🟢 WhatsApp</button>
                  <button className="btn-gold" style={{flex:1}} onClick={()=>{ setCreatedLink(null); setShowCreate(false); }}>Done ✅</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {showOrder && <OrderModal order={showOrder} isSeller sellerId={userId} onClose={()=>setShowOrder(null)} onDispatch={(id,tx,confirmUrl)=>{ setOrders(orders.map(o=>o.id===id?{...o,status:"dispatched",tracking_number:tx,confirm_token:confirmUrl?confirmUrl.split("/confirm/")[1]:o.confirm_token}:o)); setShowOrder(null); }} onConfirmDelivery={(id)=>setOrders(orders.map(o=>o.id===id?{...o,status:"delivered"}:o))} onDispute={(id)=>setOrders(orders.map(o=>o.id===id?{...o,status:"disputed"}:o))} />}
    </div>
  );
}

/* ══════════ BUYER DASHBOARD ══════════ */
function InlinePwdChange({ userId, onDone }) {
  const [f, setF] = useState({cur:"",nw:"",conf:""});
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const save = async() => {
    setErr("");
    if(!f.cur||!f.nw||!f.conf){setErr("All fields required");return;}
    if(f.nw!==f.conf){setErr("New passwords don't match");return;}
    if(f.nw.length<6){setErr("Password must be at least 6 characters");return;}
    setSaving(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/change-password`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({user_id:userId,current_password:f.cur,new_password:f.nw})});
      const d = await res.json();
      if(d.success){setF({cur:"",nw:"",conf:""});onDone("✅ Password changed successfully!");}
      else setErr(d.error||"Failed");
    } catch(e){setErr("Could not connect");}
    setSaving(false);
  };
  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div><label className="label">Current Password</label><input className="input" type="password" placeholder="Enter current password" value={f.cur} onChange={e=>setF({...f,cur:e.target.value})} /></div>
      <div><label className="label">New Password</label><input className="input" type="password" placeholder="Min 6 characters" value={f.nw} onChange={e=>setF({...f,nw:e.target.value})} /></div>
      <div><label className="label">Confirm New Password</label><input className="input" type="password" placeholder="Repeat new password" value={f.conf} onChange={e=>setF({...f,conf:e.target.value})} /></div>
      {err && <div style={{color:"var(--red)",fontSize:12}}>❌ {err}</div>}
      <button className="btn-gold" style={{width:"100%",padding:12}} disabled={saving} onClick={save}>{saving?"⏳ Saving...":"🔐 Change Password"}</button>
    </div>
  );
}

function BuyerDB({ user, userId, userPhone, onLogout, dark, onToggle }) {
  const [page, setPage] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showOrder, setShowOrder] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [userName, setUserName] = useState(user);
  const [payStep, setPayStep] = useState(0);
  const [payError, setPayError] = useState("");
  const [linkInput, setLinkInput] = useState("");
  const [linkOrder, setLinkOrder] = useState(null);
  const [linkLoading, setLinkLoading] = useState(false);
  const [linkError, setLinkError] = useState("");
  const [toast, setToast] = useState("");
  const [dealForm, setDealForm] = useState({product:"",amount:"",token_pct:"10",seller_name:"",seller_phone:""});
  const [dealCreating, setDealCreating] = useState(false);
  const [dealLink, setDealLink] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [settingsTab, setSettingsTab] = useState("profile");
  const [settingsForm, setSettingsForm] = useState({name:"",phone:"",email:""});
  const [settingsSaving, setSettingsSaving] = useState(false);

  useEffect(()=>{
    const load=async()=>{ setLoadingOrders(true); if(userPhone&&userPhone.trim()!==""){const r=await getBuyerOrders(userPhone.trim()); if(r.success) setOrders(r.data.orders||[]);} setLoadingOrders(false); };
    load();
  },[userPhone]);

  // Split orders: seller-created pending (action needed) vs rest
  const pendingSellerOrders = orders.filter(o=>o.status==="pending" && o.initiated_by==="seller");
  const otherOrders = orders.filter(o=>!(o.status==="pending" && o.initiated_by==="seller"));

  // Stats
  const totalSpent = orders.filter(o=>o.status!=="pending"&&o.status!=="cancelled").reduce((s,o)=>s+(Number(o.buyer_pays||o.token_amount)||0),0);
  const activeOrders = orders.filter(o=>["token_paid","dispatched"].includes(o.status)).length;

  // Search filter
  const sq = searchQuery.trim().toLowerCase();
  const searchedOther = sq ? otherOrders.filter(o=>(o.product_name||"").toLowerCase().includes(sq)||(o.id||"").toLowerCase().includes(sq)||(o.seller_name||"").toLowerCase().includes(sq)) : otherOrders;

  // Receipt PDF helper
  const downloadReceipt = (o) => {
    // ✅ SECURITY FIX: Escape all user-supplied data before document.write
    const esc = (s) => String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");
    const w = window.open("","_blank","width=600,height=700");
    w.document.write(`<!DOCTYPE html><html><head><title>EscaraPay Receipt — ${esc(o.id)}</title>
    <style>body{font-family:Arial,sans-serif;padding:40px;color:#0c2340;max-width:520px;margin:auto}
    .logo{font-size:22px;font-weight:800;color:#24A1E2;margin-bottom:4px}.sub{font-size:12px;color:#64748b;margin-bottom:28px}
    h2{font-size:18px;margin-bottom:20px}.row{display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #e2e8f0;font-size:14px}
    .row span:last-child{font-weight:600}.total{background:#f0fdf4;padding:12px 0;font-size:16px;font-weight:700;color:#065f46}
    .footer{margin-top:28px;font-size:11px;color:#94a3b8;text-align:center;border-top:1px solid #e2e8f0;padding-top:16px}
    @media print{button{display:none!important}}</style></head><body>
    <div class="logo">EscaraPay</div>
    <div class="sub">Payment Protection Platform | MSME: UDYAM-UP-23-0036110</div>
    <h2>Payment Receipt</h2>
    <div class="row"><span>Order ID</span><span>${esc(o.id)}</span></div>
    <div class="row"><span>Product</span><span>${esc(o.product_name)||"—"}</span></div>
    <div class="row"><span>Seller</span><span>${esc(o.seller_name)||"—"}</span></div>
    <div class="row"><span>Order Amount</span><span>₹${esc(o.order_amount)}</span></div>
    <div class="row"><span>Status</span><span>${esc(o.status)}</span></div>
    <div class="row"><span>Date</span><span>${esc((o.created_at||"").split("T")[0])}</span></div>
    <div class="row total"><span>Token Paid (Protected)</span><span>₹${esc(o.buyer_pays||o.token_amount)}</span></div>
    <div style="margin-top:20px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:14px;font-size:12px;color:#92400e">
      🔐 This token is held safely by EscaraPay until delivery is confirmed.
    </div>
    <div class="footer">Generated on ${esc(new Date().toLocaleString("en-IN"))} | support@escarapay.in | escarapay.in</div>
    <br/><button onclick="window.print()" style="background:#24A1E2;color:#fff;border:none;padding:10px 28px;border-radius:8px;font-size:14px;cursor:pointer;margin-top:10px">🖨️ Print / Save PDF</button>
    </body></html>`);
    w.document.close();
  };

  const loadCashfree = () => new Promise((resolve, reject) => {
    if (document.getElementById("cashfree-script")) { resolve(); return; }
    const s = document.createElement("script");
    s.id = "cashfree-script";
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.onload = resolve; s.onerror = reject;
    document.body.appendChild(s);
  });

  const handlePay = async(order)=>{
    setPayError(""); setPayStep(1);
    try { await loadCashfree(); }
    catch(e) { setPayError("Payment gateway failed to load. Please try again."); setPayStep(0); return; }
    const result=await createPaymentOrder(order.id);
    if(!result.success){setPayError(result.error);setPayStep(0);return;}
    const { paymentSessionId } = result.data;
    setPayStep(0);
    const cashfree = window.Cashfree({ mode: "production" });
    cashfree.checkout({ paymentSessionId, redirectTarget: "_modal" }).then(async(res) => {
      if (res.error) { setPayError(res.error.message || "Payment failed"); return; }
      if (res.paymentDetails?.paymentStatus === "FAILED") { setPayError("Payment failed. Please try again."); return; }
      setPayStep(2);
      const verify=await verifyPayment(null,null,null,order.id);
      if(verify.success){
        setPayStep(3);
        setOrders(prev=>prev.map(o=>o.id===order.id?{...o,status:"token_paid"}:o));
        setLinkOrder(prev=>prev&&prev.id===order.id?{...prev,status:"token_paid"}:prev);
        setReceipt({...order, status:"token_paid", paid_at: new Date().toLocaleString("en-IN")});
        setTimeout(()=>{setPayStep(0);},2500);
      } else { setPayError("Verify failed: "+verify.error); setPayStep(0); }
    }).catch(e => { setPayError("Payment cancelled or failed."); setPayStep(0); });
  };

  const fetchLinkOrder=async()=>{
    setLinkError(""); setLinkOrder(null);
    if(!linkInput){setLinkError("Please paste the payment link!");return;}
    const match=linkInput.match(/EP[A-Z0-9]+/);
    if(!match){setLinkError("Invalid EscaraPay link!");return;}
    setLinkLoading(true);
    const r=await getOrderById(match[0]);
    setLinkLoading(false);
    if(r.success) setLinkOrder(r.data.order);
    else setLinkError("Order not found: "+r.error);
  };

  const handleCreateDeal = async()=>{
    if(!dealForm.product||!dealForm.amount){alert("❌ Product name and amount are required!"); return;}
    setDealCreating(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/orders/buyer-create`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ buyer_id:userId, buyer_name:user, buyer_phone:userPhone, product_name:dealForm.product, order_amount:Number(dealForm.amount), token_pct:Number(dealForm.token_pct), seller_name:dealForm.seller_name, seller_phone:dealForm.seller_phone }),
      });
      const data = await res.json();
      setDealCreating(false);
      if (data.success) { setDealLink(data.dealLink); setDealForm({product:"",amount:"",token_pct:"10",seller_name:"",seller_phone:""}); }
      else alert("❌ "+data.error);
    } catch(e) { setDealCreating(false); alert("❌ Could not connect to server. Please try again."); }
  };

  const tokenPreview2 = dealForm.amount ? calcToken(dealForm.amount, dealForm.token_pct) : 0;
  const filteredOrders = filterStatus==="all" ? orders : orders.filter(o=>o.status===filterStatus);

  const nav = [{id:"orders",icon:"📦",label:"My Orders"},{id:"pay_order",icon:"🔗",label:"Pay via Link"},{id:"create_deal",icon:"🤝",label:"Create Deal"},{id:"settings",icon:"⚙️",label:"Settings"},{id:"help",icon:"❓",label:"Help"}];

  return (
    <div style={{minHeight:"100vh"}}>
      {toast && <Toast msg={toast} onDone={()=>setToast("")} />}
      {showProfile && <ProfileModal user={userName} userId={userId} userType="buyer" onClose={()=>setShowProfile(false)} onUpdate={(n)=>setUserName(n)} />}

      {/* ── Receipt Modal ── */}
      {receipt && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setReceipt(null)}>
          <div style={{background:"var(--sf)",borderRadius:16,padding:28,maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}} onClick={e=>e.stopPropagation()}>
            <div style={{textAlign:"center",marginBottom:20}}>
              <div style={{fontSize:52,marginBottom:8}}>✅</div>
              <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:4}}>Payment Successful!</div>
              <div style={{fontSize:13,color:"var(--muted)"}}>Token secured — seller will dispatch soon</div>
            </div>
            <div style={{background:"var(--sf2)",borderRadius:12,padding:16,marginBottom:16,display:"flex",flexDirection:"column",gap:10}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span style={{color:"var(--muted)"}}>Order ID</span><span style={{fontWeight:600,fontFamily:"monospace"}}>{receipt.id}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span style={{color:"var(--muted)"}}>Product</span><span style={{fontWeight:600}}>{receipt.product_name}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span style={{color:"var(--muted)"}}>Seller</span><span style={{fontWeight:600}}>{receipt.seller_name||"—"}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span style={{color:"var(--muted)"}}>Order Amount</span><span style={{fontWeight:600}}>₹{receipt.order_amount}</span></div>
              <div style={{height:1,background:"var(--border)"}}/>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:15}}><span style={{color:"var(--muted)",fontWeight:600}}>Token Paid</span><span style={{fontWeight:800,color:"var(--green)"}}>₹{receipt.buyer_pays||receipt.token_amount}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}><span style={{color:"var(--muted)"}}>Paid At</span><span>{receipt.paid_at}</span></div>
            </div>
            <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.2)",borderRadius:10,padding:12,fontSize:12,color:"#065f46",marginBottom:16}}>
              🔐 Your token is held safely by EscaraPay. It will be released to the seller only after you confirm delivery — or automatically in 14 days.
            </div>
            <div style={{display:"flex",gap:8}}>
              <button className="btn-ghost" style={{flex:1,fontSize:13}} onClick={()=>{const txt=`EscaraPay Payment Receipt\nOrder: ${receipt.id}\nProduct: ${receipt.product_name}\nToken Paid: ₹${receipt.buyer_pays||receipt.token_amount}\nDate: ${receipt.paid_at}`;navigator.clipboard?.writeText(txt);setToast("Receipt copied!");}}>📋 Copy Receipt</button>
              <button className="btn-green" style={{flex:1,fontSize:13}} onClick={()=>setReceipt(null)}>Done ✓</button>
            </div>
          </div>
        </div>
      )}
      <nav className="nav">
        <Logo />
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <ThemeToggle dark={dark} onToggle={onToggle} />
          <div className="avatar" style={{background:"linear-gradient(135deg,var(--blue),var(--accent))",cursor:"pointer"}} onClick={()=>setShowProfile(true)} title="Profile">{userName[0]}</div>
          <span className="hide-m" style={{fontSize:13,fontWeight:500,cursor:"pointer"}} onClick={()=>setShowProfile(true)}>{userName}</span>
          <button className="btn-ghost" style={{fontSize:12,padding:"6px 12px"}} onClick={onLogout}>Logout</button>
        </div>
      </nav>
      <div className="sidebar">
        <div style={{marginBottom:16,padding:"0 8px"}}><div style={{fontSize:10,color:"var(--muted)",fontWeight:700,textTransform:"uppercase",letterSpacing:".6px"}}>Buyer Panel</div></div>
        {nav.map(n=>(<div key={n.id} className={`si ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span></div>))}
      </div>
      {/* Mobile Bottom Nav */}
      <div className="mobile-nav">
        {nav.map(n=>(<div key={n.id} className={`mni ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span></div>))}
        <div className="mni" onClick={onLogout}><span>🚪</span><span>Logout</span></div>
      </div>
      <div className="main">
        {page==="orders" && (
          <div className="fu">
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,marginBottom:14}}>My Orders</h1>
            {(!userPhone||userPhone.trim()==="") && <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,padding:14,marginBottom:14,fontSize:13}}>⚠️ Phone number not found. Please logout and login again.</div>}

            {/* ── Stats Cards ── */}
            {orders.length>0 && (
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:18}}>
                {[
                  {label:"Total Orders",val:orders.length,icon:"📦",color:"var(--blue)"},
                  {label:"Active",val:activeOrders,icon:"🚚",color:"#f59e0b"},
                  {label:"Total Spent",val:`₹${totalSpent.toLocaleString("en-IN")}`,icon:"💳",color:"var(--green)"},
                ].map(s=>(
                  <div key={s.label} className="card" style={{padding:"12px 14px",textAlign:"center"}}>
                    <div style={{fontSize:20,marginBottom:4}}>{s.icon}</div>
                    <div style={{fontWeight:800,fontSize:"clamp(13px,3vw,18px)",color:s.color}}>{s.val}</div>
                    <div style={{fontSize:10,color:"var(--muted)",marginTop:2}}>{s.label}</div>
                  </div>
                ))}
              </div>
            )}

            {loadingOrders ? <div style={{textAlign:"center",padding:40,color:"var(--muted)"}}>⏳ Loading orders...</div> : <>

              {/* ── Pending Payments Section ── */}
              {pendingSellerOrders.length>0 && (
                <div style={{marginBottom:24}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                    <div style={{width:8,height:8,borderRadius:"50%",background:"#f59e0b",boxShadow:"0 0 8px #f59e0b"}}/>
                    <span style={{fontWeight:700,fontSize:15,color:"#b45309"}}>Action Required — {pendingSellerOrders.length} Pending Payment{pendingSellerOrders.length>1?"s":""}</span>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    {pendingSellerOrders.map(o=>(
                      <div key={o.id} className="card" style={{borderColor:"rgba(245,158,11,.4)",background:"rgba(245,158,11,.04)",display:"flex",flexDirection:"column",gap:10}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                          <div style={{display:"flex",gap:12,alignItems:"center"}}>
                            <div style={{width:44,height:44,borderRadius:11,background:"rgba(245,158,11,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>💳</div>
                            <div>
                              <div style={{fontWeight:700,marginBottom:2,fontSize:14}}>{o.product_name}</div>
                              <div style={{fontSize:12,color:"var(--muted)"}}>Seller: {o.seller_name||"—"} • {(o.created_at||"").split("T")[0]}</div>
                              <div style={{fontSize:12,marginTop:3}}>Order: <strong>₹{o.order_amount}</strong> | Token: <span style={{color:"var(--gold)",fontWeight:700}}>₹{o.token_amount}</span></div>
                            </div>
                          </div>
                          <span style={{background:"rgba(245,158,11,.15)",color:"#b45309",padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>⏳ PAYMENT DUE</span>
                        </div>
                        <div style={{background:"rgba(245,158,11,.08)",border:"1px solid rgba(245,158,11,.2)",borderRadius:8,padding:"10px 12px",fontSize:12,color:"#92400e"}}>
                          🔐 Pay ₹{o.buyer_pays||o.token_amount} token to secure this order. Seller will dispatch only after payment.
                        </div>
                        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                          <button className="btn-gold pulse" style={{flex:1,padding:"10px 0",fontSize:14,fontWeight:700}} onClick={()=>handlePay(o)}>💳 Pay ₹{o.buyer_pays||o.token_amount} Now</button>
                          <button className="btn-outline" style={{padding:"9px 12px",fontSize:12}} onClick={()=>window._goToTrack&&window._goToTrack(o.id)}>🔍 Track</button>
                          <button className="btn-ghost" style={{padding:"9px 12px",fontSize:12}} onClick={()=>setShowOrder(o)}>Details</button>
                        </div>
                        {payStep>0 && <div style={{textAlign:"center",fontSize:13,color:"var(--muted)",padding:6}}>{payStep===1?"⏳ Loading payment gateway...":(payStep===2?"⏳ Verifying payment...":"✅ Payment confirmed!")}</div>}
                        {payError && <div style={{color:"var(--red)",fontSize:12,padding:"4px 0"}}>❌ {payError}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ── Order History Section ── */}
              {otherOrders.length>0 && <>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
                  {pendingSellerOrders.length>0 && <div style={{fontSize:13,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".5px"}}>Order History</div>}
                  {/* ── Search Bar ── */}
                  <div style={{position:"relative",flex:1,minWidth:180,maxWidth:320}}>
                    <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:14,pointerEvents:"none"}}>🔍</span>
                    <input className="input" style={{paddingLeft:32,paddingTop:7,paddingBottom:7,fontSize:13,height:"auto"}} placeholder="Search product, order ID, seller…" value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} />
                  </div>
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
                  <div className={`chip ${filterStatus==="all"?"active":""}`} onClick={()=>setFilterStatus("all")}>All ({otherOrders.length})</div>
                  {Object.entries(STATUS_META).map(([key,val])=>{ const count=otherOrders.filter(o=>o.status===key).length; if(!count) return null; return <div key={key} className={`chip ${filterStatus===key?"active":""}`} onClick={()=>setFilterStatus(key)}>{val.icon} {val.label} ({count})</div>; })}
                </div>
                {searchedOther.length===0 && sq && <div style={{textAlign:"center",padding:24,color:"var(--muted)",fontSize:13}}>🔍 No orders found for "{searchQuery}"</div>}
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {(filterStatus==="all"?searchedOther:searchedOther.filter(o=>o.status===filterStatus)).map(o=>{
                    const daysLeft=o.status==="dispatched"?getDaysLeft(o.dispatched_at||o.updated_at):null;
                    const trackingUrl=getTrackingUrl(o.tracking_number);
                    const waSellerLink = o.seller_phone ? `https://wa.me/91${o.seller_phone.replace(/\D/g,"")}?text=${encodeURIComponent("Hi, I have a question about my EscaraPay order "+o.id+" ("+o.product_name+")")}` : null;
                    return (
                      <div key={o.id} className="card" style={{display:"flex",flexDirection:"column",gap:10}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                          <div style={{display:"flex",gap:12,alignItems:"center"}}>
                            <div style={{width:44,height:44,borderRadius:11,background:"var(--sf2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🛍️</div>
                            <div>
                              <div style={{fontWeight:600,marginBottom:2,fontSize:14}}>{o.product_name}</div>
                              <div style={{fontSize:12,color:"var(--muted)"}}>Seller: {o.seller_name||"—"} • {(o.created_at||"").split("T")[0]}</div>
                              <div style={{fontSize:12,marginTop:2}}>₹{o.order_amount} | Token: <span style={{color:"var(--gold)",fontWeight:600}}>₹{o.buyer_pays||o.token_amount}</span></div>
                            </div>
                          </div>
                          <Bdg status={o.status} />
                        </div>
                        {o.tracking_number && <div className="tracking-box"><div style={{flex:1}}><div style={{fontSize:11,color:"var(--blue)",fontWeight:600,marginBottom:2}}>📦 Tracking</div><div style={{fontFamily:"monospace",fontWeight:700}}>{o.tracking_number}</div></div>{trackingUrl&&<a href={trackingUrl} target="_blank" rel="noreferrer" style={{background:"var(--blue)",color:"#fff",padding:"6px 12px",borderRadius:8,fontSize:12,fontWeight:600,textDecoration:"none"}}>Track →</a>}</div>}
                        {o.status==="dispatched"&&daysLeft!==null&&<div className="hold-box"><div style={{fontSize:12,color:"#a78bfa",fontWeight:600}}>⏰ {daysLeft>0?`Token Hold: ${daysLeft} day${daysLeft===1?"":"s"} remaining`:"Auto-release ready!"}</div></div>}
                        <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                          {o.status==="dispatched"&&<button className="btn-green" style={{padding:"7px 12px",fontSize:12}} onClick={()=>confirmDelivery(o.id).then(r=>{if(r.success)setOrders(prev=>prev.map(x=>x.id===o.id?{...x,status:"delivered"}:x));})}>✅ Confirm Delivery</button>}
                          {["dispatched","token_paid","delivered"].includes(o.status)&&<button className="btn-outline" style={{padding:"6px 11px",fontSize:12}} onClick={()=>window._goToTrack&&window._goToTrack(o.id)}>🔍 Track</button>}
                          {waSellerLink && <a href={waSellerLink} target="_blank" rel="noreferrer" style={{background:"#25D366",color:"#fff",padding:"6px 11px",borderRadius:8,fontSize:12,fontWeight:600,textDecoration:"none",display:"flex",alignItems:"center",gap:4}}>💬 WhatsApp</a>}
                          {["token_paid","dispatched","delivered"].includes(o.status)&&<button className="btn-ghost" style={{padding:"6px 11px",fontSize:12}} onClick={()=>downloadReceipt(o)}>🧾 Receipt</button>}
                          <button className="btn-ghost" style={{padding:"6px 11px",fontSize:12}} onClick={()=>{ setDealForm({product:o.product_name||"",amount:o.order_amount||"",token_pct:"10",seller_name:o.seller_name||"",seller_phone:o.seller_phone||""}); setPage("create_deal"); setToast("Reorder form pre-filled!"); }}>🔁 Reorder</button>
                          <button className="btn-ghost" style={{padding:"6px 11px",fontSize:12}} onClick={()=>setShowOrder(o)}>Details</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>}

              {/* ── Empty State ── */}
              {orders.length===0 && (
                <div style={{textAlign:"center",padding:40,color:"var(--muted)"}}>
                  <div style={{fontSize:40,marginBottom:10}}>🛍️</div>
                  <div style={{fontWeight:600,marginBottom:6}}>No orders yet!</div>
                  <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap",marginTop:14}}>
                    <button className="btn-gold" onClick={()=>setPage("pay_order")}>🔗 Pay via Link</button>
                    <button className="btn-outline" onClick={()=>setPage("create_deal")}>🤝 Create Deal</button>
                  </div>
                </div>
              )}
            </>}
          </div>
        )}

        {page==="pay_order" && (
          <div className="fu" style={{maxWidth:500}}>
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:800,marginBottom:8}}>Pay via Order Link</h1>
            <p style={{color:"var(--muted)",marginBottom:20,fontSize:13}}>Paste the seller's payment link to view details and pay securely</p>
            <div className="card" style={{marginBottom:14}}>
              <label className="label">EscaraPay Order Link</label>
              <input className="input" placeholder="https://www.escarapay.in/pay/ORDER-ID" value={linkInput} onChange={e=>setLinkInput(e.target.value)} style={{marginBottom:10}} />
              <button className="btn-gold" style={{width:"100%"}} onClick={fetchLinkOrder}>{linkLoading?"⏳ Looking up order...":"🔍 Find Order"}</button>
              {linkError && <div style={{color:"var(--red)",fontSize:12,marginTop:8}}>❌ {linkError}</div>}
            </div>
            {linkOrder && (
              <div className="card" style={{background:"rgba(14,165,233,.06)",borderColor:"rgba(14,165,233,.3)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
                  <div><div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>{linkOrder.id}</div><div className="syne" style={{fontWeight:800,fontSize:18}}>{linkOrder.product_name}</div><div style={{fontSize:13,color:"var(--muted)",marginTop:4}}>Seller: {linkOrder.seller_name||"—"}</div></div>
                  <Bdg status={linkOrder.status} />
                </div>
                <div className="g2" style={{marginBottom:14}}>
                  <div style={{background:"var(--sf2)",borderRadius:10,padding:12,textAlign:"center"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Order Amount</div><div className="syne" style={{fontWeight:800,fontSize:20}}>₹{linkOrder.order_amount}</div></div>
                  <div style={{background:"rgba(14,165,233,.15)",borderRadius:10,padding:12,textAlign:"center",border:"1px solid rgba(14,165,233,.3)"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Token (Protected)</div><div className="syne" style={{fontWeight:800,fontSize:20,color:"var(--gold)"}}>₹{linkOrder.token_amount}</div></div>
                </div>
                {linkOrder.status==="pending" ? (
                  <button className="btn-gold pulse" style={{width:"100%",padding:13,fontSize:15}} onClick={()=>handlePay(linkOrder)}>💳 Pay ₹{linkOrder.buyer_pays||linkOrder.token_amount} Token</button>
                ) : (
                  <div style={{textAlign:"center",padding:12,color:"var(--muted)",fontSize:13}}>Payment already completed &nbsp;<Bdg status={linkOrder.status} /></div>
                )}
              </div>
            )}
          </div>
        )}

        {page==="create_deal" && (
          <div className="fu" style={{maxWidth:520}}>
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:800,marginBottom:8}}>Create a Deal 🤝</h1>
            <p style={{color:"var(--muted)",marginBottom:16,fontSize:13}}>Want extra security? Create the deal yourself — the seller will confirm, then you pay safely.</p>
            {!dealLink ? (
              <div className="card">
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div><label className="label">Product / Service *</label><input className="input" placeholder="Handmade Saree" value={dealForm.product} onChange={e=>setDealForm({...dealForm,product:e.target.value})} /></div>
                  <div className="g2">
                    <div><label className="label">Order Amount (₹) *</label><input className="input" type="number" placeholder="2000" value={dealForm.amount} onChange={e=>setDealForm({...dealForm,amount:e.target.value})} /></div>
                    <div><label className="label">Token %</label><select className="select" value={dealForm.token_pct} onChange={e=>setDealForm({...dealForm,token_pct:e.target.value})}><option value="5">5%</option><option value="10">10%</option><option value="15">15%</option><option value="20">20%</option></select></div>
                  </div>
                  {dealForm.amount && <div style={{background:"rgba(14,165,233,.1)",border:"1px solid rgba(14,165,233,.25)",borderRadius:10,padding:14}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Token Amount (You Pay)</div><div className="syne" style={{fontSize:24,fontWeight:800,color:"var(--gold)"}}>₹{Math.round(tokenPreview2*1.02)}</div></div>}
                  <div><label className="label">Seller's Name (optional)</label><input className="input" placeholder="Meena Crafts" value={dealForm.seller_name} onChange={e=>setDealForm({...dealForm,seller_name:e.target.value})} /></div>
                  <div><label className="label">Seller's WhatsApp (optional)</label><input className="input" placeholder="9876543210" value={dealForm.seller_phone} onChange={e=>setDealForm({...dealForm,seller_phone:e.target.value})} /></div>
                  <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handleCreateDeal} disabled={!dealForm.product||!dealForm.amount||dealCreating}>{dealCreating?"⏳ Creating deal...":"🤝 Generate Deal Link"}</button>
                </div>
              </div>
            ) : (
              <div className="card" style={{textAlign:"center"}}>
                <div style={{fontSize:46,marginBottom:12}}>🎉</div>
                <h3 className="syne" style={{fontWeight:800,fontSize:21,marginBottom:8}}>Deal Link Ready!</h3>
                <div style={{background:"var(--sf2)",borderRadius:10,padding:12,marginBottom:14,border:"1px solid var(--border)",wordBreak:"break-all"}}><code style={{fontSize:12,color:"#a78bfa"}}>{dealLink}</code></div>
                <div style={{display:"flex",gap:8,marginBottom:12}}>
                  <button className="btn-ghost" style={{flex:1}} onClick={()=>{ navigator.clipboard?.writeText(dealLink); setToast("Deal link copied!"); }}>📋 Copy</button>
                  <button className="btn-gold" style={{flex:1}} onClick={()=>setDealLink(null)}>New Deal</button>
                </div>
              </div>
            )}
          </div>
        )}

        {page==="settings" && (
          <div className="fu" style={{maxWidth:520}}>
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:800,marginBottom:18}}>⚙️ Settings</h1>
            <div style={{display:"flex",gap:8,marginBottom:20}}>
              {[{id:"profile",label:"👤 Profile"},{id:"security",label:"🔐 Password"}].map(t=>(
                <div key={t.id} className={`chip ${settingsTab===t.id?"active":""}`} onClick={()=>setSettingsTab(t.id)}>{t.label}</div>
              ))}
            </div>
            {settingsTab==="profile" && (
              <div className="card">
                <div style={{display:"flex",flexDirection:"column",gap:14}}>
                  <div><label className="label">Full Name</label><input className="input" placeholder={userName} value={settingsForm.name} onChange={e=>setSettingsForm({...settingsForm,name:e.target.value})} /></div>
                  <div><label className="label">Phone Number</label><input className="input" placeholder={userPhone||"Not set"} value={settingsForm.phone} onChange={e=>setSettingsForm({...settingsForm,phone:e.target.value})} /></div>
                  <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:8,padding:"10px 12px",fontSize:12,color:"var(--muted)"}}>
                    ℹ️ Email change requires OTP verification — contact support@escarapay.in
                  </div>
                  <button className="btn-gold" style={{width:"100%",padding:12}} disabled={settingsSaving||(!settingsForm.name&&!settingsForm.phone)} onClick={async()=>{
                    setSettingsSaving(true);
                    try {
                      const res = await fetch(`${BACKEND_URL}/api/users/${userId}/update-profile`, {method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({name:settingsForm.name||undefined,phone:settingsForm.phone||undefined})});
                      const d = await res.json();
                      if(d.success){ if(settingsForm.name) setUserName(settingsForm.name); setSettingsForm({name:"",phone:"",email:""}); setToast("✅ Profile updated!"); }
                      else setToast("❌ "+d.error);
                    } catch(e){ setToast("❌ Could not save"); }
                    setSettingsSaving(false);
                  }}>{settingsSaving?"⏳ Saving...":"💾 Save Changes"}</button>
                </div>
              </div>
            )}
            {settingsTab==="security" && (
              <div className="card">
                <InlinePwdChange userId={userId} onDone={(msg)=>setToast(msg)} />
              </div>
            )}
          </div>
        )}

        {page==="help" && (
          <div className="fu" style={{maxWidth:560}}>
            <h1 className="syne" style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:800,marginBottom:22}}>Help & Safety</h1>
            {[
              {q:"What is the difference between Create Deal and Pay via Link?",a:"Pay via Link: Seller created the order. Create Deal: You create the order, seller confirms. Both offer the same protection!"},
              {q:"When does the seller receive the token?",a:"Token is held for 14 days after dispatch. If no dispute is raised, it is auto-released to the seller."},
              {q:"Item not received?",a:"Go to 'View Details' → 'Raise Dispute'. Our team investigates within 24 hours."},
              {q:"How do I track my order?",a:"Click the 'Track →' button on your order card."},
            ].map(({q,a})=>(
              <div key={q} className="card" style={{marginBottom:10}}>
                <div style={{fontWeight:600,marginBottom:6,color:"var(--gold)",fontSize:13}}>❓ {q}</div>
                <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>{a}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showOrder && <OrderModal order={showOrder} isSeller={false} onClose={()=>setShowOrder(null)} onDispatch={()=>{}} onConfirmDelivery={(id)=>setOrders(prev=>prev.map(o=>o.id===id?{...o,status:"delivered"}:o))} onDispute={(id)=>setOrders(prev=>prev.map(o=>o.id===id?{...o,status:"disputed"}:o))} />}

      {(payStep>0||payError) && (
        <div className="overlay">
          <div className="modal" style={{textAlign:"center"}}>
            {payError?(<><div style={{fontSize:40,marginBottom:12}}>❌</div><div className="syne" style={{fontWeight:800,fontSize:18,color:"var(--red)",marginBottom:8}}>Payment Failed</div><div style={{color:"var(--muted)",fontSize:13,marginBottom:16}}>{payError}</div><button className="btn-ghost" style={{width:"100%"}} onClick={()=>{setPayError("");setPayStep(0);}}>Close</button></>)
             :payStep===1?(<><div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div className="syne" style={{fontWeight:700,fontSize:16}}>Loading payment gateway...</div></>)
             :payStep===2?(<><div style={{width:44,height:44,border:"3px solid var(--green)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div className="syne" style={{fontWeight:700,fontSize:16}}>Verifying payment...</div></>)
             :payStep===3?(<><div style={{fontSize:52,marginBottom:12}}>🎉</div><div className="syne" style={{fontWeight:800,fontSize:21,color:"var(--green)",marginBottom:8}}>Token Secured!</div><div style={{color:"var(--muted)",fontSize:13}}>Funds will be released to seller after delivery confirmation ✅</div></>)
             :null}
          </div>
        </div>
      )}
    </div>
  );
}

/* ══════════ ORDER TRACKING PAGE ══════════ */
function TrackPage({ orderId: initId, dark, onToggle, onGoHome }) {
  const [inputId, setInputId] = useState(initId || "");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    updateMeta({
      title: "Track Your Order | EscaraPay — Payment Protection India",
      description: "Track your EscaraPay protected order. Enter your Order ID to check delivery status, tracking details and token release status.",
      url: "https://www.escarapay.in/track",
      image: "https://www.escarapay.in/og-image.png"
    });
  }, []);

  useEffect(() => {
    if (initId) doSearch(initId);
  }, [initId]);

  const doSearch = async (id) => {
    const tid = (id || inputId).trim().toUpperCase();
    if (!tid) return;
    setLoading(true); setError(""); setOrder(null); setSearched(true);
    const r = await getOrderById(tid);
    setLoading(false);
    if (r.success) setOrder(r.data.order);
    else setError("No order found. Please double-check your Order ID.");
  };

  const trackingUrl = order ? getTrackingUrl(order.tracking_number) : null;
  const daysLeft = order ? getDaysLeft(order.dispatched_at || order.updated_at) : 7;

  const steps = [
    { label: "Order Created",       done: true,                                                                icon: "📋", color: "#10B981" },
    { label: "Token Paid",          done: order && order.status !== "pending" && order.status !== "pending_seller_confirm", icon: "💳", color: "#0ea5e9" },
    { label: "Dispatched by Seller",done: order && ["dispatched","delivered","disputed"].includes(order.status), icon: "🚚", color: "#8B5CF6" },
    { label: "Delivered",           done: order && order.status === "delivered",                               icon: "✅", color: "#10B981" },
  ];

  return (
    <div style={{ minHeight: "100vh" }}>
      <nav className="nav">
        <Logo onClick={onGoHome} />
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <ThemeToggle dark={dark} onToggle={onToggle} />
          <button className="btn-ghost" style={{ fontSize: 12 }} onClick={onGoHome}>← Home</button>
        </div>
      </nav>

      <div style={{ maxWidth: 540, margin: "0 auto", padding: "clamp(20px,5vw,50px) 16px" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 44, marginBottom: 10 }}>📦</div>
          <h1 className="syne" style={{ fontWeight: 800, fontSize: "clamp(22px,4vw,30px)", marginBottom: 6 }}>Track Your Order</h1>
          <p style={{ color: "var(--muted)", fontSize: 14 }}>Enter your Order ID to check status without logging in</p>
        </div>

        {/* Search Box */}
        <div className="card" style={{ marginBottom: 20 }}>
          <label className="label">Order ID</label>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              className="input"
              placeholder="ESC-XXXXXXXX"
              value={inputId}
              onChange={e => setInputId(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === "Enter" && doSearch()}
              style={{ fontFamily: "monospace", fontWeight: 700, letterSpacing: 1 }}
            />
            <button className="btn-gold" style={{ flexShrink: 0, padding: "11px 20px" }} onClick={() => doSearch()} disabled={loading}>
              {loading ? "⏳" : "🔍 Track"}
            </button>
          </div>
          <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 8 }}>
            💡 Your Order ID was shared by the seller or buyer on WhatsApp (e.g. ESC-A1B2C3D4)
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <div className="card" style={{ textAlign: "center", padding: 40 }}>
            <div style={{ width: 40, height: 40, border: "3px solid var(--gold)", borderTopColor: "transparent", borderRadius: "50%", animation: "spin .8s linear infinite", margin: "0 auto 12px" }} />
            <div style={{ color: "var(--muted)" }}>Looking up your order...</div>
          </div>
        )}

        {/* Error */}
        {!loading && searched && error && (
          <div className="card" style={{ textAlign: "center", padding: 32 }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>🔍</div>
            <div className="syne" style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>No Order Found</div>
            <div style={{ color: "var(--muted)", fontSize: 13 }}>{error}</div>
          </div>
        )}

        {/* Order Found */}
        {!loading && order && (
          <div className="fu">
            {/* Status Banner */}
            <div style={{
              background: order.status === "delivered" ? "rgba(16,185,129,.1)" : order.status === "disputed" ? "rgba(139,92,246,.1)" : order.status === "dispatched" ? "rgba(56,189,248,.1)" : "rgba(14,165,233,.1)",
              border: `1px solid ${order.status === "delivered" ? "rgba(16,185,129,.3)" : order.status === "disputed" ? "rgba(139,92,246,.3)" : order.status === "dispatched" ? "rgba(56,189,248,.3)" : "rgba(14,165,233,.3)"}`,
              borderRadius: 14, padding: "16px 20px", marginBottom: 16, display: "flex", alignItems: "center", gap: 14
            }}>
              <div style={{ fontSize: 32 }}>{(STATUS_META[order.status] || STATUS_META.pending).icon}</div>
              <div>
                <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 2 }}>Current Status</div>
                <div className="syne" style={{ fontWeight: 800, fontSize: 18 }}>{(STATUS_META[order.status] || STATUS_META.pending).label}</div>
              </div>
            </div>

            {/* Order Info */}
            <div className="card" style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
                <div>
                  <div style={{ fontFamily: "monospace", color: "var(--gold)", fontSize: 12, marginBottom: 3 }}>{order.id}</div>
                  <div className="syne" style={{ fontWeight: 800, fontSize: 18 }}>{order.product_name}</div>
                </div>
                <Bdg status={order.status} />
              </div>
              <div className="g2" style={{ marginBottom: 12 }}>
                <div style={{ background: "var(--sf2)", borderRadius: 10, padding: 12 }}>
                  <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 2 }}>Order Value</div>
                  <div className="syne" style={{ fontWeight: 800, fontSize: 20 }}>₹{order.order_amount}</div>
                </div>
                <div style={{ background: "rgba(14,165,233,.1)", border: "1px solid rgba(14,165,233,.2)", borderRadius: 10, padding: 12 }}>
                  <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 2 }}>Token Protected</div>
                  <div className="syne" style={{ fontWeight: 800, fontSize: 20, color: "var(--gold)" }}>₹{order.token_amount}</div>
                </div>
              </div>
              {order.seller_name && (
                <div style={{ fontSize: 13, color: "var(--muted)" }}>Seller: <strong style={{ color: "var(--text)" }}>{order.seller_name}</strong></div>
              )}
              {order.created_at && (
                <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>Order Date: {new Date(order.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</div>
              )}
            </div>

            {/* Timeline */}
            <div className="card" style={{ marginBottom: 14 }}>
              <div className="syne" style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>🗓️ Order Timeline</div>
              {steps.map((s, i) => (
                <div key={i} style={{ display: "flex", gap: 12, paddingBottom: i < steps.length - 1 ? 16 : 0, position: "relative" }}>
                  {i < steps.length - 1 && <div style={{ position: "absolute", left: 14, top: 30, bottom: 0, width: 2, background: s.done ? "rgba(16,185,129,.3)" : "var(--border)" }} />}
                  <div style={{ width: 30, height: 30, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, background: s.done ? `${s.color}22` : "var(--sf2)", border: `2px solid ${s.done ? s.color : "var(--border)"}`, color: s.done ? s.color : "var(--muted)" }}>
                    {s.done ? "✓" : s.icon}
                  </div>
                  <div style={{ paddingTop: 4, fontSize: 14, fontWeight: s.done ? 600 : 400, color: s.done ? "var(--text)" : "var(--muted)" }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Tracking Info */}
            {order.tracking_number && (
              <div className="card" style={{ marginBottom: 14, background: "rgba(56,189,248,.06)", borderColor: "rgba(56,189,248,.2)" }}>
                <div style={{ fontSize: 11, color: "var(--blue)", fontWeight: 700, marginBottom: 6 }}>📦 Courier Tracking</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  <code style={{ fontWeight: 700, fontSize: 15, color: "var(--text)" }}>{order.tracking_number}</code>
                  {trackingUrl && (
                    <a href={trackingUrl} target="_blank" rel="noreferrer" style={{ background: "var(--blue)", color: "#fff", padding: "7px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, textDecoration: "none", whiteSpace: "nowrap" }}>
                      Track on Courier →
                    </a>
                  )}
                </div>
                {order.dispatched_at && (
                  <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 8 }}>
                    Dispatched: {new Date(order.dispatched_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                  </div>
                )}
              </div>
            )}

            {/* 7-day hold info */}
            {order.status === "dispatched" && (
              <div style={{ background: "rgba(139,92,246,.08)", border: "1px solid rgba(139,92,246,.2)", borderRadius: 12, padding: 14, marginBottom: 14 }}>
                <div style={{ fontSize: 13, color: "#A78BFA", fontWeight: 700, marginBottom: 4 }}>⏰ Auto-Release Countdown</div>
                <div style={{ fontSize: 13, color: "var(--muted)" }}>
                  The escrow amount will be auto-released to the seller {daysLeft > 0 ? `in ${daysLeft} day${daysLeft===1?"":"s"}` : "today"} if the buyer does not confirm delivery.
                </div>
              </div>
            )}

            {/* Dispute info */}
            {order.status === "disputed" && order.dispute_reason && (
              <div style={{ background: "rgba(139,92,246,.08)", border: "1px solid rgba(139,92,246,.2)", borderRadius: 12, padding: 14, marginBottom: 14 }}>
                <div style={{ fontSize: 13, color: "#A78BFA", fontWeight: 700, marginBottom: 4 }}>⚠️ Dispute Active</div>
                <div style={{ fontSize: 13, color: "var(--muted)" }}>Reason: {order.dispute_reason}</div>
                <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>Our team will reach out within 24 business hours.</div>
              </div>
            )}

            {/* EscaraPay guarantee */}
            <div style={{ background: "rgba(16,185,129,.06)", border: "1px solid rgba(16,185,129,.15)", borderRadius: 12, padding: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "var(--green)", marginBottom: 6 }}>🛡️ EscaraPay Guarantee</div>
              <div style={{ fontSize: 12, color: "var(--muted)", lineHeight: 1.7 }}>Your payment is held securely in escrow. Need help? Contact us at support@escarapay.in</div>
            </div>
          </div>
        )}

        {/* Bottom buttons */}
        <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "center" }}>
          <button className="btn-ghost" onClick={onGoHome}>← Home</button>
          {order && (
            <button className="btn-ghost" style={{ color: "var(--muted)" }} onClick={() => { setOrder(null); setInputId(""); setSearched(false); }}>🔄 New Search</button>
          )}
        </div>
      </div>
    </div>
  );
}

/* ══════════ DEAL CONFIRM PAGE ══════════ */
function DealPage({ orderId, dark, onToggle, onGoHome }) {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [toast, setToast] = useState("");

  useEffect(()=>{ getOrderById(orderId).then(r=>{ setLoading(false); if(r.success) setOrder(r.data.order); else setError("Deal not found."); }); },[orderId]);

  const handleConfirm = async () => {
    const token = localStorage.getItem("escara_auth_token") || "";
    if (!token) {
      setError("Please log in to your seller account first to confirm this deal.");
      return;
    }
    setConfirming(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/orders/${orderId}/seller-confirm-deal`, {
        method:"POST",
        headers:{"Content-Type":"application/json", "Authorization": `Bearer ${token}`},
      });
      const data = await res.json();
      setConfirming(false);
      if (data.success) { setConfirmed(true); setPaymentLink(data.paymentLink); }
      else if (res.status === 401) setError("Your session has expired. Please log in again to confirm this deal.");
      else setError(data.error||"Confirmation failed");
    } catch(e) { setConfirming(false); setError("Could not connect to server. Please try again."); }
  };

  return (
    <div style={{minHeight:"100vh"}}>
      {toast && <Toast msg={toast} onDone={()=>setToast("")} />}
      <nav className="nav"><Logo onClick={onGoHome} /><div style={{display:"flex",gap:8,alignItems:"center"}}><ThemeToggle dark={dark} onToggle={onToggle} /><button className="btn-ghost" style={{fontSize:12}} onClick={onGoHome}>← Home</button></div></nav>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"calc(100vh - 62px)",padding:20}}>
        <div style={{width:"100%",maxWidth:480}}>
          {loading && <div className="card" style={{textAlign:"center",padding:50}}><div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}} /><div style={{color:"var(--muted)"}}>Deal load ho rahi hai...</div></div>}
          {error && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:40,marginBottom:12}}>❌</div><div className="syne" style={{fontWeight:800,fontSize:18,marginBottom:8}}>Deal Not Found</div><div style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>{error}</div><button className="btn-ghost" onClick={onGoHome}>← Home</button></div>}
          {order && order.status!=="pending_seller_confirm" && !confirmed && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:44,marginBottom:12}}>✅</div><div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>Deal Already Confirmed!</div><Bdg status={order.status} /><div style={{marginTop:14}}><button className="btn-ghost" onClick={onGoHome}>← Home</button></div></div>}
          {confirmed && (
            <div className="card fu" style={{textAlign:"center",padding:40}}>
              <div style={{fontSize:60,marginBottom:16}}>🎉</div>
              <div className="syne" style={{fontWeight:800,fontSize:24,color:"var(--green)",marginBottom:8}}>Deal Confirmed!</div>
              <div style={{color:"var(--muted)",fontSize:14,marginBottom:20}}>Now share the payment link with the buyer</div>
              <div style={{background:"var(--sf2)",borderRadius:8,padding:"10px 12px",marginBottom:10,wordBreak:"break-all"}}><code style={{fontSize:12,color:"var(--gold)"}}>{paymentLink}</code></div>
              <button className="btn-gold" style={{width:"100%"}} onClick={()=>{ navigator.clipboard?.writeText(paymentLink); setToast("Payment link copied!"); }}>📋 Copy Link</button>
            </div>
          )}
          {order && order.status==="pending_seller_confirm" && !confirmed && !loading && (
            <div className="fu">
              <div style={{textAlign:"center",marginBottom:20}}>
                <div className="badge borange" style={{fontSize:13,marginBottom:8}}>🤝 Buyer ne Deal Bheja Hai</div>
                <h2 className="syne" style={{fontWeight:800,fontSize:22}}>Confirm This Deal</h2>
              </div>
              <div className="card" style={{marginBottom:14}}>
                <div style={{marginBottom:16}}>
                  <div style={{fontSize:11,color:"var(--muted)",marginBottom:4}}>Deal ID: <span style={{fontFamily:"monospace",color:"var(--gold)"}}>{order.id}</span></div>
                  <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:4}}>{order.product_name}</div>
                  <div style={{fontSize:13,color:"var(--muted)"}}>Buyer: <strong style={{color:"var(--text)"}}>{order.buyer_name||"Anonymous"}</strong></div>
                </div>
                <div className="g2" style={{marginBottom:16}}>
                  <div style={{background:"var(--sf2)",borderRadius:10,padding:12,textAlign:"center"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>Order Value</div><div className="syne" style={{fontWeight:800,fontSize:22}}>₹{order.order_amount}</div></div>
                  <div style={{background:"rgba(5,150,105,.15)",borderRadius:10,padding:12,textAlign:"center"}}><div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>You Will Receive</div><div className="syne" style={{fontWeight:800,fontSize:22,color:"var(--green)"}}>₹{order.seller_receives}</div></div>
                </div>
                <button className="btn-green" style={{width:"100%",padding:"16px",fontSize:16,borderRadius:12,marginBottom:10}} onClick={handleConfirm} disabled={confirming}>{confirming?"⏳ Confirming...":"✅ Yes! I Will Ship This Order"}</button>
                <button className="btn-ghost" style={{width:"100%"}} onClick={onGoHome}>❌ Decline</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ══════════ ADMIN ══════════ */
const ADMIN_URL = BACKEND_URL;

/* ══════════ USER DETAIL MODAL (Admin) ══════════ */
function UserDetailModal({ user, adminToken, onClose, onUpdate }) {
  const [userOrders, setUserOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState("");
  const [warnReason, setWarnReason] = useState("");
  const [banReason, setBanReason] = useState("");
  const [msg, setMsg] = useState("");
  const [tab, setTab] = useState("actions");
  // Payout state
  const [payoutOrder, setPayoutOrder] = useState(null);
  const [payoutForm, setPayoutForm] = useState({ payout_to:"seller", payout_method:"upi", payout_ref:"", payout_upi:"", payout_bank:"", payout_amount:"", payout_note:"" });
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [payoutMsg, setPayoutMsg] = useState("");
  // Bulk payout
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [bulkForm, setBulkForm] = useState({ payout_method:"upi", payout_ref:"", payout_upi:"", payout_bank:"", payout_note:"" });
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkMsg, setBulkMsg] = useState("");

  // ✅ Bearer token auth — no raw password in headers
  const hdrs = { "Content-Type":"application/json", "Authorization": `Bearer ${adminToken}` };

  // Computed from userOrders
  const pendingPayouts = userOrders.filter(o => ["delivered","cancelled_buyer"].includes(o.status) && o.payout_status !== "paid");
  const donePayouts    = userOrders.filter(o => o.payout_status === "paid");

  const toggleOrder = (id) => setSelectedOrders(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]);
  const selectAll   = () => setSelectedOrders(pendingPayouts.map(o=>o.id));
  const clearAll    = () => setSelectedOrders([]);
  const selectedTotal = pendingPayouts.filter(o=>selectedOrders.includes(o.id)).reduce((a,o)=>a+(Number(o.seller_receives)||0),0);

  const selectPayoutOrder = (o) => {
    setPayoutOrder(o);
    setPayoutMsg("");
    setPayoutForm(prev => ({
      ...prev,
      payout_amount: o.seller_receives || "",
      payout_to: "seller",
      payout_upi: user.upi_id || prev.payout_upi || "",
    }));
  };

  const doBulkPayout = async () => {
    if (!selectedOrders.length) { setBulkMsg("❌ Please select at least one order"); return; }
    if (!bulkForm.payout_ref)   { setBulkMsg("❌ Transaction reference / UTR is required"); return; }
    if (bulkForm.payout_method === "upi"  && !bulkForm.payout_upi)  { setBulkMsg("❌ Please enter UPI ID"); return; }
    if (bulkForm.payout_method === "bank" && !bulkForm.payout_bank) { setBulkMsg("❌ Please enter bank details"); return; }
    setBulkLoading(true); setBulkMsg("");
    try {
      const r = await fetch(`${ADMIN_URL}/api/admin/bulk-payout`, {
        method:"POST", headers: hdrs,
        body: JSON.stringify({ ...bulkForm, order_ids: selectedOrders, admin_name:"Admin" }),
      });
      const d = await r.json();
      setBulkLoading(false);
      if (d.success) {
        setBulkMsg("✅ " + d.message);
        setUserOrders(prev => prev.map(o => selectedOrders.includes(o.id)
          ? { ...o, payout_status:"paid", payout_ref: bulkForm.payout_ref, payout_method: bulkForm.payout_method, payout_upi: bulkForm.payout_upi, payout_amount: o.seller_receives }
          : o
        ));
        setSelectedOrders([]);
        setBulkForm({ payout_method:"upi", payout_ref:"", payout_upi:"", payout_bank:"", payout_note:"" });
      } else setBulkMsg("❌ " + d.error);
    } catch(e) { setBulkLoading(false); setBulkMsg("❌ Could not connect to server. Please try again."); }
  };

  useEffect(()=>{
    const fetchOrders = async () => {
      try {
        const r = await fetch(`${ADMIN_URL}/api/admin/users/${user.id}/orders`, { headers: hdrs });
        const d = await r.json();
        if(d.success) setUserOrders(d.orders||[]);
      } catch(e) {}
      setLoading(false);
    };
    fetchOrders();
  },[]); // eslint-disable-line

  const doAction = async (action) => {
    setActionLoading(action);
    const reason = action==="warn" ? warnReason : banReason;
    try {
      const r = await fetch(`${ADMIN_URL}/api/admin/users/${user.id}/${action}`, {
        method:"POST", headers: hdrs, body: JSON.stringify({reason})
      });
      const d = await r.json();
      setActionLoading("");
      if(d.success) { setMsg(d.message); setTimeout(()=>{ onUpdate(user.id, action); }, 1500); }
      else setMsg("❌ "+d.error);
    } catch(e) { setActionLoading(""); setMsg("❌ Network error!"); }
  };

  const doManualPayout = async () => {
    if (!payoutOrder) { setPayoutMsg("❌ Please select an order first"); return; }
    if (!payoutForm.payout_ref) { setPayoutMsg("❌ Transaction reference / UTR is required"); return; }
    if (payoutForm.payout_method === "upi" && !payoutForm.payout_upi) { setPayoutMsg("❌ Please enter UPI ID"); return; }
    if (payoutForm.payout_method === "bank" && !payoutForm.payout_bank) { setPayoutMsg("❌ Please enter bank details"); return; }
    setPayoutLoading(true); setPayoutMsg("");
    try {
      const r = await fetch(`${ADMIN_URL}/api/admin/orders/${payoutOrder.id}/manual-payout`, {
        method:"POST", headers: hdrs,
        body: JSON.stringify({ ...payoutForm, payout_amount: payoutForm.payout_amount || payoutOrder.seller_receives, admin_name:"Admin" })
      });
      const d = await r.json();
      setPayoutLoading(false);
      if (d.success) {
        setPayoutMsg("✅ " + d.message);
        setUserOrders(prev => prev.map(o => o.id === payoutOrder.id ? { ...o, payout_status:"paid", payout_ref: payoutForm.payout_ref } : o));
        setPayoutOrder(null);
        setPayoutForm({ payout_to:"seller", payout_method:"upi", payout_ref:"", payout_upi:"", payout_bank:"", payout_amount:"", payout_note:"" });
      } else setPayoutMsg("❌ " + d.error);
    } catch(e) { setPayoutLoading(false); setPayoutMsg("❌ Network error!"); }
  };

  const isBanned = user.user_status === "banned";
  const warnCount = user.warning_count || 0;

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:560}} onClick={e=>e.stopPropagation()}>

        {/* Sticky Header + Tabs */}
        <div style={{position:"sticky",top:-20,background:"var(--surface)",zIndex:10,paddingTop:20,paddingBottom:12,marginTop:-20,marginLeft:-20,marginRight:-20,paddingLeft:20,paddingRight:20,borderBottom:"1px solid var(--border)",marginBottom:16}}>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div className="avatar" style={{width:40,height:40,fontSize:16,flexShrink:0,background:isBanned?"var(--red)":"linear-gradient(135deg,var(--gold),var(--accent))"}}>{user.name[0]}</div>
            <div>
              <div className="syne" style={{fontWeight:800,fontSize:15}}>{user.name}</div>
              <div style={{fontSize:11,color:"var(--muted)"}}>{user.role} • ID: {user.id}</div>
            </div>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
            <span className={`badge ${isBanned?"br":warnCount>0?"borange":"bg"}`} style={{fontSize:10}}>
              {isBanned?"🚫 Banned":warnCount>0?`⚠️ ${warnCount}w`:"✅ Active"}
            </span>
            {pendingPayouts.length > 0 && <span className="badge borange" style={{fontSize:10}}>💸 {pendingPayouts.length}</span>}
            <button className="btn-ghost" style={{padding:"4px 10px",fontSize:12}} onClick={onClose}>✕</button>
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",gap:4,background:"var(--sf2)",padding:4,borderRadius:10}}>
          {[["details","👤 Details"],["orders","📦 Orders"],["payouts","💸 Payouts"],["actions","⚙️ Actions"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)} style={{flex:1,padding:"7px 4px",border:"none",borderRadius:8,cursor:"pointer",background:tab===id?"var(--gold)":"transparent",color:tab===id?"#fff":"var(--muted)",fontFamily:"'Outfit',sans-serif",fontWeight:600,fontSize:11,transition:"all .2s",position:"relative"}}>
              {label}
              {id==="payouts" && pendingPayouts.length>0 && <span style={{position:"absolute",top:-4,right:-2,background:"var(--red)",color:"#fff",borderRadius:"50%",width:14,height:14,fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>{pendingPayouts.length}</span>}
            </button>
          ))}
        </div>
        </div>{/* end sticky */}

        {/* Details Tab */}
        {tab==="details" && (
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {[
              ["Name", user.name, undefined],
              ["Email", user.email, undefined],
              ["Phone", user.phone, undefined],
              ["Role", user.role, undefined],
              ["Seller Type", user.role==="seller" ? (user.seller_type==="website" ? "🏪 Website Store" : user.seller_type==="social_media" ? "📱 Social Media" : "Not set") : "—", user.seller_type?"var(--gold)":undefined],
              ["PAN", user.pan_number||"—", user.pan_number?"var(--green)":undefined],
              ["GST", user.gst_number||"—", user.gst_number?"var(--green)":undefined],
              ["Shop", user.shop_name||"—", undefined],
              ["UPI ID", user.upi_id||"—", user.upi_id?"var(--green)":undefined],
              ["Joined", (user.created_at||"").split("T")[0], undefined],
              ["Warnings", String(warnCount), warnCount>0?"var(--red)":undefined],
              ["Status", isBanned?"Banned":"Active", isBanned?"var(--red)":"var(--green)"],
            ].map(([label,val,color])=>(
              <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"9px 12px",background:"var(--sf2)",borderRadius:8}}>
                <span style={{fontSize:12,color:"var(--muted)",fontWeight:500}}>{label}</span>
                <span style={{fontSize:12,fontWeight:600,fontFamily:label==="PAN"||label==="GST"?"monospace":"inherit",color:color||"var(--text)"}}>{val}</span>
              </div>
            ))}
            {user.role==="seller" && user.website_url && safeUrl(user.website_url) && (
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 12px",background:"var(--sf2)",borderRadius:8}}>
                <span style={{fontSize:12,color:"var(--muted)",fontWeight:500}}>Website</span>
                <a href={safeUrl(user.website_url)} target="_blank" rel="noopener noreferrer"
                   style={{fontSize:12,fontWeight:600,color:"var(--blue)",textDecoration:"none",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                  🔗 {user.website_url.replace(/^https?:\/\/(www\.)?/,"")}
                </a>
              </div>
            )}
          </div>
        )}

        {/* Orders Tab */}
        {tab==="orders" && (
          <div>
            {loading
              ? <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading orders...</div>
              : userOrders.length===0
                ? <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>No orders found</div>
                : <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    {userOrders.map(o=>(
                      <div key={o.id} style={{background:"var(--sf2)",borderRadius:12,padding:14,border:"1px solid var(--border)"}}>
                        {/* Top row */}
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                          <div>
                            <div style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11,marginBottom:2}}>{o.id}</div>
                            <div style={{fontWeight:700,fontSize:14}}>{o.product_name}</div>
                            <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>{(o.created_at||"").split("T")[0]}</div>
                          </div>
                          <div style={{textAlign:"right"}}>
                            <Bdg status={o.status} />
                            <div style={{fontSize:13,fontWeight:700,color:"var(--green)",marginTop:4}}>₹{o.token_amount}</div>
                            <div style={{fontSize:11,color:"var(--muted)"}}>of ₹{o.order_amount}</div>
                          </div>
                        </div>
                        {/* Buyer info */}
                        <div style={{background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.15)",borderRadius:8,padding:"10px 12px",marginBottom:8}}>
                          <div style={{fontSize:11,fontWeight:700,color:"var(--gold)",marginBottom:6}}>👤 Buyer</div>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
                            <div>
                              <div style={{fontSize:13,fontWeight:600}}>{o.buyer_name||"Not provided"}</div>
                              {o.buyer_phone && (
                                <div style={{fontSize:12,color:"var(--muted)",marginTop:2,fontFamily:"monospace"}}>{o.buyer_phone}</div>
                              )}
                            </div>
                            {o.buyer_phone && (
                              <a href={`https://wa.me/91${o.buyer_phone.replace(/\D/g,"")}`}
                                target="_blank" rel="noreferrer"
                                style={{display:"flex",alignItems:"center",gap:5,background:"#25D366",color:"#fff",padding:"5px 10px",borderRadius:7,textDecoration:"none",fontSize:12,fontWeight:600}}>
                                💬 WhatsApp
                              </a>
                            )}
                          </div>
                        </div>
                        {/* Tracking + payout */}
                        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                          {o.tracking_number && (
                            <div style={{fontSize:11,background:"var(--surface)",border:"1px solid var(--border)",borderRadius:6,padding:"4px 8px"}}>
                              📦 {o.tracking_number}
                            </div>
                          )}
                          {["delivered","cancelled_buyer"].includes(o.status) && (
                            <div style={{fontSize:11,padding:"4px 8px",borderRadius:6,background:o.payout_status==="paid"?"rgba(16,185,129,.1)":"rgba(251,146,60,.1)",border:`1px solid ${o.payout_status==="paid"?"rgba(16,185,129,.3)":"rgba(251,146,60,.3)"}`,color:o.payout_status==="paid"?"var(--green)":"#f97316",fontWeight:600}}>
                              {o.payout_status==="paid"?"✅ Paid":"⏳ Payout Pending"}
                            </div>
                          )}
                          {o.confirm_token && o.status==="dispatched" && (
                            <button className="btn-ghost" style={{fontSize:11,padding:"4px 8px"}}
                              onClick={()=>navigator.clipboard?.writeText(`https://escarapay.in/confirm/${o.confirm_token}`)}>
                              🔗 Copy Confirm Link
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
            }
          </div>
        )}

        {/* PAYOUTS TAB */}
        {tab==="payouts" && (
          <div style={{display:"flex",flexDirection:"column",gap:12}}>

            {/* Pending Payouts — multi-select */}
            <div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:"1px"}}>
                  ⏳ Pending ({pendingPayouts.length})
                </div>
                {pendingPayouts.length > 0 && (
                  <div style={{display:"flex",gap:6}}>
                    <button className="btn-ghost" style={{padding:"3px 10px",fontSize:11}} onClick={selectAll}>Select All</button>
                    {selectedOrders.length > 0 && <button className="btn-ghost" style={{padding:"3px 10px",fontSize:11}} onClick={clearAll}>Clear</button>}
                  </div>
                )}
              </div>

              {pendingPayouts.length === 0
                ? <div style={{textAlign:"center",padding:16,color:"var(--muted)",fontSize:13,background:"var(--sf2)",borderRadius:10}}>✅ All payouts complete!</div>
                : pendingPayouts.map(o => {
                  const isSelected = selectedOrders.includes(o.id);
                  return (
                    <div key={o.id}
                      style={{background:isSelected?"rgba(14,165,233,.1)":"var(--sf2)",border:`1.5px solid ${isSelected?"rgba(14,165,233,.5)":"var(--border)"}`,borderRadius:10,padding:12,marginBottom:8,cursor:"pointer",transition:"all .15s"}}
                      onClick={()=>toggleOrder(o.id)}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <div style={{display:"flex",alignItems:"center",gap:10}}>
                          {/* Checkbox */}
                          <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${isSelected?"var(--gold)":"var(--border)"}`,background:isSelected?"var(--gold)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .15s"}}>
                            {isSelected && <span style={{color:"#fff",fontSize:11,fontWeight:900}}>✓</span>}
                          </div>
                          <div>
                            <div style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</div>
                            <div style={{fontWeight:600,fontSize:13}}>{o.product_name}</div>
                            <div style={{fontSize:12,color:"var(--muted)"}}>Token: ₹{o.token_amount}</div>
                          </div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div className="syne" style={{fontWeight:800,fontSize:16,color:"var(--green)"}}>₹{o.seller_receives}</div>
                          <Bdg status={o.status} />
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>

            {/* Bulk Payout Form — shows when 1+ selected */}
            {selectedOrders.length > 0 && (
              <div style={{background:"rgba(14,165,233,.06)",border:"1px solid rgba(14,165,233,.3)",borderRadius:12,padding:16}}>
                {/* Summary */}
                <div style={{background:"rgba(14,165,233,.1)",borderRadius:10,padding:12,marginBottom:14,textAlign:"center"}}>
                  <div style={{fontSize:12,color:"var(--muted)",marginBottom:4}}>
                    {selectedOrders.length} order{selectedOrders.length>1?"s":""} selected
                  </div>
                  <div className="syne" style={{fontWeight:900,fontSize:26,color:"var(--gold)"}}>₹{selectedTotal.toFixed(2)}</div>
                  <div style={{fontSize:11,color:"var(--muted)"}}>Total to transfer</div>
                  {/* Selected order IDs */}
                  <div style={{marginTop:8,display:"flex",flexWrap:"wrap",gap:4,justifyContent:"center"}}>
                    {pendingPayouts.filter(o=>selectedOrders.includes(o.id)).map(o=>(
                      <span key={o.id} style={{fontSize:10,fontFamily:"monospace",background:"var(--sf2)",padding:"2px 6px",borderRadius:4,color:"var(--gold)"}}>{o.id}</span>
                    ))}
                  </div>
                </div>

                <div style={{fontWeight:700,fontSize:13,color:"var(--gold)",marginBottom:12}}>💸 Bulk Payout Details</div>

                {/* Method */}
                <div style={{marginBottom:10}}>
                  <label className="label">Payment Method *</label>
                  <select className="select" value={bulkForm.payout_method} onChange={e=>setBulkForm({...bulkForm,payout_method:e.target.value})}>
                    <option value="upi">UPI</option>
                    <option value="bank">Bank Transfer</option>
                    <option value="cash">Cash</option>
                  </select>
                </div>

                {/* UPI */}
                {bulkForm.payout_method === "upi" && (
                  <div style={{marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                      <label className="label" style={{marginBottom:0}}>UPI ID *</label>
                      {user.upi_id && <span style={{fontSize:11,color:"var(--green)",cursor:"pointer",fontWeight:600}} onClick={()=>setBulkForm({...bulkForm,payout_upi:user.upi_id})}>✅ Use saved: {user.upi_id}</span>}
                    </div>
                    <input className="input" placeholder={user.upi_id||"seller@upi"} value={bulkForm.payout_upi} onChange={e=>setBulkForm({...bulkForm,payout_upi:e.target.value})} />
                  </div>
                )}
                {bulkForm.payout_method === "bank" && (
                  <div style={{marginBottom:10}}>
                    <label className="label">Bank Details (Acc No / IFSC) *</label>
                    <input className="input" placeholder="50100XXXXXX / HDFC0001234" value={bulkForm.payout_bank} onChange={e=>setBulkForm({...bulkForm,payout_bank:e.target.value})} />
                  </div>
                )}

                {/* UTR */}
                <div style={{marginBottom:10}}>
                  <label className="label">UTR / Ref No *</label>
                  <input className="input" placeholder="UTR123456789" value={bulkForm.payout_ref} onChange={e=>setBulkForm({...bulkForm,payout_ref:e.target.value})} />
                </div>

                {/* Note */}
                <div style={{marginBottom:12}}>
                  <label className="label">Note (optional)</label>
                  <input className="input" placeholder="e.g. Sent via HDFC" value={bulkForm.payout_note} onChange={e=>setBulkForm({...bulkForm,payout_note:e.target.value})} />
                </div>

                {bulkMsg && <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,marginBottom:10,color:bulkMsg.startsWith("✅")?"var(--green)":"var(--red)"}}>{bulkMsg}</div>}

                <div style={{display:"flex",gap:8}}>
                  <button className="btn-ghost" style={{flex:1}} onClick={clearAll}>Cancel</button>
                  <button className="btn-green" style={{flex:2,padding:"11px"}} onClick={doBulkPayout} disabled={bulkLoading}>
                    {bulkLoading ? "⏳ Processing..." : `💸 Pay ₹${selectedTotal.toFixed(2)} — ${selectedOrders.length} Order${selectedOrders.length>1?"s":""}`}
                  </button>
                </div>
              </div>
            )}

            {/* Done Payouts */}
            {donePayouts.length > 0 && (
              <div>
                <div style={{fontSize:12,fontWeight:700,color:"var(--muted)",marginBottom:8,textTransform:"uppercase",letterSpacing:"1px"}}>✅ Completed Payouts ({donePayouts.length})</div>
                {donePayouts.map(o=>(
                  <div key={o.id} style={{background:"rgba(16,185,129,.06)",border:"1px solid rgba(16,185,129,.2)",borderRadius:10,padding:12,marginBottom:8}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div>
                        <div style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</div>
                        <div style={{fontWeight:600,fontSize:13}}>{o.product_name}</div>
                        <div style={{fontSize:12,color:"var(--muted)",marginTop:3}}>
                          Amount: <strong style={{color:"var(--green)"}}>₹{o.payout_amount || o.seller_receives}</strong>
                          {o.payout_method && <> • {o.payout_method?.toUpperCase()}</>}
                          {o.payout_upi && <> • {o.payout_upi}</>}
                          {o.payout_bank && <> • {o.payout_bank}</>}
                        </div>
                        {o.payout_ref && <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>UTR: <strong style={{fontFamily:"monospace"}}>{o.payout_ref}</strong></div>}
                        {o.payout_at && <div style={{fontSize:11,color:"var(--muted)"}}>{new Date(o.payout_at).toLocaleString("en-IN")}</div>}
                      </div>
                      <span className="badge bg" style={{fontSize:10}}>✅ Paid</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Actions Tab */}
        {tab==="actions" && (
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* Warn */}
            <div style={{background:"rgba(251,146,60,.1)",border:"1px solid rgba(251,146,60,.3)",borderRadius:12,padding:14}}>
              <div style={{fontWeight:700,color:"#fb923c",marginBottom:8,fontSize:13}}>⚠️ Send Warning</div>
              <input className="input" placeholder="Warning reason (e.g. Suspicious activity)" value={warnReason} onChange={e=>setWarnReason(e.target.value)} style={{marginBottom:8}} />
              <button className="btn-ghost" style={{width:"100%",color:"#fb923c",borderColor:"rgba(251,146,60,.4)"}} onClick={()=>doAction("warn")} disabled={!!actionLoading}>
                {actionLoading==="warn"?"⏳ Sending...":"⚠️ Send Warning"}
              </button>
            </div>
            {/* Ban / Unban */}
            {!isBanned ? (
              <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:12,padding:14}}>
                <div style={{fontWeight:700,color:"var(--red)",marginBottom:8,fontSize:13}}>🚫 Ban This User</div>
                <input className="input" placeholder="Ban reason (e.g. Fraud, fake orders)" value={banReason} onChange={e=>setBanReason(e.target.value)} style={{marginBottom:8}} />
                <button className="btn-red" style={{width:"100%"}} onClick={()=>doAction("ban")} disabled={!!actionLoading}>
                  {actionLoading==="ban"?"⏳ Banning...":"🚫 Ban This User"}
                </button>
              </div>
            ) : (
              <div style={{background:"rgba(5,150,105,.1)",border:"1px solid rgba(5,150,105,.3)",borderRadius:12,padding:14}}>
                <div style={{fontWeight:700,color:"var(--green)",marginBottom:8,fontSize:13}}>✅ Unban This User</div>
                <button className="btn-green" style={{width:"100%"}} onClick={()=>doAction("unban")} disabled={!!actionLoading}>
                  {actionLoading==="unban"?"⏳ Unbanning...":"✅ Unban This User"}
                </button>
              </div>
            )}
            {msg && (
              <div style={{padding:12,borderRadius:8,background:"var(--sf2)",fontSize:13,fontWeight:600,textAlign:"center",
                color:msg.startsWith("✅")?"var(--green)":msg.startsWith("⚠️")?"#fb923c":"var(--red)"}}>
                {msg}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}


function AdminPanel({ adminToken: propToken, onLogout, dark, onToggle }) {
  const [adminToken] = useState(()=> propToken || localStorage.getItem("adminSessionToken") || "");
  const [page, setPage] = useState("dashboard");
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [users, setUsers] = useState([]);
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [filterStatus, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [authError, setAuthError] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  // ✅ Bearer token auth — no raw password in headers
  const headers = { "Content-Type":"application/json", "Authorization": `Bearer ${adminToken}` };

  const safeFetch = async (url, opts={}) => {
    try {
      const r = await fetch(url, { ...opts, headers: {...headers, ...(opts.headers||{})} });
      if (r.status === 401) {
        // ✅ Auto-logout on session expiry — clears token and redirects
        const data = await r.json().catch(()=>({}));
        setAuthError("⏰ " + (data.error || "Session expired. Logging out..."));
        localStorage.removeItem("adminSessionToken");
        setTimeout(() => onLogout(), 2000);
        return null;
      }
      setAuthError("");
      return await r.json();
    } catch(e) { setAuthError("Network error: " + e.message); return null; }
  };

  const load = async (p) => {
    setLoading(true);
    if (p==="dashboard") { const d=await safeFetch(`${ADMIN_URL}/api/admin/stats`); if(d?.success) setStats(d.stats); }
    if (p==="orders")    { const d=await safeFetch(`${ADMIN_URL}/api/admin/orders`); if(d?.success) setOrders(d.orders||[]); }
    if (p==="users")     { const d=await safeFetch(`${ADMIN_URL}/api/admin/users`);  if(d?.success) setUsers(d.users||[]); }
    if (p==="disputes")  { const d=await safeFetch(`${ADMIN_URL}/api/admin/disputes`); if(d?.success) setDisputes(d.disputes||[]); }
    setLoading(false);
  };

  useEffect(()=>{ load(page); },[page]);

  const resolveDispute = async (orderId, decision) => {
    const d=await safeFetch(`${ADMIN_URL}/api/admin/disputes/${orderId}/resolve`,{method:"POST",body:JSON.stringify({decision})});
    if(d?.success){ setToast(d.message); setDisputes(disputes.filter(o=>o.id!==orderId)); }
  };

  const filteredOrders = orders.filter(o=>{
    const ms=filterStatus==="all"||o.status===filterStatus;
    const ms2=!search||o.id.includes(search.toUpperCase())||(o.seller_name||"").toLowerCase().includes(search.toLowerCase())||(o.buyer_name||"").toLowerCase().includes(search.toLowerCase());
    return ms&&ms2;
  });

  const nav = [{id:"dashboard",icon:"📊",label:"Dashboard"},{id:"orders",icon:"📦",label:"All Orders"},{id:"users",icon:"👥",label:"Users"},{id:"disputes",icon:"⚠️",label:"Disputes"}];

  return (
    <div style={{minHeight:"100vh"}}>
      {toast && <Toast msg={toast} onDone={()=>setToast("")} />}
      <nav className="nav"><Logo /><div style={{display:"flex",gap:8,alignItems:"center"}}><ThemeToggle dark={dark} onToggle={onToggle} /><span className="badge br" style={{fontSize:11}}>🔐 Admin</span><button className="btn-ghost" style={{fontSize:12}} onClick={onLogout}>Logout</button></div></nav>
      {authError && (
        <div style={{background:"rgba(239,68,68,.15)",border:"1px solid rgba(239,68,68,.4)",padding:"10px 20px",fontSize:13,color:"var(--red)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>⚠️ {authError}</span>
          <button style={{background:"var(--red)",color:"#fff",border:"none",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:12}} onClick={onLogout}>Re-Login</button>
        </div>
      )}
      <div className="sidebar">
        <div style={{marginBottom:16,padding:"0 8px"}}><div style={{fontSize:10,color:"var(--muted)",fontWeight:700,textTransform:"uppercase",letterSpacing:".6px"}}>Admin Panel</div></div>
        {nav.map(n=>(<div key={n.id} className={`si ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span>{n.id==="disputes"&&disputes.length>0&&<span style={{marginLeft:"auto",background:"var(--red)",color:"#fff",borderRadius:10,fontSize:11,padding:"1px 7px",fontWeight:700}}>{disputes.length}</span>}</div>))}
      </div>
      <div className="mobile-nav">
        {nav.map(n=>(<div key={n.id} className={`mni ${page===n.id?"active":""}`} onClick={()=>setPage(n.id)}><span>{n.icon}</span><span>{n.label}</span></div>))}
        <div className="mni" onClick={onLogout}><span>🚪</span><span>Logout</span></div>
      </div>
      <div className="main">
        {page==="dashboard" && (
          <div className="fu">
            <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(18px,3vw,26px)",marginBottom:22}}>Admin Dashboard 🛡️</h1>
            {loading ? <div style={{textAlign:"center",padding:40,color:"var(--muted)"}}>⏳ Loading...</div> : stats && (
              <>
                <div className="g4" style={{marginBottom:18}}>
                  {[{label:"Total Orders",value:stats.totalOrders,icon:"📦",color:"var(--gold)"},{label:"Total GMV",value:`₹${(stats.totalGMV||0).toLocaleString()}`,icon:"💰",color:"var(--green)"},{label:"Revenue",value:`₹${(stats.totalRevenue||0).toLocaleString()}`,icon:"🏦",color:"var(--blue)"},{label:"Disputes",value:stats.pendingDisputes,icon:"⚠️",color:"var(--red)"}].map(s=>(
                    <div key={s.label} className="stat-card"><div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{fontSize:11,color:"var(--muted)",marginBottom:6}}>{s.label}</div><div className="syne" style={{fontSize:22,fontWeight:800,color:s.color}}>{s.value}</div></div><span style={{fontSize:20}}>{s.icon}</span></div></div>
                  ))}
                </div>

                {/* ── Pending Token — Manual Contact Section ── */}
                {(()=>{
                  const pendingOrders = orders.filter(o=>o.status==="pending" && o.buyer_phone).slice(0,10);
                  if(!pendingOrders.length) return null;
                  return (
                    <div className="card" style={{marginBottom:16,border:"1px solid rgba(245,158,11,.35)",background:"rgba(245,158,11,.04)"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
                        <div>
                          <div className="syne" style={{fontWeight:800,fontSize:15,marginBottom:2}}>📱 Pending Token — Contact Buyers ({orders.filter(o=>o.status==="pending").length})</div>
                          <div style={{fontSize:12,color:"var(--muted)"}}>Token abhi tak pay nahi hua — directly WhatsApp karo</div>
                        </div>
                        <button className="btn-ghost" style={{fontSize:12,padding:"6px 14px"}} onClick={()=>setPage("orders")}>View All →</button>
                      </div>
                      <div style={{display:"flex",flexDirection:"column",gap:10}}>
                        {pendingOrders.map(o=>{
                          const phone=(o.buyer_phone||"").replace(/\D/g,"");
                          const sellerName=o.seller_name||"Seller";
                          const waMsg=encodeURIComponent(
                            `Hi ${o.buyer_name||""}! 👋\n\n*${sellerName}* pe aapka COD order place hua hai.\n\n` +
                            `🛍️ Product: ${o.product_name}\n💰 Order Amount: ₹${o.order_amount}\n🔐 Token Amount: ₹${o.token_amount}\n\n` +
                            `Apna order confirm karne ke liye neeche link se chhota sa token pay karein 👇\nhttps://escarapay.in/pay/${o.id}\n\n` +
                            `Token pay hone ke baad hi seller dispatch karega.\n_Secured by EscaraPay 🛡️_`
                          );
                          const waLink=`https://wa.me/91${phone}?text=${waMsg}`;
                          const daysPending=Math.floor((Date.now()-new Date(o.created_at))/86400000);
                          return (
                            <div key={o.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"var(--sf2)",borderRadius:10,padding:"10px 14px",flexWrap:"wrap",gap:8}}>
                              <div style={{flex:1,minWidth:0}}>
                                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap"}}>
                                  <span className="syne" style={{fontWeight:700,fontSize:13}}>{o.buyer_name||"Unknown"}</span>
                                  <code style={{fontSize:10,color:"var(--gold)",background:"rgba(245,158,11,.1)",padding:"1px 6px",borderRadius:4}}>{o.id}</code>
                                  {daysPending>0&&<span style={{fontSize:10,color:daysPending>3?"var(--red)":"var(--muted)",background:"rgba(239,68,68,.08)",padding:"1px 6px",borderRadius:4}}>{daysPending}d ago</span>}
                                </div>
                                <div style={{fontSize:12,color:"var(--muted)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                                  {o.product_name} · ₹{o.order_amount} · <strong style={{color:"var(--gold)"}}>Token: ₹{o.token_amount}</strong>
                                </div>
                                {o.seller_name&&<div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>🏪 {o.seller_name}</div>}
                              </div>
                              <div style={{display:"flex",gap:8,flexShrink:0}}>
                                <a href={waLink} target="_blank" rel="noreferrer"
                                   style={{background:"#25D366",color:"#fff",padding:"8px 14px",borderRadius:8,fontSize:12,fontWeight:700,textDecoration:"none",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:5}}>
                                  💬 WhatsApp
                                </a>
                                {phone&&<a href={`tel:+91${phone}`} style={{background:"var(--sf2)",border:"1px solid var(--border)",color:"var(--text)",padding:"8px 12px",borderRadius:8,fontSize:12,fontWeight:700,textDecoration:"none"}}>📞 Call</a>}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                {stats.pendingDisputes>0 && <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:12,padding:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontWeight:700,color:"var(--red)",marginBottom:4}}>⚠️ {stats.pendingDisputes} Pending Dispute(s)</div><div style={{fontSize:12,color:"var(--muted)"}}>Resolve within 24 hours</div></div><button className="btn-red" style={{padding:"8px 16px",fontSize:13}} onClick={()=>setPage("disputes")}>Resolve →</button></div>}
              </>
            )}
          </div>
        )}
        {page==="orders" && (
          <div className="fu">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:10}}>
              <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(18px,3vw,26px)"}}>All Orders ({orders.length})</h1>
              <input className="input" style={{maxWidth:220,padding:"8px 12px"}} placeholder="🔍 Search..." value={search} onChange={e=>setSearch(e.target.value)} />
            </div>
            {orders.length===0&&!loading&&<div style={{background:"rgba(14,165,233,.1)",border:"1px solid rgba(14,165,233,.3)",borderRadius:10,padding:14,marginBottom:16,fontSize:13}}>ℹ️ No orders found. Sellers need to register and create orders to appear here.</div>}
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
              {["all","pending","token_paid","dispatched","delivered","disputed"].map(s=>(<div key={s} className={`chip ${filterStatus===s?"active":""}`} onClick={()=>setFilter(s)} style={{fontSize:11}}>{s==="all"?`All (${orders.length})`:s.replace("_"," ")}</div>))}
            </div>
            {loading ? <div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading...</div> : (
              <div className="card" style={{padding:0,overflowX:"auto"}}>
                <table className="tbl">
                  <thead><tr><th>Order ID</th><th>Date</th><th>Seller</th><th>Buyer</th><th>Buyer Phone</th><th>Product</th><th>Amount</th><th>Token</th><th>Commission</th><th>Status</th><th>Receipt</th></tr></thead>
                  <tbody>
                    {filteredOrders.length===0?<tr><td colSpan={11} style={{textAlign:"center",color:"var(--muted)",padding:30}}>No orders found</td></tr>:filteredOrders.map(o=>(
                      <tr key={o.id}>
                        <td><span style={{fontFamily:"monospace",color:"var(--gold)",fontSize:11}}>{o.id}</span></td>
                        <td style={{fontSize:11,color:"var(--muted)"}}>{(o.created_at||"").split("T")[0]}</td>
                        <td style={{fontSize:12}}>{o.seller_name||"—"}</td>
                        <td style={{fontSize:12}}>{o.buyer_name||"—"}</td>
                        <td style={{fontSize:12}}>
                          {o.buyer_phone
                            ? <a href={`https://wa.me/91${o.buyer_phone.replace(/\D/g,"")}`} target="_blank" rel="noreferrer"
                                style={{color:"#25D366",textDecoration:"none",fontFamily:"monospace",fontWeight:600}}
                                title="Open WhatsApp">
                                💬 {o.buyer_phone}
                              </a>
                            : <span style={{color:"var(--muted)"}}>—</span>
                          }
                        </td>
                        <td style={{fontSize:12,color:"var(--muted)"}}>{o.product_name}</td>
                        <td style={{fontWeight:600,fontSize:12}}>₹{o.order_amount}</td>
                        <td style={{color:"var(--green)",fontWeight:600,fontSize:12}}>₹{o.token_amount}</td>
                        <td style={{color:"var(--blue)",fontSize:12}}>₹{o.escara_commission||0}</td>
                        <td><Bdg status={o.status} /></td>
                        <td>{["token_paid","dispatched","delivered"].includes(o.status)&&<button className="btn-ghost" style={{padding:"3px 8px",fontSize:11}} onClick={()=>downloadReceipt(o,"admin")}>📄</button>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {page==="users" && (
          <div className="fu">
            <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(18px,3vw,26px)",marginBottom:18}}>All Users ({users.length})</h1>
            {loading?<div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading...</div>:(
              <div className="card" style={{padding:0,overflowX:"auto"}}>
                <table className="tbl">
                  <thead><tr><th>ID</th><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Type</th><th>Website</th><th>PAN</th><th>GST</th><th>Status</th><th>Joined</th><th>Action</th></tr></thead>
                  <tbody>{users.map(u=>(
                    <tr key={u.id} style={{cursor:"pointer"}} onClick={()=>setSelectedUser(u)}>
                      <td style={{color:"var(--muted)",fontSize:12}}>{u.id}</td>
                      <td style={{fontWeight:600,fontSize:13}}>{u.name}{u.warning_count>0&&<span className="badge borange" style={{fontSize:10,marginLeft:4}}>⚠️ {u.warning_count}</span>}</td>
                      <td style={{fontSize:12,color:"var(--muted)"}}>{u.email}</td>
                      <td style={{fontSize:12}}>{u.phone}</td>
                      <td><span className={`badge ${u.role==="seller"?"bg":"bo"}`} style={{fontSize:11}}>{u.role}</span></td>
                      <td style={{fontSize:11}}>
                        {u.role==="seller"
                          ? u.seller_type==="website"
                            ? <span className="badge" style={{fontSize:10,background:"rgba(14,165,233,.12)",color:"var(--blue)",border:"1px solid rgba(14,165,233,.3)"}}>🏪 Website</span>
                            : u.seller_type==="social_media"
                              ? <span className="badge" style={{fontSize:10,background:"rgba(245,158,11,.12)",color:"var(--gold)",border:"1px solid rgba(245,158,11,.3)"}}>📱 Social</span>
                              : <span style={{color:"var(--muted)",fontSize:11}}>—</span>
                          : <span style={{color:"var(--muted)",fontSize:11}}>—</span>
                        }
                      </td>
                      <td style={{fontSize:11,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                        {u.website_url && safeUrl(u.website_url)
                          ? <a href={safeUrl(u.website_url)} target="_blank" rel="noopener noreferrer"
                              style={{color:"var(--blue)",textDecoration:"none",fontWeight:600}}
                              onClick={e=>e.stopPropagation()}
                              title={u.website_url}>
                              🔗 {u.website_url.replace(/^https?:\/\/(www\.)?/,"")}
                            </a>
                          : <span style={{color:"var(--muted)"}}>—</span>
                        }
                      </td>
                      <td style={{fontFamily:"monospace",fontSize:11,color:u.pan_number?"var(--green)":"var(--muted)"}}>{u.pan_number||"—"}</td>
                      <td style={{fontFamily:"monospace",fontSize:11,color:u.gst_number?"var(--green)":"var(--muted)"}}>{u.gst_number||"—"}</td>
                      <td><span className={`badge ${u.user_status==="banned"?"br":u.warning_count>0?"borange":"bg"}`} style={{fontSize:10}}>{u.user_status==="banned"?"🚫 Banned":u.warning_count>0?"⚠️ Warned":"✅ Active"}</span></td>
                      <td style={{fontSize:11,color:"var(--muted)"}}>{(u.created_at||"").split("T")[0]}</td>
                      <td onClick={e=>e.stopPropagation()}><div style={{display:"flex",gap:4}}>
                        <button className="btn-ghost" style={{padding:"3px 8px",fontSize:11}} onClick={()=>setSelectedUser(u)}>View</button>
                      </div></td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            )}
            {selectedUser && <UserDetailModal user={selectedUser} adminToken={adminToken} onClose={()=>setSelectedUser(null)} onUpdate={(uid,action)=>{
              setUsers(users.map(u=>u.id===uid ? {...u, user_status: action==="ban"?"banned":"active", warning_count: action==="warn"?(u.warning_count||0)+1:u.warning_count} : u));
              setSelectedUser(null);
            }} />}
          </div>
        )}
        {page==="disputes" && (
          <div className="fu">
            <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(18px,3vw,26px)",marginBottom:18}}>Disputes {disputes.length>0&&<span className="badge br" style={{fontSize:14}}>🔥 {disputes.length}</span>}</h1>
            {loading?<div style={{textAlign:"center",padding:30,color:"var(--muted)"}}>⏳ Loading...</div>:disputes.length===0?(<div className="card" style={{textAlign:"center",padding:50}}><div style={{fontSize:40,marginBottom:10}}>🎉</div><div className="syne" style={{fontWeight:700,fontSize:18}}>No Active Disputes!</div></div>):(
              <div style={{display:"flex",flexDirection:"column",gap:12}}>
                {disputes.map(o=>(
                  <div key={o.id} className="card" style={{borderColor:"rgba(239,68,68,.3)"}}>
                    <div style={{marginBottom:14}}><div style={{fontFamily:"monospace",color:"var(--red)",fontSize:12,marginBottom:3}}>{o.id}</div><div className="syne" style={{fontWeight:700,fontSize:17}}>{o.product_name}</div><div style={{fontSize:13,color:"var(--muted)",marginTop:4}}>Seller: <strong style={{color:"var(--text)"}}>{o.seller_name||"—"}</strong> | Buyer: <strong style={{color:"var(--text)"}}>{o.buyer_name||"—"}</strong></div></div>
                    <div style={{background:"rgba(239,68,68,.08)",borderRadius:10,padding:12,marginBottom:14}}><div style={{fontSize:12,fontWeight:700,color:"var(--red)",marginBottom:4}}>By: {o.dispute_raised_by||"—"} | {(o.dispute_at||"").split("T")[0]}</div><div style={{fontSize:13,color:"var(--muted)"}}>{o.dispute_reason||"No reason"}</div></div>
                    <div style={{display:"flex",gap:10}}>
                      <button className="btn-green" style={{flex:1,padding:"10px"}} onClick={()=>resolveDispute(o.id,"seller")}>✅ Seller Sahi</button>
                      <button className="btn-red" style={{flex:1,padding:"10px"}} onClick={()=>resolveDispute(o.id,"buyer")}>↩️ Buyer Sahi</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function AdminLogin({ onLogin, dark, onToggle }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handle = async () => {
    if (!password) { setError("❌ Please enter the password!"); return; }
    setLoading(true); setError("");
    try {
      const res=await fetch(`${ADMIN_URL}/api/admin/login`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({password})});
      const data=await res.json(); setLoading(false);
      if(data.success && data.token){
        // ✅ Save JWT token (not password) — expires in 8h
        localStorage.setItem("adminSessionToken", data.token);
        localStorage.removeItem("adminKey"); // clear old insecure key
        onLogin(data.token);
      } else setError("❌ " + (data.error || "Wrong password!"));
    } catch(e) { setLoading(false); setError("❌ Could not connect to server. Please try again."); }
  };

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div className="modal" style={{maxWidth:360}}>
        <div style={{textAlign:"center",marginBottom:22}}><div style={{fontSize:40,marginBottom:10}}>🔐</div><h2 className="syne" style={{fontWeight:800,fontSize:22,marginBottom:4}}>Admin Access</h2><p style={{color:"var(--muted)",fontSize:13}}>EscaraPay Admin Panel</p></div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div><label className="label">Admin Password</label><input className="input" type="password" placeholder="••••••••" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()} /></div>
          {error && <div style={{color:"var(--red)",fontSize:13}}>{error}</div>}
          <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handle}>{loading?"⏳ Checking...":"Login →"}</button>
        </div>
      </div>
    </div>
  );
}

/* ══════════ PRIVACY / TERMS / CONTACT ══════════ */
function AboutPage({ onBack, dark, onToggle, lang, onLangToggle }) {
  const L = (en,hi,hl) => lang==="en"?en:lang==="hi"?hi:hl;
  useEffect(()=>{
    window.scrollTo({top:0,behavior:"instant"});
    updateMeta({title:"About EscaraPay | India's Payment Protection Platform for WhatsApp Sellers",description:"Learn about EscaraPay — India's trusted token-based payment protection platform built for WhatsApp and Instagram sellers. Founded by Madhav Gupta, MSME registered.",url:"https://www.escarapay.in/about"});
  },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onBack} /><div style={{display:"flex",gap:8,alignItems:"center"}}><LangToggle lang={lang} onToggle={onLangToggle} /><ThemeToggle dark={dark} onToggle={onToggle} /><button className="btn-ghost" onClick={onBack}>← Back</button></div></nav>
      <div style={{maxWidth:820,margin:"0 auto",padding:"40px 20px 20px"}}>

        {/* Hero */}
        <div style={{textAlign:"center",marginBottom:48}}>
          <img src={LOGO_SRC} alt="EscaraPay" style={{height:64,marginBottom:16,objectFit:"contain"}} onError={e=>e.target.style.display="none"} />
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(28px,4vw,42px)",marginBottom:12}}>About <span className="shimmer">EscaraPay</span></h1>
          <p style={{color:"var(--muted)",fontSize:16,maxWidth:560,margin:"0 auto",lineHeight:1.8}}>
            {L("India's first payment protection platform specifically designed for WhatsApp & Instagram sellers","भारत का पहला पेमेंट प्रोटेक्शन प्लेटफॉर्म, खासतौर पर व्हाट्सऐप और इंस्टाग्राम सेलर्स के लिए","India ka pehla payment protection platform specifically designed for WhatsApp & Instagram sellers")}
          </p>
        </div>

        {/* Mission */}
        <div className="card" style={{marginBottom:16,background:"rgba(14,165,233,.05)",borderColor:"rgba(14,165,233,.25)"}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:12}}>🎯 {L("Our Mission","हमारा मिशन","Hamara Mission")}</h2>
          <p style={{fontSize:14,color:"var(--muted)",lineHeight:1.9}}>
            {L(
              "Millions of sellers do business on WhatsApp and Instagram in India — but they fear RTO losses and buyers fear fraud. EscaraPay solved this with a simple payment protection system: token is locked first, released after delivery.",
              "भारत में लाखों सेलर व्हाट्सऐप और इंस्टाग्राम पर बिजनेस करते हैं — लेकिन उन्हें RTO का डर रहता है और बायर को फ्रॉड का। एस्करापे ने यह समस्या एक सरल एस्क्रो सिस्टम से हल की।",
              "India mein lakho sellers WhatsApp aur Instagram pe business karte hain — lekin unhe RTO ka darr rehta hai aur buyers ko fraud ka. EscaraPay ne yeh problem solve ki ek simple payment protection system se: token pehle lock hota hai, delivery ke baad release hota hai."
            )}
          </p>
        </div>

        {/* Problem we solve */}
        <div className="g2" style={{marginBottom:16}}>
          <div className="card" style={{background:"rgba(239,68,68,.05)",borderColor:"rgba(239,68,68,.2)"}}>
            <div style={{fontSize:28,marginBottom:10}}>😰</div>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:8,color:"var(--red)"}}>{L("Before EscaraPay","पहले की समस्या","Pehle ki Problem")}</h3>
            <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>
              ❌ {L("Seller ships, buyer cancels → RTO loss","सेलर भेजे, बायर कैंसिल करे → RTO नुकसान","Seller ship kare, buyer cancel kare → RTO loss")}<br/>
              ❌ {L("Buyer pays, seller doesn't ship → fraud","बायर पे करे, सेलर न भेजे → फ्रॉड","Buyer pay kare, seller ship na kare → fraud")}<br/>
              ❌ {L("No proof, no protection","कोई सुबूत नहीं, कोई सुरक्षा नहीं","Koi proof nahi, koi protection nahi")}<br/>
              ❌ {L("WhatsApp deals completely unsafe","व्हाट्सऐप डील पूरी तरह असुरक्षित","WhatsApp pe deals completely unsafe")}
            </div>
          </div>
          <div className="card" style={{background:"rgba(5,150,105,.05)",borderColor:"rgba(5,150,105,.2)"}}>
            <div style={{fontSize:28,marginBottom:10}}>✅</div>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:8,color:"var(--green)"}}>{L("With EscaraPay","एस्करापे के साथ","EscaraPay ke Saath")}</h3>
            <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>
              ✅ {L("Token safely held — neither party can cheat","टोकन एस्क्रो में — कोई धोखा नहीं","Token safely held — kisi ko nahi milta jab tak deal complete na ho")}<br/>
              ✅ {L("Buyer cancels? Token still goes to seller (RTO cover)","बायर कैंसिल करे? टोकन सेलर को (RTO कवर)","Seller cancel kare bhi toh token seller ko milta hai")}<br/>
              ✅ {L("Seller doesn't ship? Full refund to buyer","सेलर न भेजे? बायर को पूरा रिफंड","Seller ship na kare toh buyer ko full refund")}<br/>
              ✅ {L("Dispute system — 24 hour resolution","विवाद सिस्टम — 24 घंटे में समाधान","Dispute system — 24 ghante mein resolution")}
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="card" style={{marginBottom:16}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:16}}>⚙️ {L("How It Works","यह कैसे काम करता है","Kaise Kaam Karta Hai")}</h2>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {[
              {n:"1",c:"var(--gold)", en:"Seller Creates Order Link", hi:"सेलर ऑर्डर लिंक बनाता है", hl:"Seller Order Link Banata Hai",
               de:"Sets product name, amount, token percentage. Minimum ₹200 token auto-calculated.",
               dh:"प्रोडक्ट नाम, राशि और टोकन प्रतिशत सेट करता है। न्यूनतम ₹200 टोकन।",
               dl:"Product name, amount aur token percentage set karta hai. Minimum ₹200 token auto calculate."},
              {n:"2",c:"var(--blue)", en:"Buyer Pays Token", hi:"बायर टोकन पेमेंट करता है", hl:"Buyer Token Pay Karta Hai",
               de:"Pays via UPI/Card/NetBanking. Token locked in EscaraPay protected vault.",
               dh:"UPI/कार्ड से भुगतान करता है। टोकन एस्क्रो में लॉक।",
               dl:"Cashfree ke through UPI/Card/NetBanking se pay. Token EscaraPay protected vault mein lock."},
              {n:"3",c:"var(--accent)", en:"Seller Dispatches", hi:"सेलर भेजता है", hl:"Seller Dispatch Karta Hai",
               de:"Token secured → seller ships confidently with tracking ID.",
               dh:"टोकन सुरक्षित → सेलर निश्चिंत होकर ट्रैकिंग ID के साथ भेजता है।",
               dl:"Token secure hone ke baad seller confidently ship karta hai tracking number ke saath."},
              {n:"4",c:"var(--green)", en:"Delivery & Release", hi:"डिलीवरी और रिलीज", hl:"Delivery & Release",
               de:"Buyer confirms → 7 day hold → token released to seller.",
               dh:"बायर कन्फर्म करे → 7 दिन होल्ड → टोकन सेलर को।",
               dl:"Buyer delivery confirm karta hai → 7 din hold → token seller ko release."},
            ].map(s=>(
              <div key={s.n} className="step">
                <div className="step-num" style={{background:`${s.c}20`,color:s.c,width:34,height:34,fontSize:15}}>{s.n}</div>
                <div>
                  <div style={{fontWeight:700,marginBottom:4,fontSize:14}}>{L(s.en,s.hi,s.hl)}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>{L(s.de,s.dh,s.dl)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="g3" style={{marginBottom:16}}>
          {[
            {icon:"🚀",en:"Startup Stage",hi:"स्टार्टअप स्टेज",hl:"Startup Stage",de:"Actively building & growing",dh:"सक्रिय रूप से बना रहे हैं",dl:"Actively building & growing"},
            {icon:"🛡️",en:"Payment Protected",hi:"पेमेंट प्रोटेक्टेड",hl:"Payment Protected",de:"100% secure token system",dh:"100% सुरक्षित टोकन सिस्टम",dl:"100% secure token system"},
            {icon:"⚡",en:"Instant Setup",hi:"तुरंत शुरू",hl:"Instant Setup",de:"Ready in 5 minutes",dh:"5 मिनट में तैयार",dl:"5 minute mein start karo"},
          ].map(s=>(
            <div key={s.en} className="card" style={{textAlign:"center"}}>
              <div style={{fontSize:32,marginBottom:10}}>{s.icon}</div>
              <div className="syne" style={{fontWeight:700,fontSize:14,marginBottom:6}}>{L(s.en,s.hi,s.hl)}</div>
              <div style={{fontSize:12,color:"var(--muted)"}}>{L(s.de,s.dh,s.dl)}</div>
            </div>
          ))}
        </div>

        {/* Team */}
        <div className="card" style={{marginBottom:16,background:"rgba(124,58,237,.05)",borderColor:"rgba(124,58,237,.2)"}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:16}}>👥 {L("Our Team","हमारी टीम","Hamari Team")}</h2>
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            <div style={{display:"flex",alignItems:"center",gap:16}}>
              <div style={{width:56,height:56,borderRadius:"50%",background:"linear-gradient(135deg,var(--gold),var(--accent))",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:800,color:"#fff",flexShrink:0}}>M</div>
              <div>
                <div className="syne" style={{fontWeight:700,fontSize:16}}>Madhav Gupta</div>
                <div style={{color:"var(--gold)",fontSize:13,marginBottom:4}}>{L("Founder & Developer","संस्थापक और डेवलपर","Founder & Developer")}</div>
                <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>
                  {L("Saw real problems of WhatsApp sellers and built EscaraPay. Starting small, dreaming big!","व्हाट्सऐप सेलर्स की असली समस्याएं देखीं और एस्करापे बनाया। छोटे से शुरुआत, बड़े सपने!","WhatsApp sellers ki real problems dekhi aur EscaraPay build kiya. Chhote se shuruat, badi khwaish!")}
                </div>
              </div>
            </div>
            <div style={{height:1,background:"var(--border)"}} />
            <div style={{display:"flex",alignItems:"center",gap:16}}>
              <div style={{width:56,height:56,borderRadius:"50%",background:"linear-gradient(135deg,#ec4899,#a855f7)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:800,color:"#fff",flexShrink:0}}>M</div>
              <div>
                <div className="syne" style={{fontWeight:700,fontSize:16}}>Mahima Gupta</div>
                <div style={{color:"#ec4899",fontSize:13,marginBottom:4}}>{L("Head of Marketing","मार्केटिंग हेड","Head of Marketing")}</div>
                <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>
                  {L("Brand strategy, seller outreach and social media — the voice of EscaraPay!","ब्रांड स्ट्रेटेजी, सेलर आउटरीच और सोशल मीडिया — एस्करापे की आवाज़!","Brand strategy, seller outreach aur social media — EscaraPay ki awaaz! Sellers tak platform pahunchana inki zimmedari hai.")}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="card" style={{marginBottom:24}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:16}}>💎 {L("Our Values","हमारी मूल्य","Hamari Values")}</h2>
          <div className="g2">
            {[
              {icon:"🔒",en:"Trust First",hi:"विश्वास पहले",hl:"Trust First",
               de:"Full transparency in every transaction. No hidden fees.",dh:"हर ट्रांज़ैक्शन में पारदर्शिता।",dl:"Har transaction mein transparency. Koi hidden fees nahi."},
              {icon:"⚡",en:"Speed",hi:"गति",hl:"Speed",
               de:"Create order, share link, payment secured in 2 minutes.",dh:"ऑर्डर बनाएं, लिंक भेजें, 2 मिनट में।",dl:"Order create karo, link bhejo, 2 minute mein payment secure."},
              {icon:"🛡️",en:"Equal Protection",hi:"समान सुरक्षा",hl:"Equal Protection",
               de:"Fair protection for both buyer and seller.",dh:"बायर और सेलर दोनों के लिए सुरक्षा।",dl:"Buyer aur seller dono ke liye equal protection."},
              {icon:"🇮🇳",en:"Made for India",hi:"भारत के लिए",hl:"Made for India",
               de:"Hinglish support, UPI, built for Indian business.",dh:"हिंग्लिश, UPI, भारतीय बिज़नेस के लिए।",dl:"Hinglish support, UPI integration, Indian business ke liye."},
            ].map(v=>(
              <div key={v.en} style={{display:"flex",gap:12,alignItems:"flex-start",padding:12,background:"var(--sf2)",borderRadius:10}}>
                <span style={{fontSize:22,flexShrink:0}}>{v.icon}</span>
                <div>
                  <div style={{fontWeight:700,fontSize:13,marginBottom:3}}>{L(v.en,v.hi,v.hl)}</div>
                  <div style={{fontSize:12,color:"var(--muted)",lineHeight:1.6}}>{L(v.de,v.dh,v.dl)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{textAlign:"center",marginBottom:12}}>
          <button className="btn-gold" style={{marginRight:10}} onClick={()=>window._goToPage("contact")}>📞 {L("Contact Us","संपर्क करें","Contact Karo")}</button>
          <button className="btn-ghost" onClick={onBack}>← {L("Back to Home","होम पर वापस","Back to Home")}</button>
        </div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

/* ══════════ LEGAL NAV ══════════ */
function LegalFooter({ onNav }) {
  return (
    <footer style={{background:"var(--sf2)",borderTop:"1px solid var(--border)",marginTop:60,padding:"40px 20px 28px"}}>
      <div style={{maxWidth:900,margin:"0 auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:32,marginBottom:32}}>
          <div>
            <div className="syne" style={{fontWeight:800,fontSize:18,color:"var(--gold)",marginBottom:8}}>EscaraPay</div>
            <div style={{fontSize:12,color:"var(--muted)",lineHeight:1.8}}>India's Trusted Payment<br/>Protection Platform</div>
            <div style={{fontSize:11,color:"var(--muted)",marginTop:8}}>MSME: UDYAM-UP-23-0036110</div>
          </div>
          <div>
            <div style={{fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:"1px",color:"var(--muted)",marginBottom:10}}>Platform</div>
            {[["landing","How It Works"],["landing","For Sellers"],["landing","For Buyers"],["about","About Us"],["blogs","Blog"],["rto-calculator","RTO Calculator"]].map(([s,l])=>(
              <div key={l} style={{marginBottom:6}}>
                <span style={{fontSize:13,color:"var(--text)",cursor:"pointer",opacity:.8}} onClick={()=>{
                  if(l==="How It Works"){
                    onNav("landing");
                    setTimeout(()=>{
                      const el=document.getElementById("how-it-works");
                      if(el) el.scrollIntoView({behavior:"smooth"});
                    },400);
                  } else onNav(s);
                }}>{l}</span>
              </div>
            ))}
          </div>
          <div>
            <div style={{fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:"1px",color:"var(--muted)",marginBottom:10}}>Legal</div>
            {[["terms","Terms of Service"],["privacy","Privacy Policy"],["refund","Refund Policy"],["dispute","Dispute Resolution"]].map(([s,l])=>(
              <div key={l} style={{marginBottom:6}}><span style={{fontSize:13,color:"var(--text)",cursor:"pointer",opacity:.8}} onClick={()=>onNav(s)}>{l}</span></div>
            ))}
          </div>
          <div>
            <div style={{fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:"1px",color:"var(--muted)",marginBottom:10}}>Support</div>
            {[["contact","Contact Us"]].map(([s,l])=>(
              <div key={l} style={{marginBottom:6}}><span style={{fontSize:13,color:"var(--text)",cursor:"pointer",opacity:.8}} onClick={()=>onNav(s)}>{l}</span></div>
            ))}
            <div style={{marginTop:8}}>
              <a href="mailto:support@escarapay.in" style={{fontSize:13,color:"var(--gold)",textDecoration:"none"}}>support@escarapay.in</a>
            </div>
          </div>
        </div>
        <div style={{borderTop:"1px solid var(--border)",paddingTop:20,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
          <div style={{fontSize:11,color:"var(--muted)"}}>© 2026 EscaraPay (India). All rights reserved.</div>
          {/* Social Icons */}
          <div style={{display:"flex",gap:8}}>
            {[
              {href:"https://www.instagram.com/escarapay?igsh=MXZrNXA0bnZ0c3hkbQ==",label:"Instagram",svg:<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>},
              {href:"https://x.com/EscaraPay",label:"X",svg:<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>},
              {href:"https://www.linkedin.com/company/escara-pay/",label:"LinkedIn",svg:<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>},
              {href:"https://www.pinterest.com/escarapay/",label:"Pinterest",svg:<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>},
            ].map(({href,label,svg})=>(
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                style={{width:30,height:30,borderRadius:6,background:"var(--sf2)",border:"1px solid var(--border)",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--muted)",textDecoration:"none",transition:"all .2s"}}
                onMouseEnter={e=>{e.currentTarget.style.color="var(--gold)";e.currentTarget.style.borderColor="var(--gold)";}}
                onMouseLeave={e=>{e.currentTarget.style.color="var(--muted)";e.currentTarget.style.borderColor="var(--border)";}}>
                {svg}
              </a>
            ))}
          </div>
          <div style={{fontSize:11,color:"var(--muted)"}}>Built with ❤️ for India's social commerce sellers</div>
        </div>
      </div>
    </footer>
  );
}

function LegalNav({ active, onNav, dark, onToggle }) {
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); },[]);
  const links = [
    ["home","🏠 Home"],
    ["about","About"],
    ["terms","Terms"],
    ["privacy","Privacy"],
    ["refund","Refund"],
    ["dispute","Dispute"],
    ["contact","Contact"],
  ];
  return (
    <nav className="nav" style={{gap:0}}>
      <Logo onClick={()=>onNav("landing")} />
      <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"nowrap",overflow:"auto"}}>
        <div className="hide-m" style={{display:"flex",gap:2}}>
          {links.map(([s,l])=>(
            <button key={s} onClick={()=>onNav(s==="home"?"landing":s)}
              style={{background:active===s?"var(--gold)":"transparent",color:active===s?(dark?"#0a0a0f":"#fff"):"var(--muted)",
                border:"none",borderRadius:7,padding:"5px 10px",cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",transition:"all .2s"}}>
              {l}
            </button>
          ))}
        </div>
        <ThemeToggle dark={dark} onToggle={onToggle} />
      </div>
    </nav>
  );
}

/* ══════════ REFUND POLICY PAGE ══════════ */
function RefundPage({ onBack, dark, onToggle }) {
  const nav = (s) => { window._goToPage(s); };
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); updateMeta({
      title: "Refund Policy | EscaraPay — 100% Token Refund Guarantee",
      description: "EscaraPay's refund policy: buyers get 100% token refund if seller doesn't deliver. Understand when and how refunds are processed for WhatsApp and Instagram transactions.",
      url: "https://www.escarapay.in/refund",
      image: "https://www.escarapay.in/og-image.png"
    }); },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <LegalNav active="refund" onNav={nav} dark={dark} onToggle={onToggle} />
      <div style={{maxWidth:760,margin:"0 auto",padding:"40px 20px 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:12}}>↩️</div>
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(24px,4vw,36px)",marginBottom:8}}>Refund Policy</h1>
          <p style={{color:"var(--muted)",fontSize:13}}>EscaraPay (India) | Last updated: March 2026</p>
        </div>

        <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.3)",borderRadius:14,padding:20,marginBottom:24}}>
          <div style={{fontWeight:700,fontSize:15,color:"var(--green)",marginBottom:8}}>✅ Our Refund Promise</div>
          <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>EscaraPay is a payment protection platform. We hold your payment securely and release it only after delivery is confirmed. If delivery does not happen, your money comes back. Simple.</p>
        </div>

        {[
          {t:"1. When You Get a Refund",icon:"✅",color:"var(--green)",sections:[
            {head:"Non-Delivery by Seller",body:"If the seller does not dispatch your order within the agreed time, 100% of your token amount is refunded to your original payment method. Processing time: 5–7 business days."},
            {head:"Seller Cancellation",body:"If the seller cancels the order before dispatch, your full token is refunded. The 2% gateway fee is non-refundable as it is charged by Cashfree directly."},
            {head:"Successful Dispute Resolution (Buyer)",body:"If EscaraPay's dispute team determines the seller is at fault (e.g., item not received, wrong item, damaged goods), the token amount is refunded to you within 5–7 business days."},
          ]},
          {t:"2. When You Do NOT Get a Refund",icon:"❌",color:"var(--red)",sections:[
            {head:"Delivery Confirmed by Buyer",body:"Once you confirm delivery, the payment is permanently released to the seller. This action cannot be reversed."},
            {head:"Auto-Release After 7 Days",body:"If you do not raise a dispute within 48 hours of expected delivery, the token auto-releases to the seller after 7 days. No refund after auto-release."},
            {head:"Gateway Fee (2%)",body:"The 2% payment gateway fee charged by Cashfree is non-refundable in all cases, as it is collected by Cashfree, not by EscaraPay."},
            {head:"EscaraPay Commission (5%)",body:"EscaraPay's 5% service commission is non-refundable once a transaction is initiated, as it covers platform infrastructure and dispute resolution services."},
          ]},
          {t:"3. Refund Timeline",icon:"⏱️",color:"var(--blue)",sections:[
            {head:"Standard Refunds",body:"5–7 business days from approval date to original payment method (UPI/Card/NetBanking)."},
            {head:"Dispute-Based Refunds",body:"Up to 10 business days — includes 24-hour investigation period plus 5–7 days processing."},
            {head:"Bank Processing",body:"Once EscaraPay initiates the refund, your bank may take additional 2–3 business days to reflect in your account."},
          ]},
          {t:"4. How to Request a Refund",icon:"📋",color:"var(--accent)",sections:[
            {head:"Step 1 — Raise a Dispute",body:"Open your order in the EscaraPay app → Click 'Raise Dispute' → Provide reason and evidence."},
            {head:"Step 2 — Investigation",body:"Our team investigates within 24 business hours. We may contact both buyer and seller for clarification."},
            {head:"Step 3 — Resolution",body:"If resolved in your favor, refund is initiated within 2 business days. You'll receive a confirmation email."},
            {head:"Step 4 — Contact Support",body:"For any refund queries: support@escarapay.in | Response time: within 24 hours."},
          ]},
          {t:"5. EscaraPay's Role",icon:"🛡️",color:"var(--muted)",sections:[
            {head:"Facilitator Only",body:"EscaraPay is a payment protection facilitator. We do not manufacture, sell, or ship any products. We are responsible only for holding and releasing the protected token amount as per our policy."},
            {head:"Payments via Cashfree",body:"All payments are processed through Cashfree, an RBI-authorized payment aggregator. EscaraPay does not directly hold or process payment card data."},
          ]},
        ].map(section=>(
          <div key={section.t} className="card" style={{marginBottom:16}}>
            <h2 className="syne" style={{fontWeight:700,fontSize:16,marginBottom:14,color:section.color}}>{section.icon} {section.t}</h2>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {section.sections.map(s=>(
                <div key={s.head} style={{padding:"12px 14px",background:"var(--sf2)",borderRadius:10}}>
                  <div style={{fontWeight:600,fontSize:13,marginBottom:4}}>{s.head}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>{s.body}</div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="card" style={{background:"rgba(14,165,233,.06)",borderColor:"rgba(14,165,233,.3)",textAlign:"center",marginBottom:24}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:6}}>📧 Refund Queries</div>
          <div style={{fontSize:13,color:"var(--muted)"}}>Email: <strong>support@escarapay.in</strong> | Response within 24 hours</div>
          <div style={{fontSize:12,color:"var(--muted)",marginTop:4}}>EscaraPay (India) | Jurisdiction: Uttar Pradesh, India</div>
        </div>
        <div style={{textAlign:"center"}}><button className="btn-ghost" onClick={onBack}>← Back to Home</button></div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

/* ══════════ DISPUTE RESOLUTION PAGE ══════════ */
function DisputePage({ onBack, dark, onToggle }) {
  const nav = (s) => { window._goToPage(s); };
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); updateMeta({
      title: "Dispute Resolution | EscaraPay — Fair Decision in 24 Hours",
      description: "EscaraPay resolves buyer-seller disputes within 24 hours. Our expert mediators review evidence and deliver fair, binding decisions for WhatsApp and Instagram transactions.",
      url: "https://www.escarapay.in/dispute",
      image: "https://www.escarapay.in/og-image.png"
    }); },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <LegalNav active="dispute" onNav={nav} dark={dark} onToggle={onToggle} />
      <div style={{maxWidth:760,margin:"0 auto",padding:"40px 20px 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:12}}>⚖️</div>
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(24px,4vw,36px)",marginBottom:8}}>Dispute Resolution Policy</h1>
          <p style={{color:"var(--muted)",fontSize:13}}>EscaraPay (India) | Last updated: March 2026</p>
        </div>

        <div style={{background:"rgba(124,58,237,.08)",border:"1px solid rgba(124,58,237,.3)",borderRadius:14,padding:20,marginBottom:24}}>
          <div style={{fontWeight:700,fontSize:15,color:"#a78bfa",marginBottom:8}}>🛡️ Fair. Transparent. Final.</div>
          <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.8}}>EscaraPay is committed to fair dispute resolution. Our team reviews all evidence objectively and makes a binding decision within 24 business hours. Both buyer and seller are heard before any decision is made.</p>
        </div>

        {/* Timeline */}
        <div className="card" style={{marginBottom:16}}>
          <h2 className="syne" style={{fontWeight:700,fontSize:16,marginBottom:16}}>📋 Dispute Process Step by Step</h2>
          {[
            {n:"1",c:"var(--gold)",   t:"Raise Dispute",       d:"Open your order → Click 'Raise Dispute' → Select reason → Add evidence (photos, screenshots). Must be raised within 48 hours of expected delivery."},
            {n:"2",c:"var(--blue)",   t:"Notification",         d:"Both buyer and seller are notified immediately. The protected token is frozen — no one can access it during investigation."},
            {n:"3",c:"var(--accent)", t:"Evidence Collection",  d:"Both parties must submit evidence within 24 hours: photos of item received, tracking screenshots, chat screenshots, any proof of delivery or non-delivery."},
            {n:"4",c:"var(--red)",    t:"Investigation",        d:"EscaraPay's dispute team reviews all evidence. We may contact courier partners for tracking verification. Investigation completes within 24 business hours."},
            {n:"5",c:"var(--green)",  t:"Decision & Release",   d:"EscaraPay makes a final, binding decision. Token is released to the winning party within 2 business days. Both parties are notified via email."},
          ].map(s=>(
            <div key={s.n} className="step" style={{marginBottom:10}}>
              <div className="step-num" style={{background:`${s.c}20`,color:s.c,width:34,height:34,fontSize:15,flexShrink:0}}>{s.n}</div>
              <div><div style={{fontWeight:700,fontSize:14,marginBottom:3}}>{s.t}</div><div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>{s.d}</div></div>
            </div>
          ))}
        </div>

        {[
          {t:"1. Eligibility to Raise Dispute",icon:"⏰",color:"var(--gold)",c:"A dispute can only be raised within 48 hours of the expected delivery date. After 48 hours, the token automatically releases to the seller. Disputes raised after this window will not be considered. Emergency cases (e.g., seller fraud) may be escalated to legal@escarapay.in."},
          {t:"2. Valid Grounds for Dispute",icon:"📋",color:"var(--blue)",c:"Valid reasons include: Item not received despite tracking showing delivered, Wrong item received (different from description), Item received in damaged condition, Counterfeit or fake product received, Seller has not dispatched within agreed time. Invalid reasons: Change of mind, Item meets description but buyer doesn't like it, Buyer provided wrong delivery address."},
          {t:"3. Evidence Requirements",icon:"📸",color:"var(--accent)",c:"Buyers must provide: Photos/video of the item received (or proof of non-receipt), Screenshot of tracking showing non-delivery or wrong delivery, Original order confirmation from EscaraPay. Sellers must provide: Proof of dispatch (courier receipt, tracking ID), Photos of item packed and shipped, Any communication with buyer confirming order details."},
          {t:"4. EscaraPay's Decision — Final & Binding",icon:"⚖️",color:"var(--red)",c:"EscaraPay's dispute team makes the final decision based on evidence. This decision is binding on both parties and cannot be appealed within the platform. Possible outcomes: (a) Full refund to buyer, (b) Full token release to seller, (c) Partial resolution at EscaraPay's discretion. EscaraPay acts as a neutral facilitator — we are not liable for product quality, authenticity, or any loss beyond the protected token amount."},
          {t:"5. Escalation",icon:"📞",color:"var(--muted)",c:"If you believe the decision was unfair due to procedural error, you may escalate within 7 days by emailing legal@escarapay.in with: Your Order ID, Evidence not previously submitted, Reason for escalation. Escalated cases are reviewed by senior team within 7 business days. EscaraPay's escalation decision is final."},
          {t:"6. Anti-Abuse Policy",icon:"🚫",color:"var(--red)",c:"Repeated false disputes, submission of fake evidence, or attempts to manipulate the dispute process will result in: Immediate account suspension, Permanent ban from the platform, Reporting to relevant law enforcement under IPC Section 420 (Cheating) and IT Act 2000. EscaraPay reserves the right to charge a dispute processing fee of ₹99 for disputes found to be frivolous."},
          {t:"7. Governing Law",icon:"🇮🇳",color:"var(--green)",c:"All disputes and their resolution are subject to Indian law. In case of legal proceedings, jurisdiction lies exclusively with courts in Uttar Pradesh, India. Users agree to resolve disputes through EscaraPay's internal process before approaching courts."},
        ].map(s=>(
          <div key={s.t} className="card" style={{marginBottom:14}}>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:10,color:s.color}}>{s.icon} {s.t}</h3>
            <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.9}}>{s.c}</p>
          </div>
        ))}

        <div className="card" style={{background:"rgba(14,165,233,.06)",borderColor:"rgba(14,165,233,.3)",textAlign:"center",marginBottom:24}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:8}}>📞 Contact Dispute Team</div>
          <div style={{fontSize:13,color:"var(--muted)",marginBottom:4}}>General: <strong>support@escarapay.in</strong></div>
          <div style={{fontSize:13,color:"var(--muted)",marginBottom:4}}>Legal Escalation: <strong>legal@escarapay.in</strong></div>
          <div style={{fontSize:12,color:"var(--muted)",marginTop:8}}>EscaraPay (India) | Uttar Pradesh, India | Response: 24 hours</div>
        </div>
        <div style={{textAlign:"center"}}><button className="btn-ghost" onClick={onBack}>← Back to Home</button></div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

function PrivacyPage({ onBack, dark, onToggle }) {
  const nav = (s) => { window._goToPage(s); };
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); updateMeta({
      title: "Privacy Policy | EscaraPay — Your Data is Protected",
      description: "EscaraPay's privacy policy. We never sell your data. Learn how we collect, use and protect personal information of WhatsApp and Instagram sellers in India. MSME registered.",
      url: "https://www.escarapay.in/privacy",
      image: "https://www.escarapay.in/og-image.png"
    }); },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <LegalNav active="privacy" onNav={nav} dark={dark} onToggle={onToggle} />
      <div style={{maxWidth:760,margin:"0 auto",padding:"40px 20px 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:12}}>🔒</div>
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(24px,4vw,36px)",marginBottom:8}}>Privacy Policy</h1>
          <p style={{color:"var(--muted)",fontSize:13}}>EscaraPay (India) | Last updated: March 2026 | Effective immediately</p>
        </div>
        {[
          {t:"1. Information We Collect", c:"EscaraPay collects the following when you register or transact: Full name, email address, phone number (10 digits), PAN card or GST number (sellers only, for KYC), UPI ID (optional, for payouts), transaction history and order details, device information and IP address for security and fraud prevention."},
          {t:"2. How We Use Your Information", c:"Your data is used strictly to: process and manage protected payment transactions securely, verify identity to prevent fraud and unauthorized access, send transaction notifications, alerts, and OTPs, resolve disputes between buyers and sellers, comply with Indian financial regulations (IT Act 2000, PMLA 2002, RBI guidelines), improve platform performance and user experience."},
          {t:"3. Payment Data & Cashfree", c:"EscaraPay uses Cashfree as our payment gateway — an RBI-authorized and PCI-DSS Level 1 certified payment aggregator. EscaraPay does NOT store card numbers, CVV, or banking credentials. Token amounts are held in secure trust accounts. All transactions are encrypted using 256-bit SSL/TLS."},
          {t:"4. KYC & Seller Data", c:"Sellers must provide PAN Card or GST Number for KYC as required by Indian financial laws. This data is encrypted at rest (AES-256), accessible only by authorized compliance personnel, never shared for marketing, and retained for 7 years as per PMLA 2002 requirements."},
          {t:"5. Data Sharing", c:"We do NOT sell, rent, or trade your personal data. Data is shared only with: Cashfree (payment processing), law enforcement agencies when legally required by Indian courts or regulators, dispute resolution partners during fraud investigations. We notify you where legally permissible before sharing."},
          {t:"6. Data Security", c:"Our security measures include: SSL/TLS encryption in transit, AES-256 encryption at rest, strict role-based access controls, regular third-party security audits, industry-standard password hashing (bcrypt). However, no method of internet transmission is 100% secure."},
          {t:"7. Your Rights", c:"Under Indian data protection principles, you have the right to: access all personal data we hold about you, request correction of inaccurate information, request account deletion (subject to legal retention requirements), withdraw consent for non-essential data use, raise concerns at privacy@escarapay.in. We respond to all requests within 30 days."},
          {t:"8. Data Retention", c:"Transaction records are retained for 7 years as mandated by PMLA 2002. Account data is retained as long as your account is active. On deletion request, personal data is anonymized — anonymized statistical data may be retained for analytics."},
          {t:"9. Cookies", c:"EscaraPay uses only essential cookies for session management and security. We do not use tracking, advertising, or third-party analytics cookies."},
          {t:"10. Contact — Privacy Officer", c:"Email: privacy@escarapay.in | General Support: support@escarapay.in | EscaraPay (India), Uttar Pradesh, India"},
        ].map(s=>(
          <div key={s.t} className="card" style={{marginBottom:14}}>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:10,color:"var(--gold)"}}>{s.t}</h3>
            <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.9}}>{s.c}</p>
          </div>
        ))}
        <div style={{textAlign:"center",marginTop:24}}><button className="btn-ghost" onClick={onBack}>← Back to Home</button></div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

function TermsPage({ onBack, dark, onToggle }) {
  const nav = (s) => { window._goToPage(s); };
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); updateMeta({
      title: "Terms & Conditions | EscaraPay — WhatsApp Seller Payment Protection India",
      description: "EscaraPay's terms of service for WhatsApp and Instagram sellers in India. Token-based payment protection, RTO coverage, dispute resolution, and fee structure explained.",
      url: "https://www.escarapay.in/terms",
      image: "https://www.escarapay.in/og-image.png"
    }); },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <LegalNav active="terms" onNav={nav} dark={dark} onToggle={onToggle} />
      <div style={{maxWidth:760,margin:"0 auto",padding:"40px 20px 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:12}}>📋</div>
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(24px,4vw,36px)",marginBottom:8}}>Terms & Conditions</h1>
          <p style={{color:"var(--muted)",fontSize:13}}>EscaraPay (India) | Last updated: March 2026 | Effective immediately upon registration</p>
        </div>

        {[
          {t:"1. Acceptance of Terms", c:"By registering for or using EscaraPay, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our services. These terms apply to both buyers and sellers using the EscaraPay platform on any device or interface."},
          {t:"2. Eligibility", c:"To use EscaraPay you must: be at least 18 years of age, have a valid Indian bank account or UPI ID, provide accurate and truthful registration information including valid PAN/GST (for sellers), not be prohibited from using financial services under any Indian law or court order."},
          {t:"3. Fee Structure", c:"Minimum token amount: ₹200 per transaction. Gateway fee: 2% charged to the buyer (non-refundable in all cases). EscaraPay commission: 5% deducted from token amount. Seller receives: 95% of token amount upon successful delivery. All fees are clearly displayed before any transaction is confirmed."},
          {t:"4. Token Release Conditions", c:"Condition 1 — Order Delivered: Buyer confirms delivery → token held for 7 days → auto-released to seller. Condition 2 — Buyer Cancels Before Dispatch: Token goes to seller as shipping cover compensation. Condition 3 — Seller Fails to Ship: If seller does not dispatch within agreed time, full token is refunded to buyer. Gateway fee and EscaraPay commission are non-refundable in all scenarios."},
        ].map(s=>(
          <div key={s.t} className="card" style={{marginBottom:14}}>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:10,color:"var(--gold)"}}>{s.t}</h3>
            <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.9}}>{s.c}</p>
          </div>
        ))}

        {/* Dispute section highlighted */}
        <div className="card" style={{marginBottom:14,background:"rgba(239,68,68,.05)",borderColor:"rgba(239,68,68,.3)"}}>
          <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:12,color:"var(--red)"}}>5. Dispute Policy (In Detail)</h3>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {[
              {icon:"⏰",t:"Dispute Window",d:"Buyers must raise a dispute within 48 hours of expected delivery date. After 48 hours, token auto-releases to seller."},
              {icon:"📋",t:"How to Raise Dispute",d:"Open your order → Click 'Raise Dispute' → Select reason → Submit evidence if any. Seller will be notified immediately."},
              {icon:"🔍",t:"Investigation Process",d:"EscaraPay team investigates within 24 business hours. Both buyer and seller must provide evidence (photos, screenshots, tracking info). During investigation, token remains frozen."},
              {icon:"⚖️",t:"Resolution",d:"EscaraPay's decision is final and binding. If buyer is right → full token refunded to buyer. If seller is right → token released to seller. Partial resolutions may be made at EscaraPay's discretion."},
              {icon:"🚫",t:"Invalid Disputes",d:"Disputes raised after 48 hours, disputes without valid reason, or repeated false disputes may result in account suspension."},
              {icon:"📞",t:"Escalation",d:"If unsatisfied with resolution, email legal@escarapay.in with transaction ID. We escalate unresolved cases within 7 business days."},
            ].map(d=>(
              <div key={d.t} style={{display:"flex",gap:12,padding:10,background:"var(--sf2)",borderRadius:10}}>
                <span style={{fontSize:18,flexShrink:0}}>{d.icon}</span>
                <div><div style={{fontWeight:600,fontSize:13,marginBottom:3}}>{d.t}</div><div style={{fontSize:12,color:"var(--muted)",lineHeight:1.7}}>{d.d}</div></div>
              </div>
            ))}
          </div>
        </div>

        {[
          {t:"6. Prohibited Activities", c:"Users may not use EscaraPay for: sale of illegal, counterfeit, or prohibited goods, fraudulent transactions or identity theft, money laundering or financial fraud, creating multiple accounts to abuse the platform, harassment or threatening other users. Violations result in immediate account suspension, fund freeze, and may be reported to law enforcement under IT Act 2000 and IPC."},
          {t:"7. Seller Responsibilities", c:"Sellers must: accurately describe products and their condition, ship within the timeframe mentioned during order creation, provide valid tracking information after dispatch, respond to buyer queries within 24 hours, honor the deal terms agreed upon during order creation. Failure to meet these responsibilities may result in token refund to buyer and account suspension."},
          {t:"8. Buyer Responsibilities", c:"Buyers must: provide accurate delivery address and contact information, respond to delivery confirmation requests within 48 hours, raise disputes only for genuine reasons with evidence, not attempt chargebacks through their bank while EscaraPay dispute is active. False chargeback attempts will result in immediate account suspension."},
          {t:"9. Limitation of Liability", c:"EscaraPay's liability is strictly limited to the token amount held in safe pay protection for that specific transaction. We are not liable for: quality, safety, or legality of products exchanged, indirect or consequential damages, losses due to network failures or payment gateway downtime, disputes arising from incorrect information provided by either party."},
          {t:"10. Governing Law & Jurisdiction", c:"These Terms are governed by the laws of India. All disputes arising from use of EscaraPay are subject to the exclusive jurisdiction of courts in Uttar Pradesh, India. EscaraPay (India) is a facilitator only — not a party to any transaction between buyers and sellers. These terms comply with: Information Technology Act 2000, Payment and Settlement Systems Act 2007, Prevention of Money Laundering Act 2002, Consumer Protection Act 2019, and applicable RBI guidelines on payment aggregators."},
          {t:"11. Contact for Legal Matters", c:"Legal queries: legal@escarapay.in | Dispute escalation: disputes@escarapay.in | General support: support@escarapay.in"},
        ].map(s=>(
          <div key={s.t} className="card" style={{marginBottom:14}}>
            <h3 className="syne" style={{fontWeight:700,fontSize:15,marginBottom:10,color:"var(--gold)"}}>{s.t}</h3>
            <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.9}}>{s.c}</p>
          </div>
        ))}
        <div style={{textAlign:"center",marginTop:24}}><button className="btn-ghost" onClick={onBack}>← Back to Home</button></div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

function ContactPage({ onBack, dark, onToggle }) {
  const [form, setForm] = useState({name:"",email:"",subject:"",message:""});
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState("");
  const nav = (s) => { window._goToPage(s); };
  useEffect(()=>{ window.scrollTo({top:0,behavior:"instant"}); updateMeta({
      title: "Contact EscaraPay | 24-Hour Support for WhatsApp & Instagram Sellers",
      description: "Contact EscaraPay support team. We respond within 24 hours for payment issues, disputes, refund requests, and partnership queries. support@escarapay.in",
      url: "https://www.escarapay.in/contact",
      image: "https://www.escarapay.in/og-image.png"
    }); },[]);

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.subject || !form.message) {
      setSendError("Please fill in all fields."); return;
    }
    setSending(true); setSendError("");
    try {
      const res = await fetch(`${BACKEND_URL}/api/contact`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) setSent(true);
      else setSendError(data.error || "Failed to send. Please email us directly.");
    } catch(e) {
      setSendError("Could not connect. Please email us at support@escarapay.in");
    }
    setSending(false);
  };

  return (
    <div style={{minHeight:"100vh"}}>
      <LegalNav active="contact" onNav={nav} dark={dark} onToggle={onToggle} />
      <div style={{maxWidth:720,margin:"0 auto",padding:"40px 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:12}}>📞</div>
          <h1 className="syne" style={{fontWeight:800,fontSize:"clamp(24px,4vw,36px)",marginBottom:8}}>Contact Us</h1>
          <p style={{color:"var(--muted)",fontSize:14}}>EscaraPay (India) · We respond within 24 hours · Mon–Sat, 10AM–6PM IST</p>
        </div>

        <div style={{background:"rgba(5,150,105,.08)",border:"1px solid rgba(5,150,105,.3)",borderRadius:12,padding:14,marginBottom:24,textAlign:"center"}}>
          <span style={{fontSize:13,fontWeight:600,color:"var(--green)"}}>⚡ Average response time: under 4 hours during business hours</span>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:14,marginBottom:32}}>
          {[
            {icon:"📧",title:"General Support",value:"support@escarapay.in",sub:"Orders, accounts, general queries"},
            {icon:"⚖️",title:"Legal & Disputes",value:"legal@escarapay.in",sub:"Dispute escalation, legal matters"},
            {icon:"🔒",title:"Privacy Officer",value:"privacy@escarapay.in",sub:"Data requests, privacy concerns"},
          ].map(c=>(
            <div key={c.title} className="card" style={{textAlign:"center"}}>
              <div style={{fontSize:28,marginBottom:10}}>{c.icon}</div>
              <div className="syne" style={{fontWeight:700,fontSize:13,marginBottom:4}}>{c.title}</div>
              <a href={`mailto:${c.value}`} style={{fontSize:12,color:"var(--gold)",wordBreak:"break-all",marginBottom:4,display:"block",textDecoration:"none"}}>{c.value}</a>
              <div style={{fontSize:11,color:"var(--muted)"}}>{c.sub}</div>
            </div>
          ))}
        </div>

        {!sent ? (
          <div className="card">
            <h3 className="syne" style={{fontWeight:700,fontSize:18,marginBottom:4}}>Send Us a Message</h3>
            <p style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>We'll get back to you within 24 hours.</p>
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div className="g2">
                <div><label className="label">Your Name *</label><input className="input" placeholder="Rahul Sharma" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
                <div><label className="label">Email Address *</label><input className="input" type="email" placeholder="you@email.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} /></div>
              </div>
              <div><label className="label">Subject *</label>
                <select className="select" value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})}>
                  <option value="">-- Select a topic --</option>
                  <option>Payment Issue</option>
                  <option>Dispute Help</option>
                  <option>Refund Request</option>
                  <option>Account Problem</option>
                  <option>Technical Bug</option>
                  <option>Partnership</option>
                  <option>Other</option>
                </select>
              </div>
              <div><label className="label">Message *</label>
                <textarea className="input" placeholder="Describe your issue or question in detail..." rows={5} value={form.message} onChange={e=>setForm({...form,message:e.target.value})} style={{resize:"vertical"}} />
              </div>
              {sendError && <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:10,fontSize:13,color:"var(--red)"}}>❌ {sendError}</div>}
              <button className="btn-gold" style={{width:"100%",padding:12}} onClick={handleSubmit} disabled={sending}>
                {sending ? "⏳ Sending..." : "📨 Send Message"}
              </button>
            </div>
          </div>
        ) : (
          <div className="card" style={{textAlign:"center",padding:50}}>
            <div style={{fontSize:52,marginBottom:16}}>✅</div>
            <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:8}}>Message Sent!</div>
            <div style={{color:"var(--muted)",fontSize:14,marginBottom:8}}>Thank you, <strong>{form.name}</strong>. We have received your message.</div>
            <div style={{color:"var(--muted)",fontSize:13,marginBottom:24}}>We'll respond to <strong style={{color:"var(--gold)"}}>{form.email}</strong> within 24 hours.<br/>
              Reference: <strong style={{color:"var(--gold)"}}>ESC-{Date.now().toString().slice(-6)}</strong>
            </div>
            <button className="btn-ghost" onClick={()=>{setSent(false);setForm({name:"",email:"",subject:"",message:""});}}>← Send Another</button>
          </div>
        )}
        <div style={{textAlign:"center",marginTop:24}}><button className="btn-ghost" onClick={onBack}>← Back to Home</button></div>
      </div>
      <LegalFooter onNav={s=>window._goToPage(s)} />
    </div>
  );
}

/* ══════════ BLOG LIST PAGE ══════════ */
function BlogListPage({ dark, onToggle, onGoHome, onReadPost }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    window.scrollTo({top:0,behavior:"instant"});
    updateMeta({
      title: "EscaraPay Blog | WhatsApp Seller Tips, RTO Protection & Payment Guides India",
      description: "Free guides for Indian WhatsApp & Instagram sellers: stop RTO losses, prevent payment fraud, safe selling tips, and payment protection strategies for social commerce.",
      url: "https://www.escarapay.in/blogs",
      image: "https://www.escarapay.in/og-image.png"
    });
    fetchRegistry().then(data=>{ setPosts(data); setLoading(false); });
  },[]);
  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onGoHome}/><div style={{display:"flex",gap:8}}><ThemeToggle dark={dark} onToggle={onToggle}/><button className="btn-ghost" onClick={onGoHome}>← Home</button></div></nav>
      <div style={{maxWidth:900,margin:"0 auto",padding:"48px 20px 20px"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <span style={{background:"rgba(14,165,233,.1)",border:"1px solid rgba(14,165,233,.25)",borderRadius:100,padding:"4px 16px",fontSize:11,fontWeight:700,color:"var(--gold)",letterSpacing:1,textTransform:"uppercase"}}>BLOG</span>
          <h1 className="syne" style={{fontWeight:900,fontSize:"clamp(26px,5vw,40px)",marginTop:12,marginBottom:10}}>Payment Protection Insights</h1>
          <p style={{color:"var(--muted)",fontSize:15,maxWidth:500,margin:"0 auto"}}>Tips, guides and industry insights for India's WhatsApp & Instagram sellers.</p>
        </div>
        {loading ? (
          <div style={{textAlign:"center",padding:60}}>
            <div style={{width:40,height:40,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}}/>
            <div style={{color:"var(--muted)"}}>Loading posts...</div>
          </div>
        ) : (
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:24}}>
            {posts.map(post=>(
              <div key={post.slug} style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:18,overflow:"hidden",cursor:"pointer",transition:"transform .2s,box-shadow .2s"}}
                onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 12px 40px rgba(0,0,0,.15)";}}
                onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="";}}
                onClick={()=>onReadPost(post.slug)}>
                <img src={post.coverImage} alt={post.title} style={{width:"100%",height:190,objectFit:"cover"}} loading="lazy"/>
                <div style={{padding:"18px 20px 22px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                    <span style={{background:post.categoryColor+"22",color:post.categoryColor,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:20}}>{post.category}</span>
                    <span style={{fontSize:11,color:"var(--muted)"}}>{post.readTime}</span>
                  </div>
                  <h2 className="syne" style={{fontWeight:800,fontSize:16,lineHeight:1.35,marginBottom:8}}>{post.title}</h2>
                  <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.6,marginBottom:14}}>{post.excerpt}</p>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:11,color:"var(--muted)"}}>{post.date}</span>
                    <span style={{fontSize:13,color:"var(--gold)",fontWeight:600}}>Read →</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <LegalFooter onNav={s=>{ if(s==="landing") onGoHome(); else window._goToPage(s); }}/>
    </div>
  );
}

/* ══════════ BLOG POST PAGE ══════════ */
function BlogPostPage({ slug, dark, onToggle, onGoHome, onBlogList }) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    window.scrollTo({top:0,behavior:"instant"});
    setLoading(true);
    fetchBlogPost(slug).then(data=>{
      setPost(data);
      setLoading(false);
      if(data) updateMeta({
        title:`${data.title} | EscaraPay Blog`,
        description: data.metaDescription || data.excerpt || "Read the latest payment protection tips for WhatsApp and Instagram sellers in India on EscaraPay Blog.",
        url:`https://www.escarapay.in/blogs/${data.slug}`,
        image: data.coverImage || "https://www.escarapay.in/og-image.png"
      });
    });
  },[slug]);
  if(loading) return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onGoHome}/><ThemeToggle dark={dark} onToggle={onToggle}/></nav>
      <div style={{textAlign:"center",padding:80}}>
        <div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}}/>
        <div style={{color:"var(--muted)"}}>Loading post...</div>
      </div>
    </div>
  );
  if(!post) return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onGoHome}/><ThemeToggle dark={dark} onToggle={onToggle}/></nav>
      <div style={{textAlign:"center",padding:80}}><div style={{fontSize:52}}>📭</div><h2 className="syne" style={{marginTop:16}}>Blog post not found</h2><button className="btn-ghost" style={{marginTop:16}} onClick={onBlogList}>← Back to Blog</button></div>
    </div>
  );
  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav"><Logo onClick={onGoHome}/><div style={{display:"flex",gap:8}}><ThemeToggle dark={dark} onToggle={onToggle}/><button className="btn-ghost" onClick={onBlogList}>← Blog</button></div></nav>
      <div style={{width:"100%",maxHeight:420,overflow:"hidden",position:"relative"}}>
        <img src={post.coverImage} alt={post.title} style={{width:"100%",height:420,objectFit:"cover"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to bottom,transparent 40%,rgba(0,0,0,.75))"}}/>
        <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"24px clamp(16px,5vw,48px)"}}>
          <span style={{background:post.categoryColor,color:"#fff",fontSize:11,fontWeight:700,padding:"4px 12px",borderRadius:20,marginBottom:12,display:"inline-block"}}>{post.category}</span>
          <h1 className="syne" style={{fontWeight:900,fontSize:"clamp(18px,4vw,34px)",color:"#fff",lineHeight:1.25,marginBottom:10}}>{post.title}</h1>
          <div style={{display:"flex",gap:16,color:"rgba(255,255,255,.75)",fontSize:13}}><span>📅 {post.date}</span><span>⏱ {post.readTime}</span></div>
        </div>
      </div>
      <div style={{maxWidth:720,margin:"0 auto",padding:"40px 20px 20px"}}>
        {post.content.map((block,i)=>{
          if(block.type==="intro") return <p key={i} style={{fontSize:17,lineHeight:1.85,marginBottom:28,fontWeight:500,borderLeft:"3px solid var(--gold)",paddingLeft:16}}>{block.text}</p>;
          if(block.type==="text") return <p key={i} style={{fontSize:15,lineHeight:1.85,marginBottom:24}}>{block.text}</p>;
          if(block.type==="heading") return <h2 key={i} className="syne" style={{fontWeight:800,fontSize:22,marginTop:36,marginBottom:14}}>{block.text}</h2>;
          if(block.type==="image") return (
            <div key={i} style={{marginBottom:28,borderRadius:14,overflow:"hidden",border:"1px solid var(--border)",background:"var(--sf2)"}}>
              <div style={{display:"flex",justifyContent:"center",padding: block.src&&block.src.includes('/blog-images/')?"16px":"0"}}>
                <img src={block.src} alt={block.caption}
                  style={{
                    maxWidth:"100%",
                    width: block.src&&block.src.includes('/blog-images/')?"auto":"100%",
                    maxHeight: block.src&&block.src.includes('/blog-images/')?"520px":"320px",
                    height:"auto",
                    objectFit:"contain",
                    borderRadius: block.src&&block.src.includes('/blog-images/')?"10px":"0",
                    display:"block",
                  }}
                  loading="lazy"
                />
              </div>
              {block.caption&&<div style={{padding:"10px 16px",fontSize:12,color:"var(--muted)",textAlign:"center",borderTop:"1px solid var(--border)"}}>{block.caption}</div>}
            </div>
          );
          if(block.type==="list") return (
            <div key={i} style={{marginBottom:28,display:"flex",flexDirection:"column",gap:10}}>
              {block.items.map((item,j)=>(
                <div key={j} style={{background:"var(--sf2)",borderRadius:12,padding:"14px 18px",borderLeft:"3px solid var(--gold)"}}>
                  <div style={{fontWeight:700,fontSize:14,marginBottom:3}}>{item.title}</div>
                  <div style={{fontSize:13,color:"var(--muted)",lineHeight:1.6}}>{item.desc}</div>
                </div>
              ))}
            </div>
          );
          if(block.type==="callout") return <div key={i} style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.25)",borderRadius:14,padding:"16px 20px",marginBottom:28,fontSize:15,lineHeight:1.7,fontWeight:500}}>{block.text}</div>;
          if(block.type==="checklist") return (
            <div key={i} style={{marginBottom:28,display:"flex",flexDirection:"column",gap:10}}>
              {block.items.map((item,j)=>(
                <div key={j} style={{display:"flex",gap:12,alignItems:"flex-start",fontSize:14,lineHeight:1.6}}>
                  <span style={{color:"var(--green)",fontSize:16,flexShrink:0,marginTop:1}}>✅</span><span>{item}</span>
                </div>
              ))}
            </div>
          );
          return null;
        })}
        <div style={{background:"linear-gradient(135deg,rgba(14,165,233,.1),rgba(99,102,241,.1))",border:"1px solid rgba(14,165,233,.2)",borderRadius:18,padding:"28px 24px",textAlign:"center",marginTop:40,marginBottom:20}}>
          <div style={{fontSize:32,marginBottom:10}}>🛡️</div>
          <h3 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>Start Selling Safely Today</h3>
          <p style={{color:"var(--muted)",fontSize:14,marginBottom:20}}>Join thousands of Indian sellers who trust EscaraPay for secure payments.</p>
          <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
            <button className="btn-gold" style={{padding:"11px 24px"}} onClick={onGoHome}>Create Free Account →</button>
            <button className="btn-ghost" onClick={onBlogList}>← More Articles</button>
          </div>
        </div>
      </div>
      <LegalFooter onNav={s=>{ if(s==="landing") onGoHome(); else window._goToPage(s); }}/>
    </div>
  );
}

/* ══════════ RTO CALCULATOR FULL PAGE ══════════ */
function RTOCalculatorPage({ dark, onToggle, onGoHome }) {
  const [orders, setOrders]     = useState(100);
  const [avgValue, setAvgValue] = useState(1200);
  const [rtoRate, setRtoRate]   = useState(28);
  const [tokenPct, setTokenPct] = useState(20);
  const [category, setCategory] = useState("clothing");

  useEffect(()=>{
    window.scrollTo({top:0,behavior:"instant"});
    updateMeta({
      title:"RTO Loss Calculator for WhatsApp & Instagram Sellers | EscaraPay",
      description:"Calculate exactly how much money you lose to RTO returns every month. See how EscaraPay's token system protects your revenue.",
      url:"https://www.escarapay.in/rto-calculator"
    });
  },[]);

  const categoryData = {
    clothing:    { rto:28, icon:"👗", label:"Clothing & Apparel" },
    electronics: { rto:18, icon:"📱", label:"Electronics" },
    footwear:    { rto:32, icon:"👟", label:"Footwear" },
    accessories: { rto:22, icon:"💍", label:"Accessories" },
    beauty:      { rto:15, icon:"💄", label:"Beauty & Personal Care" },
    furniture:   { rto:12, icon:"🪑", label:"Furniture & Home" },
    toys:        { rto:20, icon:"🧸", label:"Toys & Games" },
    other:       { rto:25, icon:"📦", label:"Other" },
  };

  const handleCategory = (c) => { setCategory(c); setRtoRate(categoryData[c].rto); };

  // Core calculations
  const rtoOrders      = Math.round(orders * rtoRate / 100);
  const normalOrders   = orders - rtoOrders;
  const shippingOut    = 80;
  const shippingReturn = 65;
  const handling       = 35;
  const productDamage  = Math.round(avgValue * 0.05); // 5% damage on return
  const lossPerRTO     = shippingOut + shippingReturn + handling + productDamage;
  const monthlyLoss    = rtoOrders * lossPerRTO;
  const yearlyLoss     = monthlyLoss * 12;
  const monthlyRevenue = normalOrders * avgValue;

  // EscaraPay savings
  const tokenAmount    = Math.round(avgValue * tokenPct / 100);
  const escaraFee      = Math.round(tokenAmount * 0.065); // 5% commission + 1.5% gateway
  const netToken       = tokenAmount - escaraFee;
  const tokenCollected = rtoOrders * netToken;
  const netSaving      = Math.max(0, tokenCollected - (rtoOrders * shippingOut));
  const yearlySaving   = netSaving * 12;
  const roi            = monthlyLoss > 0 ? Math.round((netSaving/monthlyLoss)*100) : 0;
  const breakEven      = netToken > 0 ? Math.ceil(lossPerRTO / netToken) : 0;

  const fmt  = (n) => n>=100000?`₹${(n/100000).toFixed(1)}L`:n>=1000?`₹${(n/1000).toFixed(1)}K`:`₹${Math.round(n)}`;
  const pct  = (n) => `${n}%`;

  // Industry benchmarks
  const benchmarks = [
    { label:"Average Indian eCommerce RTO", value:"30-40%", color:"#ef4444" },
    { label:"Social Commerce RTO (no protection)", value:"25-35%", color:"#f97316" },
    { label:"Social Commerce RTO (with token)", value:"5-12%", color:"#10b981" },
    { label:"Shipping cost per RTO", value:"₹120-180", color:"#6366f1" },
    { label:"Product damage on return", value:"5-15%", color:"#f59e0b" },
  ];

  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav">
        <Logo onClick={onGoHome}/>
        <div style={{display:"flex",gap:8}}>
          <ThemeToggle dark={dark} onToggle={onToggle}/>
          <button className="btn-ghost" onClick={onGoHome}>← Home</button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{background:"linear-gradient(135deg,rgba(239,68,68,.08),rgba(14,165,233,.08))",borderBottom:"1px solid var(--border)",padding:"52px 20px 40px",textAlign:"center"}}>
        <span style={{background:"rgba(239,68,68,.12)",border:"1px solid rgba(239,68,68,.25)",borderRadius:100,padding:"4px 16px",fontSize:11,fontWeight:700,color:"#ef4444",letterSpacing:"1.5px",textTransform:"uppercase"}}>FREE TOOL</span>
        <h1 className="syne" style={{fontWeight:900,fontSize:"clamp(26px,5vw,44px)",marginTop:14,marginBottom:10}}>
          RTO Loss Calculator 🧮
        </h1>
        <p style={{color:"var(--muted)",fontSize:16,maxWidth:560,margin:"0 auto 20px"}}>
          Find out exactly how much money you lose to return-to-origin orders every month — and how much EscaraPay can save you.
        </p>
        <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
          {[["📦","Average RTO Rate","28-32%"],["💸","Loss per RTO","₹120-180"],["📅","Annual Loss","₹2L+ for 100 orders/month"]].map(([icon,label,val])=>(
            <div key={label} style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:12,padding:"12px 18px",minWidth:140}}>
              <div style={{fontSize:18,marginBottom:4}}>{icon}</div>
              <div style={{fontSize:11,color:"var(--muted)",marginBottom:2}}>{label}</div>
              <div style={{fontWeight:800,fontSize:15,color:"var(--gold)"}}>{val}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{maxWidth:960,margin:"0 auto",padding:"40px 20px"}}>

        {/* Category Selector */}
        <div style={{marginBottom:32}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:4}}>Step 1 — Select Your Category</h2>
          <p style={{color:"var(--muted)",fontSize:13,marginBottom:16}}>Each category has different average RTO rates based on industry data.</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:10}}>
            {Object.entries(categoryData).map(([key,val])=>(
              <button key={key} onClick={()=>handleCategory(key)}
                style={{padding:"14px 10px",borderRadius:12,border:`2px solid ${category===key?"var(--gold)":"var(--border)"}`,
                  background:category===key?"rgba(250,189,0,.1)":"var(--surface)",
                  color:category===key?"var(--gold)":"var(--muted)",
                  cursor:"pointer",transition:"all .2s",textAlign:"center"}}>
                <div style={{fontSize:22,marginBottom:6}}>{val.icon}</div>
                <div style={{fontSize:11,fontWeight:700}}>{val.label}</div>
                <div style={{fontSize:12,color:"#ef4444",fontWeight:700,marginTop:4}}>~{val.rto}% RTO</div>
              </button>
            ))}
          </div>
        </div>

        {/* Main Grid */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:24,marginBottom:32}}>

          {/* Sliders */}
          <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:20,padding:"24px 22px"}}>
            <h2 className="syne" style={{fontWeight:800,fontSize:18,marginBottom:20}}>Step 2 — Your Numbers</h2>

            {[
              {label:"Monthly Orders",value:orders,set:setOrders,min:10,max:1000,step:10,color:"var(--gold)",suffix:""},
              {label:"Avg Order Value (₹)",value:avgValue,set:setAvgValue,min:200,max:10000,step:100,color:"var(--gold)",suffix:"₹"},
              {label:"Current RTO Rate",value:rtoRate,set:setRtoRate,min:5,max:65,step:1,color:"#ef4444",suffix:"%"},
              {label:"EscaraPay Token %",value:tokenPct,set:setTokenPct,min:10,max:50,step:5,color:"#10b981",suffix:"%"},
            ].map(({label,value,set,min,max,step,color,suffix})=>(
              <div key={label} style={{marginBottom:20}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <label style={{fontSize:13,fontWeight:600,color:"var(--muted)"}}>{label}</label>
                  <span style={{fontSize:15,fontWeight:800,color}}>{suffix==="₹"?`₹${value.toLocaleString()}`:value+suffix}</span>
                </div>
                <input type="range" min={min} max={max} step={step} value={value}
                  onChange={e=>set(Number(e.target.value))}
                  style={{width:"100%",accentColor:color}}/>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--muted)",marginTop:3}}>
                  <span>{suffix==="₹"?`₹${min}`:min+suffix}</span>
                  <span>{suffix==="₹"?`₹${max.toLocaleString()}`:max+suffix}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Results */}
          <div style={{display:"flex",flexDirection:"column",gap:14}}>

            {/* Current Loss */}
            <div style={{background:"rgba(239,68,68,.06)",border:"1px solid rgba(239,68,68,.2)",borderRadius:16,padding:"20px"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#ef4444",textTransform:"uppercase",letterSpacing:"1px",marginBottom:14}}>😢 Your Current Loss</div>
              {[
                ["RTO Orders/month", `${rtoOrders} orders`,"#ef4444"],
                ["Loss per RTO order", `₹${lossPerRTO}`,"#ef4444"],
                ["Shipping (outward)", `₹${shippingOut}`,"var(--muted)"],
                ["Return shipping", `₹${shippingReturn}`,"var(--muted)"],
                ["Handling charges", `₹${handling}`,"var(--muted)"],
                ["Product damage (~5%)", `₹${productDamage}`,"var(--muted)"],
              ].map(([l,v,c])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:8,paddingBottom:8,borderBottom:"1px solid rgba(239,68,68,.1)"}}>
                  <span style={{color:"var(--muted)"}}>{l}</span>
                  <strong style={{color:c}}>{v}</strong>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
                <span style={{fontSize:14,color:"var(--muted)"}}>Monthly Loss</span>
                <strong style={{fontSize:22,color:"#ef4444",fontFamily:"'Syne',sans-serif"}}>{fmt(monthlyLoss)}</strong>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8}}>
                <span style={{fontSize:14,color:"var(--muted)"}}>Yearly Loss</span>
                <strong style={{fontSize:28,color:"#ef4444",fontFamily:"'Syne',sans-serif"}}>{fmt(yearlyLoss)}</strong>
              </div>
            </div>

            {/* With EscaraPay */}
            <div style={{background:"rgba(16,185,129,.06)",border:"1px solid rgba(16,185,129,.25)",borderRadius:16,padding:"20px"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#10b981",textTransform:"uppercase",letterSpacing:"1px",marginBottom:14}}>✅ With EscaraPay</div>
              {[
                ["Token per order", `₹${tokenAmount}`,"#10b981"],
                ["EscaraPay fee (~6.5%)", `-₹${escaraFee}`,"var(--muted)"],
                ["Net token (you keep)", `₹${netToken}`,"#10b981"],
                ["Tokens from RTO orders", fmt(tokenCollected),"#10b981"],
              ].map(([l,v,c])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:8,paddingBottom:8,borderBottom:"1px solid rgba(16,185,129,.1)"}}>
                  <span style={{color:"var(--muted)"}}>{l}</span>
                  <strong style={{color:c}}>{v}</strong>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
                <span style={{fontSize:14,color:"var(--muted)"}}>Monthly Saving</span>
                <strong style={{fontSize:22,color:"#10b981",fontFamily:"'Syne',sans-serif"}}>{fmt(netSaving)}</strong>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8}}>
                <span style={{fontSize:14,color:"var(--muted)"}}>Yearly Saving</span>
                <strong style={{fontSize:28,color:"#10b981",fontFamily:"'Syne',sans-serif"}}>{fmt(yearlySaving)}</strong>
              </div>
            </div>

          </div>
        </div>

        {/* ROI + Break Even */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16,marginBottom:32}}>
          {[
            {label:"ROI with EscaraPay",value:`${roi}%`,sub:"return on token investment",color:"var(--gold)",bg:"rgba(250,189,0,.08)"},
            {label:"Break-even Point",value:`${breakEven} RTO orders`,sub:"to recover monthly loss",color:"var(--gold)",bg:"rgba(250,189,0,.08)"},
            {label:"Revenue at Risk",value:fmt(monthlyLoss),sub:"every month without protection",color:"#ef4444",bg:"rgba(239,68,68,.06)"},
            {label:"Protected Revenue",value:fmt(monthlyRevenue),sub:"from successful deliveries",color:"#10b981",bg:"rgba(16,185,129,.06)"},
          ].map(({label,value,sub,color,bg})=>(
            <div key={label} style={{background:bg,border:`1px solid ${color}33`,borderRadius:16,padding:"20px",textAlign:"center"}}>
              <div style={{fontSize:11,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:"1px",marginBottom:8}}>{label}</div>
              <div className="syne" style={{fontWeight:900,fontSize:28,color,marginBottom:4}}>{value}</div>
              <div style={{fontSize:12,color:"var(--muted)"}}>{sub}</div>
            </div>
          ))}
        </div>

        {/* Industry Benchmarks */}
        <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:20,padding:"24px",marginBottom:32}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:4}}>📊 Industry Benchmarks</h2>
          <p style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>Based on Indian social commerce data 2024-25</p>
          <div style={{display:"flex",flexDirection:"column",gap:0}}>
            {benchmarks.map(({label,value,color},i)=>(
              <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 0",borderBottom:i<benchmarks.length-1?"1px solid var(--border)":"none"}}>
                <span style={{fontSize:14,color:"var(--text)"}}>{label}</span>
                <span style={{fontWeight:700,fontSize:15,color}}>{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:20,padding:"24px",marginBottom:32}}>
          <h2 className="syne" style={{fontWeight:800,fontSize:20,marginBottom:16}}>💡 Tips to Reduce RTO</h2>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:12}}>
            {[
              {icon:"🔐",tip:"Collect token upfront",desc:"Serious buyers only — reduces fake orders by 60-80%"},
              {icon:"📦",tip:"Add tracking",desc:"Buyers who can track are less likely to deny delivery"},
              {icon:"💬",tip:"Confirm before dispatch",desc:"Call/WhatsApp buyer to verify address before shipping"},
              {icon:"📸",tip:"Photo proof",desc:"Photograph packed item — reduces damage return fraud"},
              {icon:"⏰",tip:"Quick dispatch",desc:"Ship within 24hrs — reduces cancellations by 40%"},
              {icon:"🛡️",tip:"Use EscaraPay",desc:"Token system makes RTO financially painful for fraudsters"},
            ].map(({icon,tip,desc})=>(
              <div key={tip} style={{background:"var(--sf2)",borderRadius:12,padding:"14px 16px"}}>
                <div style={{fontSize:22,marginBottom:8}}>{icon}</div>
                <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>{tip}</div>
                <div style={{fontSize:12,color:"var(--muted)",lineHeight:1.6}}>{desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div style={{background:"linear-gradient(135deg,rgba(14,165,233,.1),rgba(99,102,241,.1))",border:"1px solid rgba(14,165,233,.2)",borderRadius:20,padding:"36px 28px",textAlign:"center"}}>
          <div style={{fontSize:40,marginBottom:12}}>🛡️</div>
          <h2 className="syne" style={{fontWeight:900,fontSize:"clamp(20px,4vw,30px)",marginBottom:10}}>
            Stop Losing {fmt(yearlyLoss)} Every Year
          </h2>
          <p style={{color:"var(--muted)",fontSize:15,marginBottom:24,maxWidth:480,margin:"0 auto 24px"}}>
            Start using EscaraPay's token system today. Free to set up, takes 2 minutes per order.
          </p>
          <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
            <button className="btn-gold" style={{padding:"13px 32px",fontSize:15,borderRadius:12}}
              onClick={onGoHome}>
              Start Free — Create Account →
            </button>
            <button className="btn-ghost" style={{padding:"13px 24px"}}
              onClick={()=>{window.history.pushState({},"","/blogs");window._goToPage("blogs");}}>
              Read Our Guides
            </button>
          </div>
        </div>

      </div>
      <LegalFooter onNav={s=>{ if(s==="landing") onGoHome(); else window._goToPage(s); }}/>
    </div>
  );
}

function ConfirmPage({ token, dark, onToggle, onGoHome }) {
  const [order, setOrder]         = useState(null);
  const [step, setStep]           = useState("loading"); // loading|confirm|issue|done|error|already_done|already_disputed
  const [issueText, setIssueText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg]             = useState("");

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/confirm/${token}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setOrder(d.order);
          if (d.order.status === "delivered")  setStep("already_done");
          else if (d.order.status === "disputed") setStep("already_disputed");
          else setStep("confirm");
        } else setStep("error");
      })
      .catch(() => setStep("error"));
  }, [token]);

  const handleReceived = async () => {
    setSubmitting(true);
    const r = await fetch(`${BACKEND_URL}/api/confirm/${token}/received`, { method:"POST", headers:{"Content-Type":"application/json"} });
    const d = await r.json();
    setSubmitting(false);
    if (d.success) { setStep("done"); setMsg("✅ Thank you! Token has been released to the seller."); }
    else setMsg("❌ " + d.error);
  };

  const handleIssue = async () => {
    if (!issueText.trim()) { setMsg("❌ Please describe the issue"); return; }
    setSubmitting(true);
    const r = await fetch(`${BACKEND_URL}/api/confirm/${token}/issue`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({ reason: issueText }),
    });
    const d = await r.json();
    setSubmitting(false);
    if (d.success) { setStep("done"); setMsg("⚠️ Issue reported. Our team will review within 24 hours."); }
    else setMsg("❌ " + d.error);
  };

  return (
    <div style={{minHeight:"100vh"}}>
      <nav className="nav">
        <Logo onClick={onGoHome} />
        <ThemeToggle dark={dark} onToggle={onToggle} />
      </nav>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"calc(100vh - 64px)",padding:20}}>
        <div style={{width:"100%",maxWidth:420}}>

          {step==="loading" && <div className="card" style={{textAlign:"center",padding:50}}><div style={{width:44,height:44,border:"3px solid var(--gold)",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .8s linear infinite",margin:"0 auto 16px"}}/><div style={{color:"var(--muted)"}}>Loading order details...</div></div>}

          {step==="error" && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:52,marginBottom:12}}>❌</div><div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>Invalid Link</div><div style={{color:"var(--muted)",fontSize:13,marginBottom:20}}>This confirmation link is invalid or has expired.</div><button className="btn-ghost" onClick={onGoHome}>← Go Home</button></div>}

          {step==="already_done" && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:52,marginBottom:12}}>✅</div><div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>Already Confirmed</div><div style={{color:"var(--muted)",fontSize:13}}>This delivery was already confirmed. Thank you!</div></div>}

          {step==="already_disputed" && <div className="card" style={{textAlign:"center",padding:40}}><div style={{fontSize:52,marginBottom:12}}>⚠️</div><div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:8}}>Dispute In Progress</div><div style={{color:"var(--muted)",fontSize:13}}>A dispute has been raised for this order. Our team is reviewing it.</div></div>}

          {step==="confirm" && order && (
            <div className="fu">
              <div style={{textAlign:"center",marginBottom:20}}>
                <div style={{fontSize:48,marginBottom:8}}>📦</div>
                <h2 className="syne" style={{fontWeight:800,fontSize:22}}>Did you receive your order?</h2>
                <p style={{color:"var(--muted)",fontSize:13,marginTop:6}}>No account needed — just tap the button below</p>
              </div>
              <div className="card" style={{marginBottom:16,background:"rgba(14,165,233,.05)",borderColor:"rgba(14,165,233,.25)"}}>
                <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>Order ID: <span style={{fontFamily:"monospace",color:"var(--gold)"}}>{order.id}</span></div>
                <div className="syne" style={{fontWeight:800,fontSize:20,marginBottom:4}}>{order.product_name}</div>
                <div style={{fontSize:13,color:"var(--muted)"}}>Seller: <strong style={{color:"var(--text)"}}>{order.seller_name||"—"}</strong></div>
                <div style={{fontSize:13,color:"var(--muted)",marginTop:2}}>Token Amount: <strong style={{color:"var(--gold)"}}>₹{order.token_amount}</strong></div>
                {order.tracking_number && <div style={{marginTop:8,background:"var(--sf2)",borderRadius:8,padding:"8px 10px",fontSize:12}}>📦 Tracking: <strong style={{fontFamily:"monospace"}}>{order.tracking_number}</strong></div>}
              </div>
              {msg && <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,marginBottom:12,color:msg.startsWith("✅")?"var(--green)":"var(--red)"}}>{msg}</div>}
              <button className="btn-green" style={{width:"100%",padding:14,fontSize:15,borderRadius:12,marginBottom:10}} onClick={handleReceived} disabled={submitting}>
                {submitting?"⏳ Processing...":"✅ Yes, I Received My Order"}
              </button>
              <button className="btn-ghost" style={{width:"100%",padding:12,color:"var(--red)",borderColor:"rgba(239,68,68,.3)"}} onClick={()=>setStep("issue")}>
                ❌ No — I Have an Issue
              </button>
              <div style={{textAlign:"center",marginTop:12,fontSize:11,color:"var(--muted)"}}>🔒 Secured by EscaraPay · Funds held safely until you confirm</div>
            </div>
          )}

          {step==="issue" && order && (
            <div className="fu">
              <div style={{textAlign:"center",marginBottom:20}}>
                <div style={{fontSize:48,marginBottom:8}}>⚠️</div>
                <h2 className="syne" style={{fontWeight:800,fontSize:20}}>Report an Issue</h2>
                <p style={{color:"var(--muted)",fontSize:13,marginTop:6}}>Our team will review within 24 hours</p>
              </div>
              <div className="card" style={{marginBottom:14}}>
                <div style={{fontSize:13,fontWeight:600,marginBottom:10}}>What is the issue?</div>
                {["Item not received","Wrong item received","Item received damaged","Item does not match description"].map(opt=>(
                  <div key={opt} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:"1px solid var(--border)",cursor:"pointer"}} onClick={()=>setIssueText(opt)}>
                    <div style={{width:16,height:16,borderRadius:"50%",border:`2px solid ${issueText===opt?"var(--gold)":"var(--border)"}`,background:issueText===opt?"var(--gold)":"transparent",flexShrink:0}}/>
                    <span style={{fontSize:13}}>{opt}</span>
                  </div>
                ))}
                <div style={{marginTop:10}}>
                  <label className="label">Additional details (optional)</label>
                  <textarea className="input" rows={3} placeholder="Describe the issue in detail..."
                    value={["Item not received","Wrong item received","Item received damaged","Item does not match description"].includes(issueText)?"":issueText}
                    onChange={e=>setIssueText(e.target.value)} style={{resize:"none"}}/>
                </div>
              </div>
              <div style={{background:"rgba(14,165,233,.08)",border:"1px solid rgba(14,165,233,.2)",borderRadius:10,padding:12,marginBottom:14,fontSize:12,color:"var(--muted)"}}>
                ℹ️ Your token of <strong style={{color:"var(--gold)"}}>₹{order?.token_amount}</strong> remains held until the dispute is resolved.
              </div>
              {msg && <div style={{padding:10,borderRadius:8,background:"var(--sf2)",fontSize:13,marginBottom:12,color:"var(--red)"}}>{msg}</div>}
              <button className="btn-red" style={{width:"100%",padding:12,marginBottom:8}} onClick={handleIssue} disabled={submitting||!issueText.trim()}>
                {submitting?"⏳ Submitting...":"⚠️ Submit Issue Report"}
              </button>
              <button className="btn-ghost" style={{width:"100%"}} onClick={()=>{setStep("confirm");setMsg("");}}>← Back</button>
            </div>
          )}

          {step==="done" && (
            <div className="card fu" style={{textAlign:"center",padding:40}}>
              <div style={{fontSize:60,marginBottom:16}}>{msg.startsWith("✅")?"🎉":"⚠️"}</div>
              <div className="syne" style={{fontWeight:800,fontSize:22,marginBottom:12}}>{msg.startsWith("✅")?"Thank You!":"Issue Reported"}</div>
              <div style={{color:"var(--muted)",fontSize:14,marginBottom:16}}>{msg}</div>
              <div style={{fontSize:12,color:"var(--muted)"}}>{msg.startsWith("✅")?"The seller will be notified and payment will be processed shortly.":"Our team will review all evidence within 24 hours and contact both parties via email."}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ══════════ MAIN APP ══════════ */
export default function App() {
  const [screen, setScreen] = useState("landing");
  const [userType, setUserType] = useState(null);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState(null);
  const [userPhone, setUserPhone] = useState("");
  const [sellerType, setSellerType] = useState(null);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [dark, setDark] = useState(()=> localStorage.getItem("escara_dark")==="true");
  const toggleDark = () => { const nd=!dark; setDark(nd); localStorage.setItem("escara_dark",nd); };
  const [lang, setLang] = useState(()=> localStorage.getItem("escara_lang")||"hl");
  const toggleLang = (l) => { setLang(l); localStorage.setItem("escara_lang",l); };
  const [payOrderId, setPayOrderId]     = useState(null);
  const [dealOrderId, setDealOrderId]   = useState(null);
  const [trackOrderId, setTrackOrderId] = useState(null);
  const [confirmToken, setConfirmToken] = useState(null);
  const [blogSlug, setBlogSlug] = useState(null);
  const [adminToken, setAdminToken] = useState(()=> localStorage.getItem("adminSessionToken") || "");

  useEffect(()=>{ window._goToPage=(s)=>{ const urls={about:"/about",privacy:"/privacy",terms:"/terms",refund:"/refund",dispute:"/dispute",contact:"/contact",landing:"/",track:"/track",admin:"/admin",blogs:"/blogs","blog-list":"/blogs","rto-calculator":"/rto-calculator"}; window.history.pushState({},"",urls[s]||"/"+s); setScreen(s==="blogs"?"blog-list":s); }; window._goToTrack=(orderId)=>{ setTrackOrderId(orderId); setScreen("track"); window.history.pushState({},"","/track/"+orderId); }; },[]);
  useEffect(()=>{
    document.title = "Escara Pay | India's Trusted Payment Protection Platform";
  },[]);
  useEffect(()=>{
    const path=window.location.pathname;
    const pm=path.match(/^\/pay\/([A-Z0-9]+)$/);      if(pm){setPayOrderId(pm[1]);setScreen("pay");return;}
    const dm=path.match(/^\/deal\/([A-Z0-9]+)$/);     if(dm){setDealOrderId(dm[1]);setScreen("deal");return;}
    const tm=path.match(/^\/track\/([A-Z0-9-]+)$/i);  if(tm){setTrackOrderId(tm[1].toUpperCase());setScreen("track");return;}
    const cm=path.match(/^\/confirm\/([a-f0-9]{48})$/i); if(cm){setConfirmToken(cm[1]);setScreen("confirm");return;}
    const bm=path.match(/^\/blogs\/([a-z0-9-]+)$/); if(bm){setBlogSlug(bm[1]);setScreen("blog-post");return;}
    if(path==="/blogs"){setScreen("blog-list");return;}
    if(path==="/rto-calculator"){setScreen("rto-calculator");return;}
    if(path==="/admin"){setScreen("admin-login");return;}
    if(path==="/about"){setScreen("about");return;}
    if(path==="/privacy"){setScreen("privacy");return;}
    if(path==="/terms"){setScreen("terms");return;}
    if(path==="/refund"){setScreen("refund");return;}
    if(path==="/dispute"){setScreen("dispute");return;}
    if(path==="/contact"){setScreen("contact");return;}
    if(path==="/login"){setScreen("auth");return;}
  },[]);

  const props = { dark, onToggle:toggleDark, lang, onLangToggle:toggleLang };
  const handleLogin=(t,n,id,phone,st,wu)=>{setUserType(t);setUserName(n);setUserId(id);setUserPhone(phone||"");setSellerType(st||null);setWebsiteUrl(wu||"");setScreen("dashboard");};
  const handleLogout=()=>{clearToken();setScreen("landing");setUserType(null);setUserId(null);setUserPhone("");setUserName("");setSellerType(null);setWebsiteUrl("");};
  const goHome=()=>{window.history.pushState({},"","/");setScreen("landing");setPayOrderId(null);setDealOrderId(null);setTrackOrderId(null);setConfirmToken(null);setBlogSlug(null);};
  const goToScreen=(s,url)=>{window.history.pushState({},"",(url||"/"));setScreen(s);};

  return (
    <>
      <style>{getStyle(dark)}</style>
      {screen==="pay"         && payOrderId   && <PayPage     orderId={payOrderId}   dark={dark} onToggle={toggleDark} onGoHome={goHome} />}
      {screen==="deal"        && dealOrderId  && <DealPage    orderId={dealOrderId}  dark={dark} onToggle={toggleDark} onGoHome={goHome} />}
      {screen==="track"                       && <TrackPage   orderId={trackOrderId} dark={dark} onToggle={toggleDark} onGoHome={goHome} />}
      {screen==="confirm"     && confirmToken && <ConfirmPage token={confirmToken}   dark={dark} onToggle={toggleDark} onGoHome={goHome} />}
      {screen==="rto-calculator" && <RTOCalculatorPage dark={dark} onToggle={toggleDark} onGoHome={goHome} />}
      {screen==="blog-list"   && <BlogListPage dark={dark} onToggle={toggleDark} onGoHome={goHome} onReadPost={(slug)=>{ window.history.pushState({},"",`/blogs/${slug}`); setBlogSlug(slug); setScreen("blog-post"); }} />}
      {screen==="blog-post"   && blogSlug && <BlogPostPage slug={blogSlug} dark={dark} onToggle={toggleDark} onGoHome={goHome} onBlogList={()=>{ window.history.pushState({},"","/blogs"); setScreen("blog-list"); }} />}
      {screen==="admin-login" && <AdminLogin  onLogin={(token)=>{setAdminToken(token);setScreen("admin");}} dark={dark} onToggle={toggleDark} />}
      {screen==="admin"       && <AdminPanel  adminToken={adminToken} onLogout={async()=>{
        // ✅ Call server logout to blacklist token before clearing locally
        try {
          await fetch(`${ADMIN_URL}/api/admin/logout`,{
            method:"POST",
            headers:{"Authorization":`Bearer ${adminToken}`}
          });
        } catch(e) {}
        localStorage.removeItem("adminSessionToken");
        localStorage.removeItem("adminKey"); // clean up old key if present
        setAdminToken("");
        setScreen("landing");
      }} dark={dark} onToggle={toggleDark} />}
      {screen==="about"       && <AboutPage   onBack={goHome} {...props} />}
      {screen==="privacy"     && <PrivacyPage onBack={goHome} {...props} />}
      {screen==="terms"       && <TermsPage   onBack={goHome} {...props} />}
      {screen==="refund"      && <RefundPage  onBack={goHome} {...props} />}
      {screen==="dispute"     && <DisputePage onBack={goHome} {...props} />}
      {screen==="contact"     && <ContactPage onBack={goHome} {...props} />}
      {screen==="landing"     && <Landing     onEnter={t=>{setUserType(t);goToScreen("auth","/login");}} onTrack={()=>{window.history.pushState({},"","/track");setScreen("track");setTrackOrderId(null);}} {...props} />}
      {screen==="auth"        && <Auth        type={userType} onLogin={handleLogin} onBack={goHome} {...props} />}
      {screen==="dashboard"   && userType==="seller" && <SellerDB user={userName||"Seller"} userId={userId} onLogout={handleLogout} sellerType={sellerType} websiteUrl={websiteUrl} {...props} />}
      {screen==="dashboard"   && userType==="buyer"  && <BuyerDB  user={userName||"Buyer"}  userId={userId} userPhone={userPhone} onLogout={handleLogout} {...props} />}
    </>
  );
}